import React, { Component } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import ls from 'local-storage';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { EditorState, RichUtils, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// removed unused: InputLabel, FormControl, Select
import Menu from '@material-ui/core/Menu';
import Popover from '@material-ui/core/Popover';
// removed unused: Avatar
// removed unused: FormControlLabel, Switch
import { Tabs, Tab } from '@mui/material';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AttachFileIcon from '@material-ui/icons/AttachFile';
// removed duplicate AttachFileIcon
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import htmlToDraft from 'html-to-draftjs';
import { ContentState } from 'draft-js'; // Ensure ContentState is imported
import { ThemeContext } from '../../../ThemeContext';
import swal from 'sweetalert';

class ProjectDetail extends Component {
    static contextType = ThemeContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            project: null,
            allUsers: [],
            isLoadingUsers: false,
            // project updates
            updates: [],
            isLoadingUpdates: false,
            updateComposer: { open: false, status: 'On track', text: '' },
            showComments: {},
            timelineShowComments: {},
            commentDrafts: {},
            showAllUpdates: false,
            showAllTimeline: false,
            isUpdatesModalOpen: false,
            timeline: [],
            // update comments edit state
            editCommentDrafts: {},
            editingCommentIds: {},
            // caret positions for overview edit inputs
            editCommentCarets: {}, // key: commentId -> number
            editingCommentRemovedFile: {},
            editingCommentFiles: {}, // key: commentId -> File
            editingCommentFilePreviews: {}, // key: commentId -> preview URL
            // threaded replies state
            showReplies: {}, // key: commentId -> bool
            replyDrafts: {}, // key: commentId -> text
            showMoreReplies: {}, // key: parentCommentId -> bool
            // popovers
            priorityAnchorEl: null,
            statusAnchorEl: null,
            leadAnchorEl: null,
            membersAnchorEl: null,
            startAnchorEl: null,
            targetAnchorEl: null,
            addMilestoneAnchorEl: null,
            // pending changes
            pendingChanges: {
                status: null,
                priority: null,
                lead_ids: [],
                member_ids: [],
                start_date: null,
                target_date: null
            },
            // new milestone draft
            newMilestone: {
                name: '',
                description: '',
                due_date: ''
            },
            newMilestoneEditorState: EditorState.createEmpty(),
            isAddMilestoneDialogOpen: false,
            editingMilestoneIndex: null, // Track which milestone is being edited,
            // ui state
            expandedMilestones: {},
            editingDescription: false,
            descriptionDraft: '',
            editorState: EditorState.createEmpty(),
            editMilestoneDateAnchorEl: null,
            editingMilestoneIndex: null,
            milestoneDateDraft: '',
            editingName: false,
            nameDraft: '',
            editingSummary: false,
            summaryDraft: '',
            currentTab: 0,
            // resources
            resources: [],
            isLoadingResources: false,
            isResourceDialogOpen: false,
            resourceDraft: { title: '', url: '' },
            isUploadingResource: false,
            // comment attachment upload state
            isUploadingCommentAttachment: false,
            commentFiles: {}, // key: updateId -> file
            replyFiles: {}, // key: parentCommentId -> file
            issueRootFile: null, // file for root issue comments
            issueReplyFiles: {}, // key: parentCommentId -> file
            // image preview URLs
            commentFilePreviews: {}, // key: updateId -> preview URL
            replyFilePreviews: {}, // key: parentCommentId -> preview URL
            issueRootFilePreview: null, // preview URL for root issue comments
            issueReplyFilePreviews: {}, // key: parentCommentId -> preview URL
            // dynamic heights for images inside overview comment input (per updateId)
            commentImageHeights: {},
            // emoji picker for overview comment
            showEmojiForUpdate: {},
            updateEmojiAnchorEls: {},
            // emoji picker for reply comments
            showEmojiForReply: {},
            replyEmojiAnchorEls: {},
            activeEmojiReplyParentId: null,
            activeEmojiUpdateId: null,
            // emoji picker for issue root comment
            showIssueEmojiRoot: false,
            issueEmojiRootAnchorEl: null,
            activeIssueEmojiRoot: false,
            // emoji picker for issue replies
            showIssueEmojiForReply: {},
            issueReplyEmojiAnchorEls: {},
            activeIssueEmojiReplyParentId: null,
            // emoji picker for issue edit
            issueShowEmojiForEdit: {},
            issueEditEmojiAnchorEls: {},
            activeIssueEditId: null,
            // resource preview
            isResourcePreviewOpen: false,
            previewResource: null,
            // issues ui
            isIssueDialogOpen: false,
            isIssueDetailOpen: false,
            activeIssue: null,
            editIssueDraft: null,
            issueActivity: [],
            issueShowAllActivities: false,
            issueShowAllComments: false,
            issueDetailActiveTab: 'activity',
            editingIssueTitle: false,
            editingIssueDescription: false,
            editingEditSubIssueTitles: {},
            editingEditSubIssueDescriptions: {},
            // create-issue sub-issue inline edit flags
            editingSubIssueTitles: {}, // key: index -> bool
            editingSubIssueDescriptions: {}, // key: tmpIndex -> bool
            issueCommentDraft: '',
            // issue comments threading/edit state
            issueEditCommentDrafts: {},
            issueEditingCommentIds: {},
            issueEditingCommentFiles: {}, // key: commentId -> File
            issueEditingCommentFilePreviews: {}, // key: commentId -> objectURL (image only)
            issueEditingCommentRemovedFile: {}, // key: commentId -> bool
            issueShowReplies: {}, // key: commentId -> bool
            issueReplyDrafts: {}, // key: commentId -> text
            issueShowMoreReplies: {}, // key: parentCommentId -> bool
            detailMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null },
            subDetailMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null, index: null },
            issueDraft: {
                title: '',
                description: '',
                milestoneIndex: '',
                priority: 'Medium',
                status: 'Backlog',
                assigneeId: '',
                subIssues: []
            },
            issueMenus: {
                statusAnchor: null,
                priorityAnchor: null,
                assigneeAnchor: null,
                milestoneAnchor: null
            },
            // sub-issue chip menus
            subIssueMenus: {
                statusAnchor: null,
                priorityAnchor: null,
                assigneeAnchor: null,
                milestoneAnchor: null,
                index: null
            },
            // issues grouping expand/collapse map
            issuesGroupExpanded: {},
            // editors for issue create/edit and subtasks
            issueEditorState: EditorState.createEmpty(),
            subIssueEditorStates: {}, // index -> EditorState
            editIssueEditorState: EditorState.createEmpty(),
            editSubIssueEditorStates: {} // index -> EditorState
        };
        this.load = this.load.bind(this);
        this.getUserName = this.getUserName.bind(this);
        this.fetchUsers = this.fetchUsers.bind(this);
        this.fetchProjectUpdates = this.fetchProjectUpdates.bind(this);
        this.fetchProjectResources = this.fetchProjectResources.bind(this);
        this.fetchProjectTimeline = this.fetchProjectTimeline.bind(this);
        this.openUpdateComposer = this.openUpdateComposer.bind(this);
        this.closeUpdateComposer = this.closeUpdateComposer.bind(this);
        this.postProjectUpdate = this.postProjectUpdate.bind(this);
        this.toggleShowAllUpdates = this.toggleShowAllUpdates.bind(this);
        this.openUpdatesModal = this.openUpdatesModal.bind(this);
        this.closeUpdatesModal = this.closeUpdatesModal.bind(this);
        this.toggleComments = this.toggleComments.bind(this);
        this.toggleTimelineComments = this.toggleTimelineComments.bind(this);
        this.setCommentDraft = this.setCommentDraft.bind(this);
        this.postComment = this.postComment.bind(this);
        // timeline show all toggle
        this.toggleShowAllTimeline = this.toggleShowAllTimeline.bind(this);
        // update comments: reply/edit/delete
        this.replyToUpdateComment = this.replyToUpdateComment.bind(this);
        this.startEditUpdateComment = this.startEditUpdateComment.bind(this);
        this.cancelEditUpdateComment = this.cancelEditUpdateComment.bind(this);
        this.setEditUpdateCommentDraft = this.setEditUpdateCommentDraft.bind(this);
        this.saveEditUpdateComment = this.saveEditUpdateComment.bind(this);
        this.setEditCaretPosition = this.setEditCaretPosition.bind(this);
        this.deleteUpdateComment = this.deleteUpdateComment.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleCloseAll = this.handleCloseAll.bind(this);
        this.handlePendingChange = this.handlePendingChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleNewMilestoneChange = this.handleNewMilestoneChange.bind(this);
        this.saveNewMilestone = this.saveNewMilestone.bind(this);
        this.openAddMilestoneDialog = this.openAddMilestoneDialog.bind(this);
        this.closeAddMilestoneDialog = this.closeAddMilestoneDialog.bind(this);
        this.handleNewMilestoneEditorChange = this.handleNewMilestoneEditorChange.bind(this);
        this.toggleMilestone = this.toggleMilestone.bind(this);
        this.startEditDescription = this.startEditDescription.bind(this);
        this.cancelEditDescription = this.cancelEditDescription.bind(this);
        this.saveDescription = this.saveDescription.bind(this);
        this.openMilestoneDate = this.openMilestoneDate.bind(this);
        this.saveMilestoneDate = this.saveMilestoneDate.bind(this);
        this.startEditName = this.startEditName.bind(this);
        this.cancelEditName = this.cancelEditName.bind(this);
        this.saveName = this.saveName.bind(this);
        this.startEditSummary = this.startEditSummary.bind(this);
        this.cancelEditSummary = this.cancelEditSummary.bind(this);
        this.saveSummary = this.saveSummary.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.openIssueDialog = this.openIssueDialog.bind(this);
        // resources handlers
        this.openResourceDialog = this.openResourceDialog.bind(this);
        this.closeResourceDialog = this.closeResourceDialog.bind(this);
        this.handleResourceDraftChange = this.handleResourceDraftChange.bind(this);
        this.saveResource = this.saveResource.bind(this);
        this.deleteResource = this.deleteResource.bind(this);
        this.triggerFilePicker = this.triggerFilePicker.bind(this);
        this.onResourceFilePicked = this.onResourceFilePicked.bind(this);
        this.openResourcePreview = this.openResourcePreview.bind(this);
        this.closeResourcePreview = this.closeResourcePreview.bind(this);
        this.closeIssueDialog = this.closeIssueDialog.bind(this);
        this.handleIssueDraftChange = this.handleIssueDraftChange.bind(this);
        this.saveIssue = this.saveIssue.bind(this);
        this.openIssueMenu = this.openIssueMenu.bind(this);
        this.closeIssueMenus = this.closeIssueMenus.bind(this);
        this.fetchIssues = this.fetchIssues.bind(this);
        this.openIssueDetail = this.openIssueDetail.bind(this);
        this.closeIssueDetail = this.closeIssueDetail.bind(this);
        this.handleEditIssueChange = this.handleEditIssueChange.bind(this);
        this.saveIssueDetail = this.saveIssueDetail.bind(this);
        this.openDetailMenu = this.openDetailMenu.bind(this);
        this.closeDetailMenus = this.closeDetailMenus.bind(this);
        this.openSubDetailMenu = this.openSubDetailMenu.bind(this);
        this.closeSubDetailMenus = this.closeSubDetailMenus.bind(this);
        this.addEditSubIssue = this.addEditSubIssue.bind(this);
        this.removeEditSubIssue = this.removeEditSubIssue.bind(this);
        this.updateEditSubIssueField = this.updateEditSubIssueField.bind(this);
        // issue activity/comments
        this.fetchIssueActivity = this.fetchIssueActivity.bind(this);
        this.postIssueComment = this.postIssueComment.bind(this);
        // issue comments reply/edit/delete
        this.postIssueReply = this.postIssueReply.bind(this);
        this.replyToIssueComment = this.replyToIssueComment.bind(this);
        this.startEditIssueActivityComment = this.startEditIssueActivityComment.bind(this);
        this.cancelEditIssueActivityComment = this.cancelEditIssueActivityComment.bind(this);
        this.setIssueEditCommentDraft = this.setIssueEditCommentDraft.bind(this);
        this.saveIssueActivityComment = this.saveIssueActivityComment.bind(this);
        this.deleteIssueActivityComment = this.deleteIssueActivityComment.bind(this);
        // attachments into comment composers
        this.triggerAttachmentInput = this.triggerAttachmentInput.bind(this);
        this.onAttachToUpdateComment = this.onAttachToUpdateComment.bind(this);
        this.onAttachToIssueComment = this.onAttachToIssueComment.bind(this);
        // emoji picker positioning
        // emoji pickers use MUI Popover (no manual coords)
        // sub-issues handlers
        this.addSubIssue = this.addSubIssue.bind(this);
        this.removeSubIssue = this.removeSubIssue.bind(this);
        this.updateSubIssueTitle = this.updateSubIssueTitle.bind(this);
        this.updateSubIssueField = this.updateSubIssueField.bind(this);
        this.openSubIssueMenu = this.openSubIssueMenu.bind(this);
        this.closeSubIssueMenus = this.closeSubIssueMenus.bind(this);
        // issues groups toggle
        this.toggleIssuesGroup = this.toggleIssuesGroup.bind(this);
        this.renderGroupToggle = this.renderGroupToggle.bind(this);
        // editors
        this.handleIssueEditorChange = this.handleIssueEditorChange.bind(this);
        this.handleSubIssueEditorChange = this.handleSubIssueEditorChange.bind(this);
        this.handleEditIssueEditorChange = this.handleEditIssueEditorChange.bind(this);
        this.handleEditSubIssueEditorChange = this.handleEditSubIssueEditorChange.bind(this);
        // permission helpers
        this.isCurrentUserLead = this.isCurrentUserLead.bind(this);
        this.isCurrentUserMember = this.isCurrentUserMember.bind(this);
        this.canEditAllOverview = this.canEditAllOverview.bind(this);
        this.canEditLimitedOverview = this.canEditLimitedOverview.bind(this);
        this.getCurrentUserId = this.getCurrentUserId.bind(this);
        this.canEditUpdateComment = this.canEditUpdateComment.bind(this);
        this.canEditIssueComment = this.canEditIssueComment.bind(this);
        this.showNotAllowed = this.showNotAllowed.bind(this);
        this.setCommentDraftFile = this.setCommentDraftFile.bind(this);
        this.setReplyFile = this.setReplyFile.bind(this);
        this.setIssueRootFile = this.setIssueRootFile.bind(this);
        this.setIssueReplyFile = this.setIssueReplyFile.bind(this);
    }

    isDarkMode() {
        if (this.context && typeof this.context.darkMode !== 'undefined') {
            return this.context.darkMode;
        }
        return localStorage.getItem('theme') === 'dark';
    }

    componentDidMount() {
        this.load();
        this.fetchProjectUpdates();
        this.fetchProjectResources();
        // Handle deep-linking from notifications (open Issues tab / specific issue)
        this.processNavigationHints();
        // Ensure cleanup if component unmounts with picker open
        window.addEventListener('beforeunload', this.detachEmojiListeners);
    }

    handleTabChange(event, newValue) {
        this.setState({ currentTab: newValue }, async () => {
            if (newValue === 1) {
                const hasIssuesArray = Array.isArray((this.state.project || {}).issues);
                if (!hasIssuesArray) {
                    await this.fetchIssues();
                }
            }
        });
    }

    async processNavigationHints() {
        try {
            const state = (this.props.location && this.props.location.state) || {};
            const wantsIssuesTab = state && (state.tab === 'issues' || typeof state.openIssueId !== 'undefined');
            if (!wantsIssuesTab) return;
            // Ensure Issues tab selected
            if (this.state.currentTab !== 1) {
                this.setState({ currentTab: 1 });
            }
            const ensureIssuesLoaded = async () => {
                const hasIssuesArray = Array.isArray(((this.state.project || {}).issues));
                if (!hasIssuesArray) {
                    await this.fetchIssues();
                }
            };
            await ensureIssuesLoaded();
            const issueId = state.openIssueId;
            if (issueId == null) return;
            const issues = (this.state.project && Array.isArray(this.state.project.issues)) ? this.state.project.issues : [];
            const found = issues.find((it) => String(it.id || it._id) === String(issueId));
            if (found) {
                this.openIssueDetail(found);
                return;
            }
            // Try refetch once if not found
            await this.fetchIssues();
            const refreshed = (this.state.project && Array.isArray(this.state.project.issues)) ? this.state.project.issues : [];
            const again = refreshed.find((it) => String(it.id || it._id) === String(issueId));
            if (again) {
                this.openIssueDetail(again);
            }
        } catch (_) { }
    }

    openIssueDialog() {
        this.setState({ isIssueDialogOpen: true });
    }

    closeIssueDialog() {
        this.setState({ isIssueDialogOpen: false, issueDraft: { title: '', description: '', milestoneIndex: '', priority: 'Medium', status: 'Backlog', assigneeId: '', subIssues: [] } });
    }

    openIssueDetail(issue) {
        // Normalize current issue into editable draft
        const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];
        const milestoneId = issue?.milestone?.id || issue?.milestone?._id || issue?.milestone_id || null;
        const milestoneIndex = milestoneId != null ? String(Math.max(0, milestones.findIndex((m) => (m.id || m._id) === milestoneId))) : '';
        const draft = {
            id: issue?.id || issue?._id,
            title: issue?.title || '',
            description: issue?.description || '',
            status: issue?.status || 'Backlog',
            priority: issue?.priority || 'Medium',
            assigneeId: issue?.assignee_id || issue?.assigneeId || '',
            milestoneIndex: milestoneId != null && milestones.findIndex((m) => (m.id || m._id) === milestoneId) !== -1 ? milestoneIndex : '',
            subIssues: (Array.isArray(issue?.subtasks) ? issue.subtasks : (Array.isArray(issue?.sub_issues) ? issue.sub_issues : [])).map((s) => {
                const smId = s?.milestone_id || s?.milestone?.id || null;
                const smIndex = smId != null ? String(Math.max(0, milestones.findIndex((m) => (m.id || m._id) === smId))) : '';
                const parentIndex = milestoneIndex;
                const effectiveIndex = (smId != null && milestones.findIndex((m) => (m.id || m._id) === smId) !== -1)
                    ? smIndex
                    : (parentIndex !== '' && parentIndex != null ? parentIndex : '');
                return {
                    id: s?.id || s?._id || undefined,
                    title: s?.title || s?.name || '',
                    description: s?.description || '',
                    status: s?.status || 'Backlog',
                    priority: s?.priority || 'Medium',
                    assigneeId: s?.assignee_id || '',
                    milestoneIndex: effectiveIndex
                };
            })
        };
        // Initialize edit editor states from existing content (try parse JSON)
        let editIssueState = EditorState.createEmpty();
        try {
            const parsed = JSON.parse(draft.description || '');
            if (parsed && parsed.blocks) editIssueState = EditorState.createWithContent(convertFromRaw(parsed));
            else if (draft.description) editIssueState = EditorState.createWithText(draft.description);
        } catch (_) {
            if (draft.description) editIssueState = EditorState.createWithText(draft.description);
        }
        const editSubStates = {};
        (draft.subIssues || []).forEach((s, idx) => {
            try {
                const p = JSON.parse(s.description || '');
                if (p && p.blocks) editSubStates[String(idx)] = EditorState.createWithContent(convertFromRaw(p));
                else if (s.description) editSubStates[String(idx)] = EditorState.createWithText(s.description);
            } catch (_) {
                if (s.description) editSubStates[String(idx)] = EditorState.createWithText(s.description);
            }
        });

        this.setState({ isIssueDetailOpen: true, activeIssue: issue || null, editIssueDraft: draft, issueShowAllActivities: false, issueShowAllComments: false, issueDetailActiveTab: 'activity', editIssueEditorState: editIssueState, editSubIssueEditorStates: editSubStates, editingIssueTitle: false, editingIssueDescription: false, editingEditSubIssueTitles: {}, editingEditSubIssueDescriptions: {} }, async () => {
            try { await this.fetchIssueActivity(); } catch (_) { }
        });
    }

    closeIssueDetail() {
        this.setState({ isIssueDetailOpen: false, activeIssue: null, editIssueDraft: null, issueActivity: [], issueCommentDraft: '', editingIssueTitle: false, editingIssueDescription: false });
    }

    handleEditIssueChange(field, value) {
        this.setState({ editIssueDraft: { ...(this.state.editIssueDraft || {}), [field]: value } });
    }
    handleIssueEditorChange(state) { this.setState({ issueEditorState: state }); }
    handleSubIssueEditorChange(tmpIndex, state) {
        const map = { ...(this.state.subIssueEditorStates || {}) };
        map[String(tmpIndex)] = state;
        this.setState({ subIssueEditorStates: map });
    }
    handleEditIssueEditorChange(state) { this.setState({ editIssueEditorState: state }); }
    handleEditSubIssueEditorChange(tmpIndex, state) {
        const map = { ...(this.state.editSubIssueEditorStates || {}) };
        map[String(tmpIndex)] = state;
        this.setState({ editSubIssueEditorStates: map });
    }

    openDetailMenu(kind, event) { this.setState({ detailMenus: { ...this.state.detailMenus, [`${kind}Anchor`]: event.currentTarget } }); }
    closeDetailMenus() { this.setState({ detailMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null } }); }
    openSubDetailMenu(kind, index, event) { this.setState({ subDetailMenus: { ...this.state.subDetailMenus, [`${kind}Anchor`]: event.currentTarget, index } }); }
    closeSubDetailMenus() { this.setState({ subDetailMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null, index: null } }); }

    addEditSubIssue() {
        const list = Array.isArray(this.state.editIssueDraft?.subIssues) ? [...this.state.editIssueDraft.subIssues] : [];
        list.push({ title: '', description: '', status: 'Backlog', priority: 'Medium', assigneeId: '', milestoneIndex: (this.state.editIssueDraft?.milestoneIndex ?? '') });
        this.handleEditIssueChange('subIssues', list);
        // rebuild editor states indexed by position
        const nextStates = {};
        list.forEach((s, idx) => {
            try {
                const p = JSON.parse(s.description || '');
                if (p && p.blocks) nextStates[String(idx)] = EditorState.createWithContent(convertFromRaw(p));
                else if (s.description) nextStates[String(idx)] = EditorState.createWithText(s.description);
                else nextStates[String(idx)] = EditorState.createEmpty();
            } catch (_) {
                nextStates[String(idx)] = s.description ? EditorState.createWithText(s.description) : EditorState.createEmpty();
            }
        });
        this.setState({ editSubIssueEditorStates: nextStates, editingEditSubIssueTitles: { ...(this.state.editingEditSubIssueTitles || {}), [String(list.length - 1)]: false }, editingEditSubIssueDescriptions: { ...(this.state.editingEditSubIssueDescriptions || {}), [String(list.length - 1)]: false } });
    }
    removeEditSubIssue(index) {
        const list = Array.isArray(this.state.editIssueDraft?.subIssues) ? [...this.state.editIssueDraft.subIssues] : [];
        if (index < 0 || index >= list.length) return;
        list.splice(index, 1);
        this.handleEditIssueChange('subIssues', list);
        const nextStates = {};
        list.forEach((s, idx) => {
            try {
                const p = JSON.parse(s.description || '');
                if (p && p.blocks) nextStates[String(idx)] = EditorState.createWithContent(convertFromRaw(p));
                else if (s.description) nextStates[String(idx)] = EditorState.createWithText(s.description);
                else nextStates[String(idx)] = EditorState.createEmpty();
            } catch (_) {
                nextStates[String(idx)] = s.description ? EditorState.createWithText(s.description) : EditorState.createEmpty();
            }
        });
        this.setState({ editSubIssueEditorStates: nextStates });
    }
    updateEditSubIssueField(index, field, value) {
        const list = Array.isArray(this.state.editIssueDraft?.subIssues) ? [...this.state.editIssueDraft.subIssues] : [];
        if (index < 0 || index >= list.length) {
            console.error('Invalid sub-issue index:', index, 'List length:', list.length);
            return;
        }
        list[index] = { ...list[index], [field]: value };
        console.log('Updating sub-issue field:', { index, field, value, updatedList: list }); // Debug log
        this.handleEditIssueChange('subIssues', list);
    }

    async fetchIssueActivity() {
        try {
            const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
            const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
            if (!projectId || !issueId) return;
            if (typeof AuthApi.getIssueActivity === 'function') {
                const res = await AuthApi.getIssueActivity(projectId, issueId);
                const list = (res && res.data) || res || [];
                this.setState({ issueActivity: Array.isArray(list) ? list : [] });
            }
        } catch (_) { }
    }

    async postIssueComment() {
        try {
            const text = String(this.state.issueCommentDraft || '').trim();
            if (!text) return;
            const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
            const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
            if (!projectId || !issueId) return;
            const file = this.state.issueRootFile || null;
            if (typeof AuthApi.createIssueCommentForm === 'function') {
                const res = await AuthApi.createIssueCommentForm(projectId, issueId, { text, file });
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchIssueActivity();
                }
            }
        } catch (_) { }
        if (this.state.issueRootFilePreview) {
            URL.revokeObjectURL(this.state.issueRootFilePreview);
        }
        this.setState({ issueCommentDraft: '', issueRootFile: null, issueRootFilePreview: null });
    }

    // Issue comments: replies
    async postIssueReply(parentCommentId) {
        try {
            const text = String((this.state.issueReplyDrafts || {})[parentCommentId] || '').trim();
            if (!text) return;
            const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
            const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
            if (!projectId || !issueId) return;

            // Ensure we're replying to a valid ISSUE COMMENT (must have numeric comment_id)
            const items = Array.isArray(this.state.issueActivity) ? this.state.issueActivity : [];
            const commentIds = new Set(
                items
                    .filter((it) => (it.kind || (it.action ? 'activity' : 'comment')) === 'comment')
                    .map((c) => Number(c.comment_id))
                    .filter((n) => !Number.isNaN(n))
            );
            const pid = Number(parentCommentId);
            const isValidParent = !Number.isNaN(pid) && commentIds.has(pid);

            const file = (this.state.issueReplyFiles || {})[parentCommentId] || null;
            if (typeof AuthApi.createIssueCommentForm === 'function') {
                const payload = isValidParent ? { text, parent_comment_id: pid, file } : { text, file };
                const res = await AuthApi.createIssueCommentForm(projectId, issueId, payload);
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchIssueActivity();
                } else {
                    // local append fallback
                    const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
                    list.unshift({ kind: 'comment', comment_id: Date.now(), id: `comment_${Date.now()}`, created_at: new Date().toISOString(), author: { name: 'You' }, text, ...(isValidParent ? { parent_comment_id: pid } : {}) });
                    this.setState({ issueActivity: list });
                }
            }
        } catch (_) {
            const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
            const pid = Number(parentCommentId);
            list.unshift({ kind: 'comment', comment_id: Date.now(), id: `comment_${Date.now()}`, created_at: new Date().toISOString(), author: { name: 'You' }, text: (this.state.issueReplyDrafts || {})[parentCommentId] || '', ...(Number.isNaN(pid) ? {} : { parent_comment_id: pid }) });
            this.setState({ issueActivity: list });
        }
        const nextFiles = { ...(this.state.issueReplyFiles || {}) }; delete nextFiles[parentCommentId];
        const nextPreviews = { ...(this.state.issueReplyFilePreviews || {}) };
        if (nextPreviews[parentCommentId]) {
            URL.revokeObjectURL(nextPreviews[parentCommentId]);
            delete nextPreviews[parentCommentId];
        }
        this.setState({ issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [parentCommentId]: '' }, issueReplyFiles: nextFiles, issueReplyFilePreviews: nextPreviews, issueShowReplies: { ...(this.state.issueShowReplies || {}), [parentCommentId]: false } });
    }

    replyToIssueComment(comment) {
        const cid = Number(comment?.comment_id);
        if (Number.isNaN(cid)) return;
        this.setState({ issueShowReplies: { ...(this.state.issueShowReplies || {}), [cid]: true } });
    }

    startEditIssueActivityComment(commentId, currentText) {
        const editing = { ...(this.state.issueEditingCommentIds || {}) };
        const drafts = { ...(this.state.issueEditCommentDrafts || {}) };
        editing[commentId] = true;
        drafts[commentId] = currentText || '';
        // reset file state for this comment edit
        const removed = { ...(this.state.issueEditingCommentRemovedFile || {}) };
        delete removed[commentId];
        const files = { ...(this.state.issueEditingCommentFiles || {}) };
        const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) };
        if (previews[commentId]) { try { URL.revokeObjectURL(previews[commentId]); } catch (_) { } delete previews[commentId]; }
        delete files[commentId];
        this.setState({ issueEditingCommentIds: editing, issueEditCommentDrafts: drafts, issueEditingCommentRemovedFile: removed, issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews });
    }

    cancelEditIssueActivityComment(commentId) {
        const editing = { ...(this.state.issueEditingCommentIds || {}) };
        const drafts = { ...(this.state.issueEditCommentDrafts || {}) };
        delete editing[commentId];
        delete drafts[commentId];
        const removed = { ...(this.state.issueEditingCommentRemovedFile || {}) };
        delete removed[commentId];
        const files = { ...(this.state.issueEditingCommentFiles || {}) };
        const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) };
        if (previews[commentId]) { try { URL.revokeObjectURL(previews[commentId]); } catch (_) { } }
        delete files[commentId];
        delete previews[commentId];
        this.setState({ issueEditingCommentIds: editing, issueEditCommentDrafts: drafts, issueEditingCommentRemovedFile: removed, issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews });
    }

    setIssueEditCommentDraft(commentId, text) {
        const drafts = { ...(this.state.issueEditCommentDrafts || {}) };
        drafts[commentId] = text;
        this.setState({ issueEditCommentDrafts: drafts });
    }

    async saveIssueActivityComment(commentId) {
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
        const text = (this.state.issueEditCommentDrafts || {})[commentId] || '';
        if (!String(text).trim() || !projectId || !issueId) return;
        try {
            if (typeof AuthApi.updateIssueComment === 'function') {
                const remove_file = (this.state.issueEditingCommentRemovedFile || {})[commentId] === true;
                const newFile = (this.state.issueEditingCommentFiles || {})[commentId] || null;
                if (newFile && typeof AuthApi.updateIssueCommentForm === 'function') {
                    const res = await AuthApi.updateIssueCommentForm(projectId, issueId, commentId, { text, file: newFile });
                    if (res && (res.status === true || res.code === 200)) {
                        await this.fetchIssueActivity();
                    }
                } else {
                    const payload = { text, ...(remove_file ? { remove_file: true } : {}) };
                    const res = await AuthApi.updateIssueComment(projectId, issueId, commentId, payload);
                    if (res && (res.status === true || res.code === 200)) {
                        await this.fetchIssueActivity();
                    } else {
                        const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
                        const idx = list.findIndex((c) => Number(c.comment_id) === Number(commentId));
                        if (idx !== -1) { list[idx] = { ...list[idx], text }; this.setState({ issueActivity: list }); }
                    }
                }
            } else {
                const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
                const idx = list.findIndex((c) => Number(c.comment_id) === Number(commentId));
                if (idx !== -1) { list[idx] = { ...list[idx], text }; this.setState({ issueActivity: list }); }
            }
        } catch (_) {
            const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
            const idx = list.findIndex((c) => Number(c.comment_id) === Number(commentId));
            if (idx !== -1) { list[idx] = { ...list[idx], text }; this.setState({ issueActivity: list }); }
        }
        this.cancelEditIssueActivityComment(commentId);
    }

    async deleteIssueActivityComment(commentId) {
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
        try {
            if (typeof AuthApi.deleteIssueComment === 'function') {
                const res = await AuthApi.deleteIssueComment(projectId, issueId, commentId);
                if (res && (res.status === true || res.code === 200)) {
                    await this.fetchIssueActivity();
                    return;
                }
            }
        } catch (_) { }
        // local remove
        const list = Array.isArray(this.state.issueActivity) ? [...this.state.issueActivity] : [];
        const filtered = list.filter((c) => Number(c.comment_id) !== Number(commentId));
        this.setState({ issueActivity: filtered });
    }

    async saveIssueDetail() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const draft = this.state.editIssueDraft || {};
        const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];

        // Fix milestone index conversion for main issue
        const mObj = draft.milestoneIndex !== '' && draft.milestoneIndex != null ? milestones[Number(draft.milestoneIndex)] : null;
        const milestoneId = mObj && (mObj.id || mObj._id) ? (mObj.id || mObj._id) : null;

        const payload = {
            title: draft.title,
            description: JSON.stringify(convertToRaw(this.state.editIssueEditorState.getCurrentContent())),
            status: draft.status || 'Backlog',
            priority: draft.priority || 'Medium',
            assignee_id: draft.assigneeId || null,
            milestone_id: milestoneId,
            sub_issues: (Array.isArray(draft.subIssues) ? draft.subIssues : []).map((s) => {
                // Fix milestone index conversion for sub-issues
                const smObj = s.milestoneIndex !== '' && s.milestoneIndex != null && !isNaN(Number(s.milestoneIndex))
                    ? milestones[Number(s.milestoneIndex)]
                    : null;
                return {
                    id: s.id || undefined,
                    title: String(s.title || '').trim(),
                    description: JSON.stringify(convertToRaw((this.state.editSubIssueEditorStates || {})[String((draft.subIssues || []).indexOf(s))] ? (this.state.editSubIssueEditorStates[String((draft.subIssues || []).indexOf(s))]).getCurrentContent() : EditorState.createEmpty().getCurrentContent())),
                    status: s.status || 'Backlog',
                    priority: s.priority || 'Medium',
                    assignee_id: s.assigneeId || null,
                    milestone_id: smObj && (smObj.id || smObj._id) ? (smObj.id || smObj._id) : null
                };
            }).filter((s) => s.title)
        };

        try {
            const issueId = this.state.activeIssue?.id || this.state.activeIssue?._id;
            console.log('Updating issue with payload:', payload); // Debug log
            const apiRes = await AuthApi.updateProjectIssue(id, issueId, payload);
            console.log('API response:', apiRes); // Debug log

            if (apiRes && (apiRes.status === true || apiRes.code === 200)) {
                await this.fetchIssues();
                this.closeIssueDetail();
            } else {
                console.error('Failed to update issue:', apiRes);
                alert('Failed to update issue. Please try again.');
            }
        } catch (e) {
            console.error('Error updating issue:', e);
            alert('Error updating issue. Please try again.');
        }
    }

    handleIssueDraftChange(field, value) {
        this.setState({ issueDraft: { ...this.state.issueDraft, [field]: value } });
    }

    async saveIssue() {
        const project = this.state.project || {};
        const { title, milestoneIndex, priority, subIssues } = this.state.issueDraft;
        if (!String(title).trim()) return;
        const milestones = Array.isArray(project.milestones) ? project.milestones : [];
        const mObj = milestoneIndex !== '' ? milestones[Number(milestoneIndex)] : null;
        const milestoneId = mObj && (mObj.id || mObj._id) ? (mObj.id || mObj._id) : null;
        const id = this.props.match && this.props.match.params && this.props.match.params.id;

        const payload = {
            title: title,
            description: JSON.stringify(convertToRaw(this.state.issueEditorState.getCurrentContent())),
            priority: priority || 'Medium',
            status: this.state.issueDraft.status || 'Backlog',
            assignee_id: this.state.issueDraft.assigneeId || null,
            milestone_id: milestoneId || null,
            sub_issues: Array.isArray(subIssues)
                ? subIssues
                    .map((s) => {
                        const ms = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];
                        const smObj = s.milestoneIndex !== '' && s.milestoneIndex != null ? ms[Number(s.milestoneIndex)] : null;
                        return {
                            id: s.id || undefined,
                            title: String(s.title || '').trim(),
                            description: JSON.stringify(convertToRaw((this.state.subIssueEditorStates[String(s._tmpIndex || '')] || EditorState.createEmpty()).getCurrentContent())),
                            status: s.status || 'Backlog',
                            priority: s.priority || 'Medium',
                            assignee_id: s.assigneeId || null,
                            milestone_id: smObj && (smObj.id || smObj._id) ? (smObj.id || smObj._id) : null
                        };
                    })
                    .filter((s) => s.title)
                : []
        };

        try {
            const apiRes = await AuthApi.createProjectIssue(id, payload);
            if (apiRes && (apiRes.status === true || apiRes.code === 201)) {
                await this.fetchIssues();
            }
        } catch (e) { }
        // Always reset and close after save
        this.setState({ issueDraft: { title: '', description: '', milestoneIndex: '', priority: 'Medium', status: 'Backlog', assigneeId: '', subIssues: [] }, issueEditorState: EditorState.createEmpty(), subIssueEditorStates: {} });
        this.closeIssueDialog();
    }

    addSubIssue() {
        const list = Array.isArray(this.state.issueDraft.subIssues) ? [...this.state.issueDraft.subIssues] : [];
        const tmpIndex = Date.now();
        const newItem = { _tmpIndex: tmpIndex, title: '', description: '', status: 'Backlog', priority: 'Medium', assigneeId: '', milestoneIndex: (this.state.issueDraft.milestoneIndex || '') };
        const subStates = { ...(this.state.subIssueEditorStates || {}) };
        subStates[String(tmpIndex)] = EditorState.createEmpty();
        this.setState({ issueDraft: { ...this.state.issueDraft, subIssues: [...list, newItem] } });
        this.setState({ subIssueEditorStates: subStates, editingSubIssueDescriptions: { ...(this.state.editingSubIssueDescriptions || {}), [String(tmpIndex)]: false } });
    }

    removeSubIssue(index) {
        const list = Array.isArray(this.state.issueDraft.subIssues) ? [...this.state.issueDraft.subIssues] : [];
        if (index < 0 || index >= list.length) return;
        const removed = list.splice(index, 1)[0];
        const subStates = { ...(this.state.subIssueEditorStates || {}) };
        if (removed && removed._tmpIndex) delete subStates[String(removed._tmpIndex)];
        const titles = { ...(this.state.editingSubIssueTitles || {}) };
        delete titles[String(index)];
        const descs = { ...(this.state.editingSubIssueDescriptions || {}) };
        if (removed && removed._tmpIndex) delete descs[String(removed._tmpIndex)];
        this.setState({ issueDraft: { ...this.state.issueDraft, subIssues: list }, subIssueEditorStates: subStates, editingSubIssueTitles: titles, editingSubIssueDescriptions: descs });
    }

    updateSubIssueTitle(index, value) {
        const list = Array.isArray(this.state.issueDraft.subIssues) ? [...this.state.issueDraft.subIssues] : [];
        if (index < 0 || index >= list.length) return;
        list[index] = { ...list[index], title: value };
        this.setState({ issueDraft: { ...this.state.issueDraft, subIssues: list } });
    }

    updateSubIssueField(index, field, value) {
        const list = Array.isArray(this.state.issueDraft.subIssues) ? [...this.state.issueDraft.subIssues] : [];
        if (index < 0 || index >= list.length) return;
        list[index] = { ...list[index], [field]: value };
        this.setState({ issueDraft: { ...this.state.issueDraft, subIssues: list } });
    }

    openSubIssueMenu(kind, index, event) {
        this.setState({ subIssueMenus: { ...this.state.subIssueMenus, [`${kind}Anchor`]: event.currentTarget, index } });
    }

    closeSubIssueMenus() {
        this.setState({ subIssueMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null, index: null } });
    }

    toggleIssuesGroup(key) {
        const currentMap = { ...(this.state.issuesGroupExpanded || {}) };
        const isCurrentlyExpanded = currentMap[key] === true; // default collapsed unless explicitly true
        currentMap[key] = !isCurrentlyExpanded; // toggle
        this.setState({ issuesGroupExpanded: currentMap });
    }

    renderGroupToggle(isExpanded, onClick) {
        const icon = isExpanded ? '▾' : '▸';
        const isDark = this.isDarkMode();
        return (
            <Box
                role="button"
                aria-label={isExpanded ? 'Collapse' : 'Expand'}
                onClick={onClick}
                style={{
                    width: 22,
                    height: 22,
                    border: isDark ? '1px solid #555' : '1px solid #cbd5e1',
                    borderRadius: 6,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    background: isDark ? '#2d2d2d' : '#fff',
                    color: isDark ? '#e2e8f0' : '#334155',
                    userSelect: 'none'
                }}
            >
                {icon}
            </Box>
        );
    }

    renderIssueCard(issue, index, groupKey) {
        const isDark = this.isDarkMode();
        const status = issue.status || 'Backlog';
        const priority = issue.priority || 'Medium';
        const assigneeId = issue.assignee_id || issue.assigneeId || '';
        const subs = Array.isArray(issue.subtasks) ? issue.subtasks : (Array.isArray(issue.sub_issues) ? issue.sub_issues : []);

        // Status styles - using brighter colors for better dark mode visibility
        const statusStyles = { backgroundColor: '#64748b', color: '#fff' };
        if (status === 'Backlog') statusStyles.backgroundColor = isDark ? '#71717a' : '#64748b';
        if (status === 'Todo') statusStyles.backgroundColor = isDark ? '#a1a1aa' : '#9ca3af';
        if (status === 'In Progress') statusStyles.backgroundColor = isDark ? '#3b82f6' : '#2563eb';
        if (status === 'Done') statusStyles.backgroundColor = isDark ? '#22c55e' : '#16a34a';
        if (status === 'Canceled') statusStyles.backgroundColor = isDark ? '#78716c' : '#6b7280';
        if (status === 'Duplicate') statusStyles.backgroundColor = isDark ? '#a8a29e' : '#94a3b8';

        // Priority styles
        const priorityStyles = { backgroundColor: '#475569', color: '#fff' };
        if (priority === 'Low') priorityStyles.backgroundColor = '#16a34a';
        if (priority === 'Medium') priorityStyles.backgroundColor = '#f59e0b';
        if (priority === 'High') priorityStyles.backgroundColor = '#dc2626';

        const assigneeName = assigneeId ? this.getUserName(assigneeId) : 'Unassigned';
        const assigneePhoto = assigneeId ? this.getUserPhoto(assigneeId) : null;

        return (
            <Box
                key={`issue-card-${issue.id || issue._id || index}`}
                mb={1.5}
                p={2}
                style={{
                    border: isDark ? '1px solid #333' : '1px solid #e5e7eb',
                    borderRadius: 10,
                    backgroundColor: isDark ? '#1e1e1e' : '#ffffff',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                }}
                onClick={() => this.openIssueDetail(issue)}
            >
                <Box>
                    {/* Issue Title and Status */}
                    <Box display="flex" alignItems="center" mb={1}>
                        <Typography variant="subtitle1" style={{ fontWeight: 700, color: isDark ? '#e2e8f0' : '#1a202c', marginRight: 8 }}>
                            {issue.title}
                        </Typography>
                        <Chip
                            label={status}
                            size="small"
                            style={{ ...statusStyles, fontSize: 11, height: 20, boxShadow: '0 1px 2px rgba(0,0,0,0.08)' }}
                        />
                    </Box>

                    {/* Description - directly below title */}
                    {issue.description && (
                        <Typography
                            variant="body2"
                            style={{
                                color: isDark ? '#94a3b8' : '#374151',
                                marginBottom: 8,
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                // WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                            }}
                        >
                            {this.renderDescriptionContent(issue.description)}
                        </Typography>
                    )}

                    {/* Sub-issues */}
                    {subs.length > 0 && (
                        <Box mb={1}>
                            {subs.slice(0, 3).map((s, si) => (
                                <Box key={`sub-${index}-${si}`} display="flex" alignItems="center" mb={0.5}>
                                    <Box
                                        style={{
                                            width: 4,
                                            height: 4,
                                            backgroundColor: isDark ? '#94a3b8' : '#6b7280',
                                            borderRadius: '50%',
                                            marginRight: 6
                                        }}
                                    />
                                    <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#4b5563', fontSize: 12 }}>
                                        {s.title || s.name || `Sub-issue ${si + 1}`}
                                    </Typography>
                                </Box>
                            ))}
                            {subs.length > 3 && (
                                <Typography variant="body2" style={{ color: isDark ? '#64748b' : '#6b7280', fontSize: 12, marginLeft: 10 }}>
                                    +{subs.length - 3} more sub-issues
                                </Typography>
                            )}
                        </Box>
                    )}

                    {/* Bottom row with tags and right side info */}
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {/* Left side tags */}
                        <Box display="flex" alignItems="center" gridGap={6} flexWrap="wrap">
                            <Chip
                                label={priority}
                                size="small"
                                style={{ ...priorityStyles, fontSize: 11, height: 20, boxShadow: '0 1px 2px rgba(0,0,0,0.08)' }}
                            />
                            {assigneeId && (
                                <Box display="flex" alignItems="center" style={{ fontSize: 11 }}>
                                    {assigneePhoto ? (
                                        <img
                                            src={assigneePhoto}
                                            alt={assigneeName}
                                            style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                marginRight: 4,
                                                objectFit: 'cover'
                                            }}
                                        />
                                    ) : (
                                        <Box
                                            style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                backgroundColor: '#6b7280',
                                                color: 'white',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 8,
                                                marginRight: 4
                                            }}
                                        >
                                            {assigneeName.slice(0, 2).toUpperCase()}
                                        </Box>
                                    )}
                                    <span style={{ color: isDark ? '#e2e8f0' : '#374151' }}>{assigneeName}</span>
                                </Box>
                            )}
                        </Box>

                        {/* Right side info */}
                        <Box display="flex" flexDirection="column" alignItems="flex-end">
                            {issue.milestone && (
                                <Box
                                    style={{
                                        fontSize: 11,
                                        color: isDark ? '#d0d0d0' : '#374151',
                                        backgroundColor: isDark ? '#333' : '#f3f4f6',
                                        padding: '2px 6px',
                                        borderRadius: 4,
                                        marginBottom: 4
                                    }}
                                >
                                    {issue.milestone.name}
                                </Box>
                            )}
                            <Box style={{ fontSize: 11, color: isDark ? '#94a3b8' : '#6b7280' }}>
                                {subs.length > 0 && `${subs.length} sub-issue${subs.length !== 1 ? 's' : ''}`}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    openIssueMenu(kind, event) {
        this.setState({ issueMenus: { ...this.state.issueMenus, [`${kind}Anchor`]: event.currentTarget } });
    }

    closeIssueMenus() {
        this.setState({ issueMenus: { statusAnchor: null, priorityAnchor: null, assigneeAnchor: null, milestoneAnchor: null } });
    }

    async load() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        try {
            const [projectRes, usersRes] = await Promise.all([
                AuthApi.singleProject(id),
                AuthApi.getData()
            ]);
            const project = projectRes && (projectRes.data || projectRes);
            const usersRaw = (usersRes && usersRes.data) || usersRes || [];
            const filteredUsers = Array.isArray(usersRaw)
                ? usersRaw.filter((u) => u && Number(u.user_logged) === 1)
                : [];
            const leadIds = Array.isArray(project?.lead_ids) ? project.lead_ids : (project?.lead_id ? [project.lead_id] : []);
            // If backend didn't embed issues, fetch them separately
            let projectWithIssues = project;
            if (!Array.isArray(project?.issues)) {
                try {
                    const issuesRes = await AuthApi.getProjectIssues(id);
                    const issues = (issuesRes && issuesRes.data) || issuesRes || [];
                    projectWithIssues = { ...project, issues };
                } catch (_) { }
            }
            this.setState({
                project: projectWithIssues,
                allUsers: filteredUsers,
                loading: false,
                pendingChanges: {
                    status: projectWithIssues?.status || 'Backlog',
                    priority: projectWithIssues?.priority || 'No priority',
                    lead_ids: leadIds || [],
                    member_ids: Array.isArray(projectWithIssues?.member_ids) ? projectWithIssues.member_ids : [],
                    start_date: projectWithIssues?.start_date || null,
                    target_date: projectWithIssues?.target_date || null
                }
            });
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    async fetchProjectUpdates() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        this.setState({ isLoadingUpdates: true });
        try {
            if (typeof AuthApi.getProjectUpdates === 'function') {
                const res = await AuthApi.getProjectUpdates(id);
                const list = (res && res.data) || res || [];
                this.setState({ updates: Array.isArray(list) ? list : [] });
            } else {
                this.setState({ updates: [] });
            }
        } catch (_) {
            this.setState({ updates: [] });
        } finally {
            this.setState({ isLoadingUpdates: false });
        }
    }

    async fetchProjectTimeline() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        try {
            if (typeof AuthApi.getProjectTimeline === 'function') {
                const res = await AuthApi.getProjectTimeline(id);
                const list = (res && res.data) || res || [];
                // For now we will reuse updates modal to show full timeline (kind: 'update' or 'activity')
                this.setState({ timeline: Array.isArray(list) ? list : [] });
            }
        } catch (_) { }
    }

    async fetchProjectResources() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        this.setState({ isLoadingResources: true });
        try {
            if (typeof AuthApi.getProjectResources === 'function') {
                const res = await AuthApi.getProjectResources(id);
                const list = (res && res.data) || res || [];
                this.setState({ resources: Array.isArray(list) ? list : [] });
            } else {
                this.setState({ resources: [] });
            }
        } catch (_) {
            this.setState({ resources: [] });
        } finally {
            this.setState({ isLoadingResources: false });
        }
    }

    openResourceDialog() { this.setState({ isResourceDialogOpen: true }); }
    closeResourceDialog() { this.setState({ isResourceDialogOpen: false, resourceDraft: { title: '', url: '' } }); }
    handleResourceDraftChange(field, value) { this.setState({ resourceDraft: { ...this.state.resourceDraft, [field]: value } }); }

    async saveResource() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const { title, url } = this.state.resourceDraft;
        if (!String(title).trim() || !String(url).trim()) return;
        try {
            if (typeof AuthApi.createProjectResource === 'function') {
                const res = await AuthApi.createProjectResource(id, { title, url });
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchProjectResources();
                }
            }
        } catch (_) { }
        this.closeResourceDialog();
    }

    async deleteResource(resourceId) {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        try {
            if (typeof AuthApi.deleteProjectResource === 'function') {
                const res = await AuthApi.deleteProjectResource(id, resourceId);
                if (res && (res.status === true || res.code === 200)) {
                    await this.fetchProjectResources();
                }
            }
        } catch (_) { }
    }

    triggerFilePicker() {
        if (!(this.canEditAllOverview() || this.canEditLimitedOverview())) return;
        const input = document.getElementById('project-resource-file-input');
        if (input) input.click();
    }

    triggerAttachmentInput(inputId) {
        if (!(this.canEditAllOverview() || this.canEditLimitedOverview())) return;
        try {
            const el = document.getElementById(inputId);
            if (el) el.click();
        } catch (_) { }
    }

    async onResourceFilePicked(evt) {
        const files = (evt && evt.target && evt.target.files) ? evt.target.files : null;
        if (!files || !files.length) return;
        const file = files[0];
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        this.setState({ isUploadingResource: true });
        try {
            if (typeof AuthApi.uploadProjectResource === 'function') {
                const res = await AuthApi.uploadProjectResource(id, file, file.name);
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchProjectResources();
                }
            }
        } catch (_) { }
        this.setState({ isUploadingResource: false });
        try { evt.target.value = ''; } catch (_) { }
    }

    async onAttachToUpdateComment(updateId, parentCommentId, evt) {
        const files = (evt && evt.target && evt.target.files) ? evt.target.files : null;
        if (!files || !files.length) return;
        const file = files[0];
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!projectId) return;
        this.setState({ isUploadingCommentAttachment: true });
        try {
            // Generate preview URL for images
            let previewUrl = null;
            if (file.type.startsWith('image/')) {
                previewUrl = URL.createObjectURL(file);
            }

            // Store the file for later use when posting the comment
            if (parentCommentId) {
                const current = (this.state.replyDrafts || {})[parentCommentId] || '';
                this.setState({
                    replyDrafts: { ...(this.state.replyDrafts || {}), [parentCommentId]: current },
                    replyFiles: { ...(this.state.replyFiles || {}), [parentCommentId]: file },
                    replyFilePreviews: { ...(this.state.replyFilePreviews || {}), [parentCommentId]: previewUrl }
                });
            } else {
                const current = (this.state.commentDrafts || {})[updateId] || '';
                this.setState({
                    commentDrafts: { ...(this.state.commentDrafts || {}), [updateId]: current },
                    commentFiles: { ...(this.state.commentFiles || {}), [updateId]: file },
                    commentFilePreviews: { ...(this.state.commentFilePreviews || {}), [updateId]: previewUrl }
                });
            }
        } catch (_) { }
        this.setState({ isUploadingCommentAttachment: false });
        try { evt.target.value = ''; } catch (_) { }
    }

    async onAttachToIssueComment(parentCommentId, evt) {
        const files = (evt && evt.target && evt.target.files) ? evt.target.files : null;
        if (!files || !files.length) return;
        const file = files[0];
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!projectId) return;
        this.setState({ isUploadingCommentAttachment: true });
        try {
            // Generate preview URL for images
            let previewUrl = null;
            if (file.type.startsWith('image/')) {
                previewUrl = URL.createObjectURL(file);
            }

            // Store the file for later use when posting the comment
            if (parentCommentId) {
                const current = (this.state.issueReplyDrafts || {})[parentCommentId] || '';
                this.setState({
                    issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [parentCommentId]: current },
                    issueReplyFiles: { ...(this.state.issueReplyFiles || {}), [parentCommentId]: file },
                    issueReplyFilePreviews: { ...(this.state.issueReplyFilePreviews || {}), [parentCommentId]: previewUrl }
                });
            } else {
                const current = this.state.issueCommentDraft || '';
                this.setState({
                    issueCommentDraft: current,
                    issueRootFile: file,
                    issueRootFilePreview: previewUrl
                });
            }
        } catch (_) { }
        this.setState({ isUploadingCommentAttachment: false });
        try { evt.target.value = ''; } catch (_) { }
    }

    openResourcePreview(resource) {
        const href = (resource && (resource.public_url || resource.url)) || '';
        const mime = resource && resource.mime_type;
        const isFromComment = Boolean(resource && resource._fromComment);
        const file_name = resource && (resource.file_name || resource.original_name || '');
        const title = isFromComment
            ? (this.formatAttachmentLabel(file_name, href, mime) || file_name || 'Attachment')
            : (resource?.title || resource?.original_name || 'Resource');
        this.setState({ isResourcePreviewOpen: true, previewResource: { href, title, mime, file_name, _fromComment: isFromComment } });
    }

    closeResourcePreview() {
        this.setState({ isResourcePreviewOpen: false, previewResource: null });
    }

    openUpdateComposer() {
        if (!(this.canEditAllOverview() || this.canEditLimitedOverview())) return;
        this.setState({ updateComposer: { ...this.state.updateComposer, open: true } });
    }
    closeUpdateComposer() {
        this.detachEmojiListeners();
        this.setState({ updateComposer: { status: 'On track', text: '', open: false }, activeEmojiUpdateId: null });
    }
    toggleShowAllUpdates() {
        this.setState({ showAllUpdates: !this.state.showAllUpdates });
    }
    toggleShowAllTimeline() {
        this.setState({ showAllTimeline: !this.state.showAllTimeline });
    }
    openUpdatesModal() {
        this.setState({ isUpdatesModalOpen: true }, async () => {
            await this.fetchProjectTimeline();
        });
    }
    closeUpdatesModal() {
        this.setState({ isUpdatesModalOpen: false });
    }
    async postProjectUpdate() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const composer = this.state.updateComposer || {};
        if (!id) return;
        if (!String(composer.text || '').trim()) return;
        try {
            if (typeof AuthApi.createProjectUpdate === 'function') {
                const payload = { status: composer.status, text: composer.text };
                const res = await AuthApi.createProjectUpdate(id, payload);
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchProjectUpdates();
                }
            } else {
                // local fallback: prepend locally
                const local = { id: Date.now(), status: composer.status, text: composer.text, author: { name: 'You' }, created_at: new Date().toISOString(), comments: [] };
                this.setState({ updates: [local, ...this.state.updates] });
            }
        } catch (_) { }
        this.closeUpdateComposer();
    }
    toggleComments(updateId) {
        const current = { ...(this.state.showComments || {}) };
        current[updateId] = !current[updateId];
        this.setState({ showComments: current });
    }
    toggleTimelineComments(updateId) {
        const current = { ...(this.state.timelineShowComments || {}) };
        current[updateId] = !current[updateId];
        this.setState({ timelineShowComments: current });
    }
    setCommentDraft(updateId, text) {
        const drafts = { ...(this.state.commentDrafts || {}) };
        drafts[updateId] = text;
        this.setState({ commentDrafts: drafts });
    }
    async postComment(updateId) {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const text = (this.state.commentDrafts || {})[updateId] || '';
        if (!String(text).trim()) return;
        try {
            const file = (this.state.commentFiles || {})[updateId] || null;
            if (typeof AuthApi.createProjectUpdateCommentForm === 'function') {
                const res = await AuthApi.createProjectUpdateCommentForm(id, updateId, { text, file });
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchProjectUpdates();
                }
            } else {
                // local fallback mutate
                const list = [...(this.state.updates || [])];
                const idx = list.findIndex((u) => (u.id || u._id) === updateId);
                if (idx !== -1) {
                    const upd = { ...(list[idx] || {}) };
                    const comments = Array.isArray(upd.comments) ? [...upd.comments] : [];
                    comments.push({ id: Date.now(), text, author: { name: 'You' }, created_at: new Date().toISOString() });
                    upd.comments = comments;
                    list[idx] = upd;
                    this.setState({ updates: list });
                }
            }
        } catch (_) { }
        this.setCommentDraft(updateId, '');
        const next = { ...(this.state.commentFiles || {}) }; delete next[updateId];
        const nextPreviews = { ...(this.state.commentFilePreviews || {}) };
        if (nextPreviews[updateId]) {
            URL.revokeObjectURL(nextPreviews[updateId]);
            delete nextPreviews[updateId];
        }
        const nextHeights = { ...(this.state.commentImageHeights || {}) }; delete nextHeights[updateId];
        this.setState({ commentFiles: next, commentFilePreviews: nextPreviews, commentImageHeights: nextHeights });
    }

    async postReply(updateId, parentCommentId) {
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        const text = (this.state.replyDrafts || {})[parentCommentId] || '';
        if (!String(text).trim()) return;
        try {
            const file = (this.state.replyFiles || {})[parentCommentId] || null;
            if (typeof AuthApi.createProjectUpdateCommentForm === 'function') {
                const res = await AuthApi.createProjectUpdateCommentForm(projectId, updateId, { text, parent_comment_id: parentCommentId, file });
                if (res && (res.status === true || res.code === 201)) {
                    await this.fetchProjectUpdates();
                }
            } else {
                // local fallback: add reply to the comment
                const list = [...(this.state.updates || [])];
                const idx = list.findIndex((u) => (u.id || u._id) === updateId);
                if (idx !== -1) {
                    const upd = { ...(list[idx] || {}) };
                    const comments = Array.isArray(upd.comments) ? [...upd.comments] : [];
                    comments.push({
                        id: Date.now(),
                        text,
                        author: { name: 'You' },
                        created_at: new Date().toISOString(),
                        parent_comment_id: parentCommentId
                    });
                    upd.comments = comments;
                    list[idx] = upd;
                    this.setState({ updates: list });
                }
            }
        } catch (_) {
            // local fallback on error
            const list = [...(this.state.updates || [])];
            const idx = list.findIndex((u) => (u.id || u._id) === updateId);
            if (idx !== -1) {
                const upd = { ...(list[idx] || {}) };
                const comments = Array.isArray(upd.comments) ? [...upd.comments] : [];
                comments.push({
                    id: Date.now(),
                    text,
                    author: { name: 'You' },
                    created_at: new Date().toISOString(),
                    parent_comment_id: parentCommentId
                });
                upd.comments = comments;
                list[idx] = upd;
                this.setState({ updates: list });
            }
        }
        const drafts = { ...(this.state.replyDrafts || {}) }; drafts[parentCommentId] = '';
        const files = { ...(this.state.replyFiles || {}) }; delete files[parentCommentId];
        const previews = { ...(this.state.replyFilePreviews || {}) };
        if (previews[parentCommentId]) {
            URL.revokeObjectURL(previews[parentCommentId]);
            delete previews[parentCommentId];
        }
        this.setState({ replyDrafts: drafts, replyFiles: files, replyFilePreviews: previews, showReplies: { ...(this.state.showReplies || {}), [parentCommentId]: false } });
    }

    // Reply inline to a specific comment (prepends @author and focuses composer)
    replyToUpdateComment(updateId, comment) {
        const current = { ...(this.state.commentDrafts || {}) };
        const mention = this.getDisplayNameFromUser(comment?.author || {});
        const prefix = mention ? `@${mention.split(' ')[0]} ` : '';
        const existing = current[updateId] || '';
        current[updateId] = existing ? `${existing}\n${prefix}` : prefix;
        this.setState({ commentDrafts: current, showComments: { ...(this.state.showComments || {}), [updateId]: true } });
    }

    startEditUpdateComment(updateId, commentId, currentText) {
        const editing = { ...(this.state.editingCommentIds || {}) };
        const drafts = { ...(this.state.editCommentDrafts || {}) };
        editing[commentId] = true;
        drafts[commentId] = currentText || '';
        // reset remove-file flag when starting edit
        const removed = { ...(this.state.editingCommentRemovedFile || {}) };
        delete removed[commentId];
        const editFiles = { ...(this.state.editingCommentFiles || {}) };
        const editPreviews = { ...(this.state.editingCommentFilePreviews || {}) };
        delete editFiles[commentId];
        if (editPreviews[commentId]) { try { URL.revokeObjectURL(editPreviews[commentId]); } catch (_) { } delete editPreviews[commentId]; }
        this.setState({ editingCommentIds: editing, editCommentDrafts: drafts, editingCommentRemovedFile: removed, editingCommentFiles: editFiles, editingCommentFilePreviews: editPreviews, showComments: { ...(this.state.showComments || {}), [updateId]: true } });
    }

    cancelEditUpdateComment(commentId) {
        const editing = { ...(this.state.editingCommentIds || {}) };
        const drafts = { ...(this.state.editCommentDrafts || {}) };
        delete editing[commentId];
        delete drafts[commentId];
        const removed = { ...(this.state.editingCommentRemovedFile || {}) };
        delete removed[commentId];
        const editFiles = { ...(this.state.editingCommentFiles || {}) };
        const editPreviews = { ...(this.state.editingCommentFilePreviews || {}) };
        if (editPreviews[commentId]) { try { URL.revokeObjectURL(editPreviews[commentId]); } catch (_) { } }
        delete editFiles[commentId];
        delete editPreviews[commentId];
        this.setState({ editingCommentIds: editing, editCommentDrafts: drafts, editingCommentRemovedFile: removed, editingCommentFiles: editFiles, editingCommentFilePreviews: editPreviews });
    }

    setEditUpdateCommentDraft(commentId, text) {
        const drafts = { ...(this.state.editCommentDrafts || {}) };
        drafts[commentId] = text;
        this.setState({ editCommentDrafts: drafts });
    }

    setEditCaretPosition(commentId, pos) {
        const carets = { ...(this.state.editCommentCarets || {}) };
        carets[commentId] = typeof pos === 'number' ? pos : 0;
        this.setState({ editCommentCarets: carets });
    }

    async saveEditUpdateComment(updateId, commentId) {
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        const text = (this.state.editCommentDrafts || {})[commentId] || '';
        if (!String(text).trim()) return;
        try {
            if (typeof AuthApi.updateProjectUpdateComment === 'function') {
                const remove_file = (this.state.editingCommentRemovedFile || {})[commentId] === true;
                const newFile = (this.state.editingCommentFiles || {})[commentId] || null;
                let payload = { text, remove_file };
                // Support updating/adding file during edit if backend accepts form route
                if (newFile && typeof AuthApi.updateProjectUpdateCommentForm === 'function') {
                    const res = await AuthApi.updateProjectUpdateCommentForm(projectId, updateId, commentId, { text, file: newFile });
                    if (res && (res.status === true || res.code === 200)) {
                        await this.fetchProjectUpdates();
                        await this.fetchProjectTimeline();
                    }
                } else {
                    const res = await AuthApi.updateProjectUpdateComment(projectId, updateId, commentId, payload);
                    if (res && (res.status === true || res.code === 200)) {
                        await this.fetchProjectUpdates();
                        await this.fetchProjectTimeline();
                    }
                }
            } else {
                // local optimistic update
                const list = [...(this.state.updates || [])];
                const idx = list.findIndex((u) => (u.id || u._id) === updateId);
                if (idx !== -1) {
                    const upd = { ...(list[idx] || {}) };
                    const comments = Array.isArray(upd.comments) ? [...upd.comments] : [];
                    const ci = comments.findIndex((c) => (c.id || c._id) === commentId);
                    if (ci !== -1) {
                        const cur = comments[ci] || {};
                        const newFile = (this.state.editingCommentFiles || {})[commentId] || null;
                        comments[ci] = { ...cur, text, ...((this.state.editingCommentRemovedFile || {})[commentId] ? { file_url: null, file_mime: null, file_name: null } : {}), ...(newFile ? { file_url: URL.createObjectURL(newFile), file_mime: newFile.type, file_name: newFile.name } : {}) };
                        upd.comments = comments;
                        list[idx] = upd;
                        this.setState({ updates: list });
                    }
                }
            }
        } catch (_) { }
        this.cancelEditUpdateComment(commentId);
    }

    async deleteUpdateComment(updateId, commentId) {
        const projectId = this.props.match && this.props.match.params && this.props.match.params.id;
        try {
            if (typeof AuthApi.deleteProjectUpdateComment === 'function') {
                const res = await AuthApi.deleteProjectUpdateComment(projectId, updateId, commentId);
                if (res && (res.status === true || res.code === 200)) {
                    await this.fetchProjectUpdates();
                }
            } else {
                // local remove
                const list = [...(this.state.updates || [])];
                const idx = list.findIndex((u) => (u.id || u._id) === updateId);
                if (idx !== -1) {
                    const upd = { ...(list[idx] || {}) };
                    const comments = Array.isArray(upd.comments) ? [...upd.comments] : [];
                    const filtered = comments.filter((c) => (c.id || c._id) !== commentId);
                    upd.comments = filtered;
                    list[idx] = upd;
                    this.setState({ updates: list });
                }
            }
        } catch (_) { }
    }

    async fetchIssues() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        if (!id) return;
        try {
            const issuesRes = await AuthApi.getProjectIssues(id);
            const issues = (issuesRes && issuesRes.data) || issuesRes || [];
            const current = this.state.project || {};
            this.setState({ project: { ...current, issues } });
        } catch (e) { }
    }

    getUserName(id) {
        const u = (this.state.allUsers || []).find((x) => Number(x.id) === Number(id));
        if (!u) return `User ${id}`;
        if (u.firstName) return `${u.firstName} ${u.lastName || ''}`.trim();
        return u.name || u.email || `User ${id}`;
    }

    getUserPhoto(id) {
        const u = (this.state.allUsers || []).find((x) => Number(x.id) === Number(id));
        if (!u) return null;
        const candidate = u.photo || u.avatar || u.image || null;
        if (candidate && String(candidate).trim() !== '') return candidate;
        return null;
    }

    // Permission helpers
    getCurrentUserId() {
        try {
            const current = ls.get("user") || {};
            const id = current.id || current._id || current.user_id || current.userId;
            return id != null ? Number(id) : null;
        } catch (_) { return null; }
    }

    getUserIdFromUser(user) {
        if (!user) return null;
        const id = user.id || user._id || user.user_id || user.userId || user.author_id;
        return id != null ? Number(id) : null;
    }

    isCurrentUserLead() {
        const p = this.state.project || {};
        const leads = Array.isArray(p.lead_ids) ? p.lead_ids : (p.lead_id ? [p.lead_id] : []);
        const uid = this.getCurrentUserId();
        return uid != null && leads.map(Number).includes(Number(uid));
    }

    isCurrentUserMember() {
        const p = this.state.project || {};
        const members = Array.isArray(p.member_ids) ? p.member_ids : [];
        const uid = this.getCurrentUserId();
        return uid != null && members.map(Number).includes(Number(uid));
    }

    isSuperAdmin() {
        try {
            let roles = ls.get('roles');
            if (!roles) return false;
            if (typeof roles === 'string') return roles.trim().toLowerCase() === 'super admin';
            if (Array.isArray(roles)) {
                return roles.some(r =>
                    (typeof r === 'string' && r.trim().toLowerCase() === 'super admin') ||
                    (typeof r === 'object' && (r.name || '').trim().toLowerCase() === 'super admin')
                );
            }
        } catch (_) { }
        return false;
    }

    canEditAllOverview() {
        return this.isCurrentUserLead() || this.isSuperAdmin();
    }

    canEditLimitedOverview() {
        // members may edit: priority, start_date, target_date; also post comments and updates
        return this.isCurrentUserMember() || this.isCurrentUserLead() || this.isSuperAdmin();
    }

    canEditUpdateComment(comment) {
        const uid = this.getCurrentUserId();
        const authorId = this.getUserIdFromUser((comment || {}).author);
        return (uid != null && authorId != null && Number(uid) === Number(authorId)) || this.isSuperAdmin();
    }

    canEditIssueComment(comment) {
        return this.canEditUpdateComment(comment);
    }

    async showNotAllowed() {
        // Prefer SweetAlert2 if available globally or via dynamic import; fallback to alert
        try {
            const maybeSwal = (typeof window !== 'undefined' && window.Swal) ? window.Swal : null;
            if (maybeSwal && typeof maybeSwal.fire === 'function') {
                await maybeSwal.fire({ icon: 'warning', title: 'Not allowed', text: 'You are not allowed to perform this action.', confirmButtonColor: '#036dda' });
                return;
            }
        } catch (_) { }
        try {
            const mod = await import('sweetalert2');
            const Swal = mod && (mod.default || mod);
            if (Swal && typeof Swal.fire === 'function') {
                await Swal.fire({ icon: 'warning', title: 'Not allowed', text: 'You are not allowed to perform this action.', confirmButtonColor: '#036dda' });
                return;
            }
        } catch (_) { }
        try { window.alert('You are not allowed to perform this action.'); } catch (_) { }
    }

    // Helpers for updates/comments display
    getDisplayNameFromUser(user) {
        if (!user) return 'User';
        if (user.firstName) return `${user.firstName} ${user.lastName || ''}`.trim();
        return user.name || user.email || 'User';
    }

    getPhotoFromUser(user) {
        if (!user) return null;
        const candidate = user.photo || user.avatar || user.image || null;
        if (candidate && String(candidate).trim() !== '') return candidate;
        return null;
    }

    // Threaded comments helpers
    buildCommentIndex(comments = []) {
        const byParent = {};
        const roots = [];
        const allIds = new Set();
        comments.forEach(c => {
            const id = c.comment_id || c.id || c._id;
            if (id) allIds.add(String(id));
        });

        comments.forEach((c) => {
            let pid = c.parent_comment_id || c.parentId || null;
            // If parent ID is present but not found in the current comment list, treat as root
            if (pid && !allIds.has(String(pid))) {
                pid = null;
            }

            if (pid) {
                if (!byParent[pid]) byParent[pid] = [];
                byParent[pid].push(c);
            } else {
                roots.push(c);
            }
        });
        Object.keys(byParent).forEach((k) => byParent[k].sort((a, b) => new Date(a.created_at) - new Date(b.created_at)));
        roots.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        return { roots, byParent };
    }

    renderReplyComposer(updateId, parentId) {
        const isDark = this.isDarkMode();
        const val = (this.state.replyDrafts || {})[parentId] || '';
        // Get current user from local storage instead of props
        const currentUser = ls.get("user") || {};
        const currentUserPhoto = this.getPhotoFromUser(currentUser);
        return (
            <Box mt={1} display="flex" alignItems="flex-start" gridGap={10}>
                {currentUserPhoto ? (
                    <img src={currentUserPhoto} alt={this.getDisplayNameFromUser(currentUser)} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                ) : (
                    <Box style={{ width: 24, height: 24, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600 }}>
                        {this.getInitialsFromUser(currentUser)}
                    </Box>
                )}
                <Box flex={1}>
                    <Box
                        style={{
                            border: '2px solid #227aad',
                            borderRadius: 6,
                            padding: 8,
                            background: isDark ? '#1e1e1e' : '#fff',
                            minHeight: '56px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            width: '100%'
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder="Write a reply..."
                            variant="standard"
                            InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                            size="small"
                            multiline
                            rows={2}
                            value={val}
                            onChange={(e) => this.setState({ replyDrafts: { ...(this.state.replyDrafts || {}), [parentId]: e.target.value } })}
                            style={{ background: 'none' }}
                        />
                        {/* Image preview for reply (displayed inside box) */}
                        {(() => {
                            const previewUrl = (this.state.replyFilePreviews || {})[parentId] || null;
                            if (!previewUrl) return null;
                            return (
                                <Box style={{ position: 'relative', display: 'inline-block' }}>
                                    <img
                                        src={previewUrl}
                                        alt="Preview"
                                        style={{
                                            marginTop: 8,
                                            maxWidth: '200px',
                                            maxHeight: '140px',
                                            borderRadius: 8,
                                            border: '1px solid #e5e7eb',
                                            objectFit: 'cover',
                                            display: 'block',
                                            marginLeft: 0,
                                            marginRight: 0
                                        }}
                                    />
                                    <span
                                        title="Remove"
                                        onClick={() => this.setReplyFile(parentId, null)}
                                        style={{
                                            position: 'absolute',
                                            top: 2,
                                            right: 2,
                                            background: isDark ? '#333' : '#fff',
                                            border: isDark ? '1px solid #555' : '1px solid #bbb',
                                            borderRadius: '50%',
                                            cursor: 'pointer',
                                            width: 22,
                                            height: 22,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 700,
                                            fontSize: 15
                                        }}
                                    >×</span>
                                </Box>
                            );
                        })()}
                        {/* Show file chip for non-images as previous code */}
                        {(() => {
                            const previews = this.state.replyFilePreviews || {};
                            const files = this.state.replyFiles || {};
                            const previewUrl = previews[parentId];
                            const fileObj = files[parentId];
                            // If not an image, but file present
                            if (!previewUrl && fileObj && fileObj.name) {
                                return (
                                    <Box mt={1} mb={1} style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff' }}>
                                        {(() => { const ext = this.getFileExtensionFromMeta(fileObj.name, null, fileObj.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                        <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(fileObj.name, fileObj.name, fileObj.type)}</span>
                                        <span
                                            title="Remove"
                                            onClick={() => this.setReplyFile(parentId, null)}
                                            style={{
                                                marginLeft: 6,
                                                color: isDark ? '#aaa' : '#555',
                                                cursor: 'pointer',
                                                borderRadius: '50%',
                                                border: isDark ? '1px solid #666' : '1px solid #bbb',
                                                width: 18,
                                                height: 18,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 700,
                                                fontSize: 13
                                            }}
                                        >×</span>
                                    </Box>
                                );
                            }
                            return null;
                        })()}
                    </Box>
                    <Box display="flex" justifyContent="flex-end" mt={1}>
                        <Box>
                            <input id={`attach-update-reply-${parentId}`} type="file" style={{ display: 'none' }} onChange={(e) => this.onAttachToUpdateComment(updateId, parentId, e)} />
                            <Button size="small" onClick={() => this.triggerAttachmentInput(`attach-update-reply-${parentId}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                            <Button size="small" onClick={(e) => {
                                this.setState({
                                    showEmojiForReply: { ...(this.state.showEmojiForReply || {}), [parentId]: true },
                                    replyEmojiAnchorEls: { ...(this.state.replyEmojiAnchorEls || {}), [parentId]: e.currentTarget },
                                    activeEmojiReplyParentId: parentId
                                });
                            }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                            <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.postReply(updateId, parentId)}>Reply</Button>
                        </Box>
                    </Box>
                    {/* Emoji Picker for reply composer */}
                    <Popover
                        open={Boolean((this.state.showEmojiForReply || {})[parentId])}
                        anchorEl={(this.state.replyEmojiAnchorEls || {})[parentId] || null}
                        onClose={() => this.setState({ showEmojiForReply: { ...(this.state.showEmojiForReply || {}), [parentId]: false }, activeEmojiReplyParentId: null })}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                    >
                        {(() => {
                            try {
                                const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                const onPick = (emojiData) => {
                                    const emoji = emojiData?.emoji || emojiData?.native || '';
                                    const current = (this.state.replyDrafts || {})[parentId] || '';
                                    this.setState({ replyDrafts: { ...(this.state.replyDrafts || {}), [parentId]: current + emoji } });
                                };
                                return (
                                    <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                );
                            } catch (_) { return null; }
                        })()}
                    </Popover>
                </Box>
            </Box>
        );
    }

    renderComment(updateId, c, byParent) {
        const isDark = this.isDarkMode();
        const cid = (c && (c.comment_id || c.id || c._id));
        const isEditing = (this.state.editingCommentIds || {})[cid] === true;
        const replies = byParent[cid] || [];
        const showReplyBox = (this.state.showReplies || {})[cid] === true;
        const showMore = (this.state.showMoreReplies || {})[cid] === true;
        const visibleReplies = showMore ? replies : replies.slice(0, 1);

        return (
            <Box key={`c-${cid}`} display="flex" alignItems="flex-start" gridGap={12} style={{ marginTop: 12 }}>
                {(() => {
                    const cPhoto = this.getPhotoFromUser(c.author);
                    if (cPhoto) {
                        return (
                            <img src={cPhoto} alt={this.getDisplayNameFromUser(c.author)} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '2px solid #cbd5e1' }} />
                        );
                    }
                    return (
                        <Box style={{ width: 28, height: 28, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>
                            {this.getInitialsFromUser(c.author)}
                        </Box>
                    );
                })()}
                <Box flex={1}>
                    <Box display="flex" alignItems="baseline" gridGap={8}>
                        <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#4c545f', fontWeight: 700 }}>{this.getDisplayNameFromUser(c.author)}</Typography>
                        <Typography variant="caption" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>{this.formatDateDMYTime(c.created_at)}</Typography>
                    </Box>
                    {isEditing ? (
                        <Box>
                            <Box
                                style={{
                                    border: '2px solid #036dda',
                                    borderRadius: 10,
                                    padding: 10,
                                    background: isDark ? '#1e1e1e' : '#ffffff',
                                    minHeight: '56px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    width: '100%'
                                }}
                            >
                                <TextField
                                    fullWidth
                                    placeholder="Edit comment..."
                                    variant="standard"
                                    InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                    size="small"
                                    multiline
                                    rows={2}
                                    value={(this.state.editCommentDrafts || {})[cid] || ''}
                                    onChange={(e) => { this.setEditUpdateCommentDraft(cid, e.target.value); try { this.setEditCaretPosition(cid, e.target.selectionStart); } catch (_) { } }}
                                    onClick={(e) => { try { this.setEditCaretPosition(cid, e.target.selectionStart); } catch (_) { } }}
                                    onKeyUp={(e) => { try { this.setEditCaretPosition(cid, e.target.selectionStart); } catch (_) { } }}
                                    onSelect={(e) => { try { this.setEditCaretPosition(cid, e.target.selectionStart); } catch (_) { } }}
                                    style={{ background: 'none' }}
                                />
                                {(() => {
                                    // Render newly selected file during edit (takes precedence)
                                    const selPreview = (this.state.editingCommentFilePreviews || {})[cid] || null;
                                    const selFile = (this.state.editingCommentFiles || {})[cid] || null;
                                    if (selFile) {
                                        const isImg = !!selPreview;
                                        return (
                                            <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                {isImg ? (
                                                    <>
                                                        <img src={selPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                        <span title="Remove" onClick={() => { const files = { ...(this.state.editingCommentFiles || {}) }; const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const prev = previews[cid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[cid]; delete previews[cid]; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews }); }} style={{ position: 'absolute', top: 2, right: 2, background: isDark ? '#333' : '#fff', border: isDark ? '1px solid #555' : '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                    </>
                                                ) : (
                                                    <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff', position: 'relative', marginRight: 6 }}>
                                                        {(() => { const ext = this.getFileExtensionFromMeta(selFile.name, null, selFile.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                        <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(selFile.name, selFile.name, selFile.type)}</span>
                                                        <span title="Remove" onClick={() => { const files = { ...(this.state.editingCommentFiles || {}) }; const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const prev = previews[cid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[cid]; delete previews[cid]; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews }); }} style={{ marginLeft: 6, color: isDark ? '#aaa' : '#555', cursor: 'pointer', borderRadius: '50%', border: isDark ? '1px solid #666' : '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                    </Box>
                                                )}
                                            </Box>
                                        );
                                    }
                                    const removed = (this.state.editingCommentRemovedFile || {})[cid] === true;
                                    if (removed) return null;
                                    const href = c.file_url || c.fileUrl || null;
                                    const mime = c.file_mime || c.mime_type || '';
                                    if (!href) return null;
                                    const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                    return (
                                        <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                            {isImage ? (
                                                <>
                                                    <img
                                                        src={href}
                                                        alt={c.file_name || 'Attachment'}
                                                        style={{
                                                            maxWidth: '200px',
                                                            maxHeight: '140px',
                                                            borderRadius: 8,
                                                            border: '1px solid #e5e7eb',
                                                            objectFit: 'cover',
                                                            display: 'block',
                                                            marginLeft: 0,
                                                            marginRight: 0
                                                        }}
                                                    />
                                                    <span
                                                        title="Remove"
                                                        onClick={() => this.setState({ editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [cid]: true } })}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 2,
                                                            right: 2,
                                                            background: '#fff',
                                                            border: '1px solid #bbb',
                                                            borderRadius: '50%',
                                                            cursor: 'pointer',
                                                            width: 22,
                                                            height: 22,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 700,
                                                            fontSize: 15
                                                        }}
                                                    >×</span>
                                                </>
                                            ) : (
                                                <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                    {(() => { const ext = this.getFileExtensionFromMeta(c.file_name, href, mime); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                    <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(c.file_name, href, mime)}</span>
                                                    <span
                                                        title="Remove"
                                                        onClick={() => this.setState({ editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [cid]: true } })}
                                                        style={{
                                                            marginLeft: 6,
                                                            color: '#555',
                                                            cursor: 'pointer',
                                                            borderRadius: '50%',
                                                            border: '1px solid #bbb',
                                                            width: 18,
                                                            height: 18,
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 700,
                                                            fontSize: 13
                                                        }}
                                                    >×</span>
                                                </Box>
                                            )}
                                        </Box>
                                    );
                                })()}
                            </Box>
                            <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                <input id={`edit-attach-update-${cid}`} type="file" style={{ display: 'none' }} onChange={(e) => { const f = (e && e.target && e.target.files && e.target.files[0]) || null; if (!f) { return; } const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const files = { ...(this.state.editingCommentFiles || {}) }; files[cid] = f; previews[cid] = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews, editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [cid]: true } }); try { e.target.value = ''; } catch (_) { } }} />
                                <Button size="small" onClick={() => this.triggerAttachmentInput(`edit-attach-update-${cid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                <Button size="small" onClick={(e) => { this.setState({ showEmojiForUpdate: { ...(this.state.showEmojiForUpdate || {}), [cid]: true }, updateEmojiAnchorEls: { ...(this.state.updateEmojiAnchorEls || {}), [cid]: e.currentTarget }, activeEmojiUpdateId: cid }); }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                <Button size="small" className="btn-cancel" onClick={() => this.cancelEditUpdateComment(cid)}>Cancel</Button>
                                <Button size="small" className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.saveEditUpdateComment(updateId, cid)}>Save</Button>
                            </Box>
                            <Popover
                                open={Boolean((this.state.showEmojiForUpdate || {})[cid])}
                                anchorEl={(this.state.updateEmojiAnchorEls || {})[cid] || null}
                                onClose={() => this.setState({ showEmojiForUpdate: { ...(this.state.showEmojiForUpdate || {}), [cid]: false }, activeEmojiUpdateId: null })}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                            >
                                {(() => {
                                    try {
                                        const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                        const onPick = (emojiData) => {
                                            const emoji = emojiData?.emoji || emojiData?.native || '';
                                            const current = (this.state.editCommentDrafts || {})[cid] || '';
                                            const caret = (this.state.editCommentCarets || {})[cid];
                                            if (typeof caret === 'number' && caret >= 0 && caret <= current.length) {
                                                const next = current.slice(0, caret) + emoji + current.slice(caret);
                                                this.setEditUpdateCommentDraft(cid, next);
                                                this.setEditCaretPosition(cid, caret + emoji.length);
                                            } else {
                                                this.setEditUpdateCommentDraft(cid, current + emoji);
                                                this.setEditCaretPosition(cid, (current + emoji).length);
                                            }
                                        };
                                        return (
                                            <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                        );
                                    } catch (_) { return null; }
                                })()}
                            </Popover>
                        </Box>
                    ) : (
                        <>
                            <Box style={{ background: isDark ? '#1e1e1e' : '#ffffff', border: isDark ? '1px solid #333' : '1px solid #e6eff5', borderRadius: 12, padding: 12, marginTop: 4, boxShadow: '0 3px 10px rgba(2,6,23,0.04)' }}>
                                <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f', textAlign: 'left', lineHeight: 1.5 }}>{c.text}</Typography>
                                {(() => {
                                    const href = c.file_url || c.fileUrl || null;
                                    const mime = c.file_mime || c.mime_type || '';
                                    if (!href) return null;
                                    const isImage = String(mime).startsWith('image/') || href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/);
                                    return (
                                        <Box mt={1} style={{ textAlign: 'left' }}>
                                            {isImage ? (
                                                <img
                                                    src={href}
                                                    alt={c.file_name || 'Attachment'}
                                                    style={{ maxWidth: '240px', maxHeight: '180px', borderRadius: 8, border: '1px solid #e2e8f0', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }}
                                                />
                                            ) : (
                                                this.renderAttachmentChip(c.file_name, href, mime, () => this.openResourcePreview({ url: href, mime_type: mime, original_name: c.file_name || 'Attachment', _fromComment: true }))
                                            )}
                                        </Box>
                                    );
                                })()}
                            </Box>
                            <Box mt={0.5} display="flex" gridGap={10}>
                                {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                    <Button size="small" style={{ color: '#1d4ed8', fontWeight: 700, textTransform: 'none' }} onClick={() => this.setState({ showReplies: { ...(this.state.showReplies || {}), [cid]: !showReplyBox } })}>Reply</Button>
                                )}
                                {this.canEditUpdateComment(c) && (
                                    <Button size="small" style={{ color: '#6b7280', textTransform: 'none' }} onClick={() => this.startEditUpdateComment(updateId, cid, c.text)}>Edit</Button>
                                )}
                                {this.canEditUpdateComment(c) && (
                                    <Button size="small" style={{ color: '#dc2626', textTransform: 'none' }} onClick={() => this.deleteUpdateComment(updateId, cid)}>Delete</Button>
                                )}
                            </Box>
                        </>
                    )}

                    {showReplyBox && this.renderReplyComposer(updateId, cid)}

                    {/* Render replies directly under the parent comment */}
                    {replies.length > 0 && (
                        <Box mt={1} style={{ marginLeft: 16, borderLeft: '2px solid #e6eff5', paddingLeft: 12 }}>
                            {visibleReplies.map((rc) => {
                                const rcid = rc.comment_id || rc.id || rc._id;
                                const rIsEditing = (this.state.editingCommentIds || {})[rcid] === true;
                                const rShowReplyBox = (this.state.showReplies || {})[rcid] === true;
                                return (
                                    <Box key={`reply-${rcid}`} display="flex" alignItems="flex-start" gridGap={8} style={{ marginTop: 8 }}>
                                        {(() => {
                                            const rPhoto = this.getPhotoFromUser(rc.author);
                                            if (rPhoto) {
                                                return (
                                                    <img src={rPhoto} alt={this.getDisplayNameFromUser(rc.author)} style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                );
                                            }
                                            return (
                                                <Box style={{ width: 22, height: 22, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>
                                                    {this.getInitialsFromUser(rc.author)}
                                                </Box>
                                            );
                                        })()}
                                        <Box flex={1}>
                                            <Box display="flex" alignItems="baseline" gridGap={6}>
                                                <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#4c545f', fontWeight: 600, fontSize: 13 }}>{this.getDisplayNameFromUser(rc.author)}</Typography>
                                                <Typography variant="caption" style={{ color: isDark ? '#94a3b8' : '#64748b', fontSize: 11 }}>{this.formatDateDMYTime(rc.created_at)}</Typography>
                                            </Box>
                                            {rIsEditing ? (
                                                <Box>
                                                    <Box
                                                        style={{
                                                            border: '2px solid #227aad',
                                                            borderRadius: 6,
                                                            padding: 8,
                                                            background: isDark ? '#1e1e1e' : '#fff',
                                                            minHeight: '56px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-start',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <TextField
                                                            fullWidth
                                                            placeholder="Edit reply..."
                                                            variant="standard"
                                                            InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                            size="small"
                                                            multiline
                                                            rows={2}
                                                            value={(this.state.editCommentDrafts || {})[rcid] || ''}
                                                            onChange={(e) => { this.setEditUpdateCommentDraft(rcid, e.target.value); try { this.setEditCaretPosition(rcid, e.target.selectionStart); } catch (_) { } }}
                                                            onClick={(e) => { try { this.setEditCaretPosition(rcid, e.target.selectionStart); } catch (_) { } }}
                                                            onKeyUp={(e) => { try { this.setEditCaretPosition(rcid, e.target.selectionStart); } catch (_) { } }}
                                                            onSelect={(e) => { try { this.setEditCaretPosition(rcid, e.target.selectionStart); } catch (_) { } }}
                                                            style={{ background: 'none' }}
                                                        />
                                                        {(() => {
                                                            const selPreview = (this.state.editingCommentFilePreviews || {})[rcid] || null;
                                                            const selFile = (this.state.editingCommentFiles || {})[rcid] || null;
                                                            if (selFile) {
                                                                const isImg = !!selPreview;
                                                                return (
                                                                    <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                        {isImg ? (
                                                                            <>
                                                                                <img src={selPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                                                <span title="Remove" onClick={() => { const files = { ...(this.state.editingCommentFiles || {}) }; const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const prev = previews[rcid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[rcid]; delete previews[rcid]; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews }); }} style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                                            </>
                                                                        ) : (
                                                                            <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                                {(() => { const ext = this.getFileExtensionFromMeta(selFile.name, null, selFile.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(selFile.name, selFile.name, selFile.type)}</span>
                                                                                <span title="Remove" onClick={() => { const files = { ...(this.state.editingCommentFiles || {}) }; const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const prev = previews[rcid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[rcid]; delete previews[rcid]; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews }); }} style={{ marginLeft: 6, color: '#555', cursor: 'pointer', borderRadius: '50%', border: '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                );
                                                            }
                                                            const removed = (this.state.editingCommentRemovedFile || {})[rcid] === true;
                                                            if (removed) return null;
                                                            const href = rc.file_url || rc.fileUrl || null;
                                                            const mime = rc.file_mime || rc.mime_type || '';
                                                            if (!href) return null;
                                                            const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                            return (
                                                                <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                    {isImage ? (
                                                                        <>
                                                                            <img
                                                                                src={href}
                                                                                alt={rc.file_name || 'Attachment'}
                                                                                style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }}
                                                                            />
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={() => this.setState({ editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [rcid]: true } })}
                                                                                style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}
                                                                            >×</span>
                                                                        </>
                                                                    ) : (
                                                                        <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                            {(() => { const ext = this.getFileExtensionFromMeta(rc.file_name, href, mime); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                            <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(rc.file_name, href, mime)}</span>
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={() => this.setState({ editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [rcid]: true } })}
                                                                                style={{ marginLeft: 6, color: '#555', cursor: 'pointer', borderRadius: '50%', border: '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}
                                                                            >×</span>
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            );
                                                        })()}
                                                    </Box>
                                                    <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                        <input id={`edit-attach-update-${rcid}`} type="file" style={{ display: 'none' }} onChange={(e) => { const f = (e && e.target && e.target.files && e.target.files[0]) || null; if (!f) { return; } const previews = { ...(this.state.editingCommentFilePreviews || {}) }; const files = { ...(this.state.editingCommentFiles || {}) }; files[rcid] = f; previews[rcid] = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; this.setState({ editingCommentFiles: files, editingCommentFilePreviews: previews, editingCommentRemovedFile: { ...(this.state.editingCommentRemovedFile || {}), [rcid]: true } }); try { e.target.value = ''; } catch (_) { } }} />
                                                        <Button size="small" onClick={() => this.triggerAttachmentInput(`edit-attach-update-${rcid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                        <Button size="small" onClick={(e) => { this.setState({ showEmojiForReply: { ...(this.state.showEmojiForReply || {}), [rcid]: true }, replyEmojiAnchorEls: { ...(this.state.replyEmojiAnchorEls || {}), [rcid]: e.currentTarget }, activeEmojiReplyParentId: rcid }); }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                        <Button size="small" className="btn-cancel" onClick={() => this.cancelEditUpdateComment(rcid)}>Cancel</Button>
                                                        <Button size="small" className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.saveEditUpdateComment(updateId, rcid)}>Save</Button>
                                                    </Box>
                                                    <Popover
                                                        open={Boolean((this.state.showEmojiForReply || {})[rcid])}
                                                        anchorEl={(this.state.replyEmojiAnchorEls || {})[rcid] || null}
                                                        onClose={() => this.setState({ showEmojiForReply: { ...(this.state.showEmojiForReply || {}), [rcid]: false }, activeEmojiReplyParentId: null })}
                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                        PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                    >
                                                        {(() => {
                                                            try {
                                                                const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                const onPick = (emojiData) => {
                                                                    const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                    const current = (this.state.editCommentDrafts || {})[rcid] || '';
                                                                    const caret = (this.state.editCommentCarets || {})[rcid];
                                                                    if (typeof caret === 'number' && caret >= 0 && caret <= current.length) {
                                                                        const next = current.slice(0, caret) + emoji + current.slice(caret);
                                                                        this.setEditUpdateCommentDraft(rcid, next);
                                                                        this.setEditCaretPosition(rcid, caret + emoji.length);
                                                                    } else {
                                                                        this.setEditUpdateCommentDraft(rcid, current + emoji);
                                                                        this.setEditCaretPosition(rcid, (current + emoji).length);
                                                                    }
                                                                };
                                                                return (
                                                                    <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                );
                                                            } catch (_) { return null; }
                                                        })()}
                                                    </Popover>
                                                </Box>
                                            ) : (
                                                <>
                                                    <Box style={{ background: isDark ? '#1e1e1e' : '#f8fafc', border: isDark ? '1px solid #333' : '1px solid #e6eff5', borderRadius: 10, padding: 10, marginTop: 2, boxShadow: '0 2px 8px rgba(2,6,23,0.04)' }}>
                                                        <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f', textAlign: 'left', fontSize: 13, lineHeight: 1.5 }}>{rc.text}</Typography>
                                                        {(() => {
                                                            const href = rc.file_url || rc.fileUrl || null;
                                                            const mime = rc.file_mime || rc.mime_type || '';
                                                            if (!href) return null;
                                                            const isImage = String(mime).startsWith('image/') || href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/);
                                                            return (
                                                                <Box mt={1} style={{ textAlign: 'left' }}>
                                                                    {isImage ? (
                                                                        <img
                                                                            src={href}
                                                                            alt={rc.file_name || 'Attachment'}
                                                                            style={{ maxWidth: '240px', maxHeight: '180px', borderRadius: 8, border: '1px solid #e2e8f0', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }}
                                                                        />
                                                                    ) : (
                                                                        this.renderAttachmentChip(rc.file_name, href, mime, () => this.openResourcePreview({ url: href, mime_type: mime, original_name: rc.file_name || 'Attachment', _fromComment: true }))
                                                                    )}
                                                                </Box>
                                                            );
                                                        })()}
                                                    </Box>
                                                    <Box mt={0.5} display="flex" gridGap={10}>
                                                        {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                            <Button size="small" style={{ color: '#1d4ed8', fontWeight: 700, textTransform: 'none' }} onClick={() => this.setState({ showReplies: { ...(this.state.showReplies || {}), [rcid]: !rShowReplyBox } })}>Reply</Button>
                                                        )}
                                                        {this.canEditUpdateComment(rc) && (
                                                            <Button size="small" style={{ color: '#6b7280', textTransform: 'none' }} onClick={() => this.startEditUpdateComment(updateId, rcid, rc.text)}>Edit</Button>
                                                        )}
                                                        {this.canEditUpdateComment(rc) && (
                                                            <Button size="small" style={{ color: '#dc2626', textTransform: 'none' }} onClick={() => this.deleteUpdateComment(updateId, rcid)}>Delete</Button>
                                                        )}
                                                    </Box>
                                                </>
                                            )}

                                            {rShowReplyBox && this.renderReplyComposer(updateId, rcid)}
                                        </Box>
                                    </Box>
                                );
                            })}
                            {replies.length > 1 && (
                                <Box mt={1}>
                                    <Button size="small" onClick={() => this.setState({ showMoreReplies: { ...(this.state.showMoreReplies || {}), [cid]: !showMore } })} style={{ fontSize: 11, textTransform: 'none', color: '#1d4ed8' }}>
                                        {showMore ? 'Hide replies' : `Show ${replies.length - 1} more repl${replies.length - 1 === 1 ? 'y' : 'ies'}`}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        );
    }

    getActivityMessage(item) {
        const action = item?.action || '';
        const entity = item?.entity_type || '';
        const changes = item?.changes || {};
        const userEmail = this.getDisplayNameFromUser(item?.author || item?.actor);

        // Handle different activity types with detailed messages like in the image
        if (action === 'created' && entity === 'project') {
            return `${userEmail} created the project.`;
        }

        if (action === 'updated' && entity === 'project') {
            const changed = changes?.changed || {};
            const changedFields = Object.keys(changed);

            // Prefer a single most-relevant field if multiple changed
            const preference = ['priority', 'target_date', 'lead_ids', 'member_ids', 'start_date'];
            const pickedKey = preference.find((k) => changedFields.includes(k)) || changedFields[0];

            if (pickedKey === 'priority') {
                const pr = changed.priority;
                const hasFromTo = pr && typeof pr === 'object' && ('from' in pr || 'to' in pr);
                const oldPriority = hasFromTo ? (pr.from ?? 'No priority') : undefined;
                const newPriority = hasFromTo ? (pr.to ?? pr) : pr;
                if (oldPriority !== undefined) {
                    return `${userEmail} changed priority from ${oldPriority} to ${newPriority}.`;
                }
                return `${userEmail} changed priority to ${newPriority}.`;
            }

            if (pickedKey === 'target_date') {
                const td = changed.target_date;
                const hasFromTo = td && typeof td === 'object' && ('from' in td || 'to' in td);
                const fromDate = hasFromTo ? td.from : undefined;
                const toDate = hasFromTo ? td.to : td;
                if (fromDate !== undefined) {
                    return `${userEmail} changed target date from ${this.formatDate(fromDate)} to ${this.formatDate(toDate)}`;
                }
                const newFormatted = toDate ? this.formatDate(toDate) : 'N/A';
                return `${userEmail} changed target date to ${newFormatted}`;
            }

            if (pickedKey === 'lead_ids') {
                return `${userEmail} updated leads`;
            }

            if (pickedKey === 'member_ids') {
                return `${userEmail} updated members`;
            }

            if (pickedKey === 'start_date') {
                const sd = changed.start_date;
                const hasFromTo = sd && typeof sd === 'object' && ('from' in sd || 'to' in sd);
                const fromDate = hasFromTo ? sd.from : undefined;
                const toDate = hasFromTo ? sd.to : sd;
                if (fromDate !== undefined) {
                    return `${userEmail} changed start date from ${this.formatDate(fromDate)} to ${this.formatDate(toDate)}`;
                }
                const formattedDate = toDate ? this.formatDate(toDate) : 'N/A';
                return `${userEmail} set start date to ${formattedDate}`;
            }

            // Fallback
            return `${userEmail} updated the project`;
        }

        // Issue activity messages
        if (entity === 'issue') {
            // If backend supplied a message already, prefer it (caller does this), this is a fallback/formatter
            const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];
            const nameFromMilestoneId = (id) => {
                const m = milestones.find((x) => (x.id || x._id) === id);
                if (!m) return 'Milestone';
                return m.name || m.title || 'Milestone';
            };

            // Created
            if (action === 'created') {
                return `${userEmail} created the issue`;
            }

            // Updated with granular fields
            if (action === 'updated') {
                const changed = changes?.changed || {};
                const fields = Object.keys(changed);
                const pref = ['status', 'priority', 'assignee_id', 'milestone_id', 'title', 'description'];
                const key = pref.find((k) => fields.includes(k)) || fields[0];
                if (!key) return `${userEmail} updated the issue`;

                const formatFromTo = (obj, fmt = (v) => v) => {
                    const has = obj && typeof obj === 'object' && ('from' in obj || 'to' in obj);
                    if (has) return { from: fmt(obj.from), to: fmt(obj.to) };
                    return { from: undefined, to: fmt(obj) };
                };

                if (key === 'status') {
                    const { from, to } = formatFromTo(changed.status);
                    if (from !== undefined) return `${userEmail} changed status from ${from || 'Backlog'} to ${to || 'Backlog'}`;
                    return `${userEmail} changed status to ${to || 'Backlog'}`;
                }
                if (key === 'priority') {
                    const { from, to } = formatFromTo(changed.priority);
                    if (from !== undefined) return `${userEmail} changed priority from ${from || 'Medium'} to ${to || 'Medium'}`;
                    return `${userEmail} changed priority to ${to || 'Medium'}`;
                }
                if (key === 'assignee_id') {
                    const { from, to } = formatFromTo(changed.assignee_id, (v) => v ? this.getUserName(v) : 'Unassigned');
                    if (from !== undefined) return `${userEmail} changed assignee from ${from} to ${to}`;
                    return `${userEmail} changed assignee to ${to}`;
                }
                if (key === 'milestone_id') {
                    const { from, to } = formatFromTo(changed.milestone_id, (v) => v ? nameFromMilestoneId(v) : 'No milestone');
                    if (from !== undefined) return `${userEmail} changed milestone from ${from} to ${to}`;
                    return `${userEmail} changed milestone to ${to}`;
                }
                if (key === 'title') {
                    const { from, to } = formatFromTo(changed.title);
                    if (from !== undefined) return `${userEmail} changed title from "${from || ''}" to "${to || ''}"`;
                    return `${userEmail} updated title`;
                }
                if (key === 'description') {
                    return `${userEmail} updated description`;
                }
                return `${userEmail} updated the issue`;
            }

            if (action === 'status_changed') {
                const fromStatus = changes?.from || 'Backlog';
                const toStatus = changes?.to || 'Backlog';
                return `${userEmail} changed status from ${fromStatus} to ${toStatus}`;
            }

            if (action === 'commented') {
                return `${userEmail} commented`;
            }

            return `${userEmail} made changes`;
        }

        if (action === 'status_changed') {
            const fromStatus = changes?.from === 1 ? 'In Progress' : 'Paused';
            const toStatus = changes?.to === 1 ? 'In Progress' : 'Paused';
            return `${userEmail} changed status from ${fromStatus} to ${toStatus}`;
        }

        if (action === 'milestone_created') {
            const milestoneName = changes?.name || 'milestone';
            return `Milestone ${milestoneName} completed`;
        }

        if (action === 'milestone_updated') {
            return `${userEmail} updated a milestone`;
        }

        if (action === 'milestone_deleted') {
            return `${userEmail} deleted a milestone`;
        }

        if (action === 'member_added') {
            const memberName = changes?.member_name || 'member';
            return `${userEmail} added member ${memberName}`;
        }

        if (action === 'lead_changed') {
            const oldLead = changes?.old_lead || 'previous lead';
            const newLead = changes?.new_lead || 'new lead';
            return `${userEmail} changed lead from ${oldLead} to ${newLead}.`;
        }

        if (action === 'priority_set') {
            const priority = changes?.priority || 'priority';
            return `${userEmail} changed priority from No priority to ${priority}`;
        }

        if (action === 'status_set') {
            const status = changes?.status || 'status';
            return `${userEmail} changed status from Backlog to ${status}`;
        }

        return `${userEmail} made changes`;
    }

    getInitialsFromUser(user) {
        const name = this.getDisplayNameFromUser(user);
        const parts = String(name).trim().split(/\s+/);
        const first = (parts[0] || '').charAt(0).toUpperCase();
        const second = (parts[1] || '').charAt(0).toUpperCase();
        return (first + second) || (first || 'U');
    }

    // Popover-based emoji pickers: no manual reposition logic required

    attachEmojiListeners() {
        try {
            window.addEventListener('scroll', this.repositionEmojiPicker, true);
            window.addEventListener('resize', this.repositionEmojiPicker, true);
            window.addEventListener('mousedown', this.onDocumentClickCloseEmoji, true);
            window.addEventListener('keydown', this.onDocumentKeydownCloseEmoji, true);
        } catch (_) { }
    }

    detachEmojiListeners() {
        try {
            window.removeEventListener('scroll', this.repositionEmojiPicker, true);
            window.removeEventListener('resize', this.repositionEmojiPicker, true);
            window.removeEventListener('mousedown', this.onDocumentClickCloseEmoji, true);
            window.removeEventListener('keydown', this.onDocumentKeydownCloseEmoji, true);
        } catch (_) { }
    }

    computeEmojiCoords(rect, pickerWidth = 310, pickerHeight = 350) {
        try {
            const margin = 8;
            const vw = (typeof window !== 'undefined' ? window.innerWidth : 1200);
            const vh = (typeof window !== 'undefined' ? window.innerHeight : 800);
            const spaceBelow = vh - rect.bottom;
            const openBelow = spaceBelow >= pickerHeight + margin * 2;
            const top = openBelow ? (rect.bottom + margin) : Math.max(margin, rect.top - pickerHeight - margin);
            // Prefer aligning the picker's right edge with the button's right edge
            const preferredLeft = rect.right - pickerWidth;
            const left = Math.max(margin, Math.min(preferredLeft, vw - pickerWidth - margin));
            return { top, left };
        } catch (_) {
            return { top: 100, left: 100 };
        }
    }

    // Removed manual outside-click/escape handling; Popover manages it

    formatDateTime(input) {
        if (!input) return '';
        try {
            const d = new Date(input);
            if (Number.isNaN(d.getTime())) return String(input);
            return d.toLocaleString();
        } catch (_) {
            return String(input);
        }
    }

    // Formatters for milestone display
    formatDate(input) {
        if (!input) return '';
        const d = new Date(input);
        if (Number.isNaN(d.getTime())) return String(input);
        const month = d.toLocaleString('en-US', { month: 'short' });
        const day = d.getDate();
        return `${month} ${day}`;
    }

    // Display-only: dd-mm-yyyy
    formatDateDMY(input) {
        if (!input) return '';
        const str = String(input).trim();
        const iso = /^\d{4}-\d{2}-\d{2}$/;
        if (iso.test(str)) {
            const [y, m, d] = str.split('-');
            return `${d}-${m}-${y}`;
        }
        const d = new Date(str);
        if (Number.isNaN(d.getTime())) return str;
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = String(d.getFullYear());
        return `${dd}-${mm}-${yyyy}`;
    }

    // dd-mm-yyyy hh:mm AM/PM
    formatDateDMYTime(input) {
        if (!input) return '';
        try {
            const d = new Date(input);
            if (Number.isNaN(d.getTime())) return String(input);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = String(d.getFullYear());
            const hours = d.getHours();
            const h12 = hours % 12 || 12;
            const mins = String(d.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            return `${dd}-${mm}-${yyyy}, ${h12}:${mins} ${ampm}`;
        } catch (_) {
            return String(input);
        }
    }

    getMilestonePercent(m) {
        const percent = m?.percent ?? m?.progress ?? m?.progressPercent ?? m?.completion ?? null;
        if (percent == null) return null;
        const n = Number(percent);
        if (Number.isNaN(n)) return null;
        return `${Math.max(0, Math.min(100, Math.round(n)))}%`;
    }

    getMilestoneIssues(m) {
        const count = m?.issues ?? m?.issueCount ?? m?.issuesCount ?? null;
        if (count == null) return null;
        const n = Number(count);
        if (Number.isNaN(n)) return null;
        return `${n} issue${n === 1 ? '' : 's'}`;
    }

    // ----- Attachment label helpers -----
    getFileExtensionFromMeta(name, url, mime) {
        try {
            const fromName = (name || '').split('.').pop();
            if (fromName && fromName.length <= 5) return fromName.toLowerCase();
            const fromUrl = typeof url === 'string' ? (url.split('?')[0].split('#')[0].split('.').pop() || '') : '';
            if (fromUrl && fromUrl.length <= 5) return fromUrl.toLowerCase();
            if (mime && typeof mime === 'string') {
                const parts = mime.split('/');
                if (parts.length === 2) {
                    // map common mimes
                    if (parts[1] === 'pdf') return 'pdf';
                    if (parts[0] === 'image') return parts[1];
                }
            }
            return '';
        } catch (_) { return ''; }
    }

    formatAttachmentLabel(name, url, mime) {
        const projectName = ((this.state.project || {}).project_name || 'Attachment').toString().trim();
        const ext = this.getFileExtensionFromMeta(name, url, mime);
        return ext ? `${projectName}.${ext}` : projectName;
    }

    // Map file extension to icon class and color (Font Awesome)
    getAttachmentIconMeta(extRaw) {
        try {
            const ext = String(extRaw || '').toLowerCase();
            // Common office/doc types
            if (ext === 'pdf') return { cls: 'fas fa-file-pdf', color: '#A61B27' };
            if (['xlsx', 'xls'].includes(ext)) return { cls: 'fas fa-file-excel', color: '#1D6F42' };
            if (['doc', 'docx'].includes(ext)) return { cls: 'fas fa-file-word', color: '#185ABD' };
            if (['ppt', 'pptx'].includes(ext)) return { cls: 'fas fa-file-powerpoint', color: '#D24726' };
            if (['csv'].includes(ext)) return { cls: 'fas fa-file-excel', color: '#1D6F42' };
            if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return { cls: 'fas fa-file-archive', color: '#C08401' };
            if (['txt', 'log', 'md'].includes(ext)) return { cls: 'fas fa-file-alt', color: '#475569' };
            if (['json', 'xml', 'yml', 'yaml'].includes(ext)) return { cls: 'fas fa-file-code', color: '#2563eb' };
            return { cls: 'fas fa-file', color: '#475569' };
        } catch (_) {
            return { cls: 'fas fa-file', color: '#475569' };
        }
    }

    renderAttachmentChip(name, url, mime, onClick) {
        const isDark = this.isDarkMode();
        const ext = this.getFileExtensionFromMeta(name, url, mime);
        const meta = this.getAttachmentIconMeta(ext);
        return (
            <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff' }}>
                <i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />
                <Button size="small" variant="text" onClick={onClick} style={{ padding: 0, minWidth: 0, color: '#1d4ed8', fontWeight: 600, textTransform: 'none' }}>
                    {this.formatAttachmentLabel(name, url, mime)}
                </Button>
            </Box>
        );
    }

    async fetchUsers() {
        try {
            this.setState({ isLoadingUsers: true });
            const res = await AuthApi.getData();
            const list = (res && res.data) || res || [];
            const filtered = Array.isArray(list)
                ? list.filter((u) => u && Number(u.user_logged) === 1)
                : [];
            this.setState({ allUsers: filtered });
        } finally {
            this.setState({ isLoadingUsers: false });
        }
    }

    handleOpen(kind, event) {
        const isLead = this.canEditAllOverview();
        const isMember = this.canEditLimitedOverview();
        const allowedForMember = (kind === 'priority' || kind === 'start' || kind === 'target');
        if (!(isLead || (isMember && allowedForMember))) return;
        const key = `${kind}AnchorEl`;
        if (!this.state.allUsers.length && (kind === 'lead' || kind === 'members')) {
            this.fetchUsers();
        }
        this.setState({ [key]: event.currentTarget });
    }

    handleCloseAll() {
        this.setState({
            statusAnchorEl: null,
            priorityAnchorEl: null,
            leadAnchorEl: null,
            membersAnchorEl: null,
            startAnchorEl: null,
            targetAnchorEl: null,
            addMilestoneAnchorEl: null
        });
    }

    handlePendingChange(field, value) {
        this.setState({ pendingChanges: { ...this.state.pendingChanges, [field]: value } });
    }

    async saveChanges() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const updated = {
            ...current,
            status: this.state.pendingChanges.status,
            priority: this.state.pendingChanges.priority,
            lead_id: this.state.pendingChanges.lead_ids[0] || null,
            lead_ids: this.state.pendingChanges.lead_ids,
            member_ids: this.state.pendingChanges.member_ids,
            start_date: this.state.pendingChanges.start_date,
            target_date: this.state.pendingChanges.target_date
        };
        // Do not send milestones when only updating project details
        const payload = { ...updated };
        if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
            delete payload.milestones;
        }
        const res = await AuthApi.editProject(payload, id);
        if (res && res.status === true) {
            // Preserve milestones locally to avoid UI flicker/duplication
            this.setState({ project: { ...updated, milestones: current.milestones } });
        }
        this.handleCloseAll();
    }

    handleNewMilestoneChange(field, value) {
        this.setState({ newMilestone: { ...this.state.newMilestone, [field]: value } });
    }

    openAddMilestoneDialog(e) {
        if (!this.canEditAllOverview()) { this.showNotAllowed(); return; }
        this.setState({ isAddMilestoneDialogOpen: true });
    }

    closeAddMilestoneDialog() {
        this.setState({
            isAddMilestoneDialogOpen: false,
            editingMilestoneIndex: null,
            newMilestone: { name: '', description: '', due_date: '' },
            newMilestoneEditorState: EditorState.createEmpty()
        });
    }

    handleNewMilestoneEditorChange(state) {
        this.setState({ newMilestoneEditorState: state });
    }

    openEditMilestone(index) {
        if (!this.canEditAllOverview()) { this.showNotAllowed(); return; }
        const ms = (this.state.project.milestones || [])[index];
        if (!ms) return;

        let editorState = EditorState.createEmpty();
        if (ms.description) {
            // Check if it looks like HTML
            if (ms.description.trim().startsWith('<') || ms.description.indexOf('<p>') !== -1) {
                const blocksFromHtml = htmlToDraft(ms.description);
                if (blocksFromHtml) {
                    const { contentBlocks, entityMap } = blocksFromHtml;
                    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                    editorState = EditorState.createWithContent(contentState);
                }
            } else {
                // Try parsing as JSON (backward compatibility)
                try {
                    const parsed = JSON.parse(ms.description);
                    if (parsed && parsed.blocks) {
                        editorState = EditorState.createWithContent(convertFromRaw(parsed));
                    }
                } catch (e) { /* fallback to empty or plain text if needed */ }
            }
        }

        this.setState({
            editingMilestoneIndex: index,
            newMilestone: {
                name: ms.name,
                description: ms.description,
                due_date: ms.dueDate || ms.due_date || ''
            },
            newMilestoneEditorState: editorState,
            isAddMilestoneDialogOpen: true
        });
    }


    async deleteMilestone(index) {
        if (!this.canEditAllOverview()) { this.showNotAllowed(); return; }
        const willDelete = await swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this milestone?",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        });

        if (!willDelete) return;

        const current = this.state.project || {};
        const milestones = [...(current.milestones || [])];
        const milestoneToDelete = milestones[index];

        // Optimistic update
        const updatedMilestones = [...milestones];
        updatedMilestones.splice(index, 1);
        const payload = { ...current, milestones: updatedMilestones };
        this.setState({ project: payload });

        if (milestoneToDelete && milestoneToDelete.id) {
            swal({
                title: "Deleting...",
                text: "Please wait while we delete the milestone.",
                icon: "info",
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false
            });
            // If it has an ID, it exists on backend, so delete via API
            const res = await AuthApi.deleteMilestone(milestoneToDelete.id);
            if (res && res.status === true) {
                swal("Deleted!", "Milestone deleted successfully.", "success");
            } else {
                // Revert or show error if needed
                console.error("Failed to delete milestone via API");
                swal("Error!", "Failed to delete milestone.", "error");
                this.load(); // Revert to server state
            }
        } else {
            // If no ID, it might be a local draft (though likely saved via editProject before),
            // or sticking to the old 'editProject' method if ID is missing.
            // But 'saveNewMilestone' previously used 'editProject' so it should have an ID if the backend assigned one.
            // If not, we fall back to syncing the whole project list just in case.
            swal({
                title: "Deleting...",
                text: "Please wait while we delete the milestone.",
                icon: "info",
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false
            });
            const res = await AuthApi.editProject(payload, current.id);
            if (res && res.status === true) {
                swal("Deleted!", "Milestone deleted successfully.", "success");
            } else {
                swal("Error!", "Failed to delete milestone.", "error");
                this.load();
            }
        }
    }

    async saveNewMilestone() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const draft = this.state.newMilestone || {};
        if (!draft.name || String(draft.name).trim() === '') {
            // simple guard: require a name
            return;
        }
        const nextMilestone = {
            name: draft.name,
            // store rich text as HTML string to reduce payload size
            description: draftToHtml(convertToRaw(this.state.newMilestoneEditorState.getCurrentContent())),
            due_date: draft.due_date || null
        };

        const updated = { ...current };
        let newMilestones = [...(Array.isArray(current.milestones) ? current.milestones : [])];

        if (this.state.editingMilestoneIndex !== null) {
            // Update existing
            const original = newMilestones[this.state.editingMilestoneIndex];

            // Optimistic update locally
            const updatedMilestone = { ...original, ...nextMilestone };
            newMilestones[this.state.editingMilestoneIndex] = updatedMilestone;
            this.setState({
                project: { ...updated, milestones: newMilestones },
                isAddMilestoneDialogOpen: false,
                editingMilestoneIndex: null
            });

            if (original.id) {
                swal({
                    title: "Updating...",
                    text: "Please wait while we update the milestone.",
                    icon: "info",
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false
                });
                // Use dedicated update endpoint
                const res = await AuthApi.updateMilestone(original.id, nextMilestone);
                if (res && res.status === true) {
                    swal("Updated!", "Milestone updated successfully.", "success");
                    this.load();
                } else {
                    swal("Error!", "Failed to update milestone.", "error");
                    // Optionally revert optimistic update here if needed
                }
            } else {
                // Fallback to editProject if no ID
                swal({
                    title: "Updating...",
                    text: "Please wait while we update the milestone.",
                    icon: "info",
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false
                });
                const payload = { ...updated, milestones: newMilestones };
                const res = await AuthApi.editProject(payload, id);
                if (res && res.status === true) {
                    swal("Updated!", "Milestone updated successfully.", "success");
                } else {
                    swal("Error!", "Failed to update milestone.", "error");
                }
            }

        } else {
            // Append new
            newMilestones.push(nextMilestone);
            const payload = { ...updated, milestones: newMilestones };
            const res = await AuthApi.editProject(payload, id);
            if (res && res.status === true) {
                this.setState({
                    project: { ...updated, milestones: payload.milestones }, // API return usually has updated list
                    newMilestone: { name: '', description: '', due_date: '' },
                    newMilestoneEditorState: EditorState.createEmpty(),
                    isAddMilestoneDialogOpen: false,
                    editingMilestoneIndex: null
                });
            }
        }
        this.handleCloseAll();
    }

    toggleMilestone(index) {
        const current = { ...(this.state.expandedMilestones || {}) };
        current[index] = !current[index];
        this.setState({ expandedMilestones: current });
    }

    startEditDescription() {
        if (!this.canEditAllOverview()) return;
        const current = (this.state.project && this.state.project.description) || '';

        // Try to parse as JSON (rich text), fallback to plain text
        let editorState;
        try {
            const parsed = JSON.parse(current);
            if (parsed && parsed.blocks) {
                editorState = EditorState.createWithContent(convertFromRaw(parsed));
            } else {
                editorState = EditorState.createWithText(current);
            }
        } catch (e) {
            editorState = EditorState.createWithText(current);
        }

        this.setState({
            editingDescription: true,
            descriptionDraft: current,
            editorState: editorState
        });
    }

    cancelEditDescription() {
        this.setState({ editingDescription: false });
    }

    async saveDescription() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const payload = { ...current, description: JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())) };
        // Avoid sending milestones when only changing description to prevent backend duplication
        if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
            delete payload.milestones;
        }
        const res = await AuthApi.editProject(payload, id);
        if (res && res.status === true) {
            // Preserve existing milestones locally so they don't disappear until next reload
            this.setState({ project: { ...current, description: JSON.stringify(convertToRaw(this.state.editorState.getCurrentContent())), milestones: current.milestones }, editingDescription: false });
        } else {
            this.setState({ editingDescription: false });
        }
    }

    handleEditorChange = (state) => {
        this.setState({ editorState: state });
        this.setState({ descriptionDraft: state.getCurrentContent().getPlainText() });
    };

    handleKeyCommand = (command, state) => {
        const newState = RichUtils.handleKeyCommand(state, command);
        if (newState) {
            this.handleEditorChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };

    uploadImageCallBack = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new window.FileReader();
            reader.onloadend = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.readAsDataURL(file);
        });
    };

    renderDescriptionContent = (description) => {
        if (!description) return 'No description provided.';

        // If stored as DraftJS raw JSON, convert to HTML and parse to React nodes
        try {
            const parsed = JSON.parse(description);
            if (parsed && parsed.blocks) {
                const html = draftToHtml(parsed);
                return parse(html || '');
            }
        } catch (_) {
            // Not JSON; fall through
        }

        // If it already contains HTML, parse to React nodes; otherwise return as plain text
        if (typeof description === 'string' && description.indexOf('<') !== -1 && description.indexOf('>') !== -1) {
            return parse(description);
        }

        return description;
    };

    openMilestoneDate(index, event) {
        // Allow leads and members to change milestone due date
        if (!(this.canEditAllOverview() || this.canEditLimitedOverview())) return;
        const p = this.state.project || {};
        const list = Array.isArray(p.milestones) ? p.milestones : [];
        const m = list[index] || {};
        const draft = m.dueDate || m.due_date || '';
        this.setState({ editingMilestoneIndex: index, editMilestoneDateAnchorEl: event.currentTarget, milestoneDateDraft: draft });
    }

    async saveMilestoneDate() {
        const idx = this.state.editingMilestoneIndex;
        if (idx == null) {
            this.setState({ editMilestoneDateAnchorEl: null });
            return;
        }
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const list = Array.isArray(current.milestones) ? [...current.milestones] : [];
        const exist = { ...(list[idx] || {}) };
        exist.dueDate = this.state.milestoneDateDraft || null;
        list[idx] = exist;
        const updated = { ...current };
        const payload = { ...current, milestones: list };
        const res = await AuthApi.editProject(payload, id);
        if (res && res.status === true) {
            this.setState({ project: { ...updated, milestones: list } });
        }
        this.setState({ editMilestoneDateAnchorEl: null, editingMilestoneIndex: null });
    }

    startEditName() {
        if (!this.canEditAllOverview()) return;
        const current = (this.state.project && this.state.project.project_name) || '';
        this.setState({ editingName: true, nameDraft: current });
    }

    cancelEditName() {
        this.setState({ editingName: false });
    }

    async saveName() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const payload = { ...current, project_name: this.state.nameDraft };
        if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
            delete payload.milestones;
        }
        const res = await AuthApi.editProject(payload, id);
        if (res && res.status === true) {
            this.setState({ project: { ...current, project_name: this.state.nameDraft, milestones: current.milestones }, editingName: false });
        } else {
            this.setState({ editingName: false });
        }
    }

    startEditSummary() {
        if (!this.canEditAllOverview()) return;
        const current = (this.state.project && this.state.project.summary) || '';
        this.setState({ editingSummary: true, summaryDraft: current });
    }

    cancelEditSummary() {
        this.setState({ editingSummary: false });
    }

    async saveSummary() {
        const id = this.props.match && this.props.match.params && this.props.match.params.id;
        const current = this.state.project || {};
        const payload = { ...current, summary: this.state.summaryDraft };
        if (Object.prototype.hasOwnProperty.call(payload, 'milestones')) {
            delete payload.milestones;
        }
        const res = await AuthApi.editProject(payload, id);
        if (res && res.status === true) {
            this.setState({ project: { ...current, summary: this.state.summaryDraft, milestones: current.milestones }, editingSummary: false });
        } else {
            this.setState({ editingSummary: false });
        }
    }

    render() {
        const isDark = this.isDarkMode();
        const p = this.state.project || {};
        const statusValue = p.status || 'Backlog';
        const priorityValue = p.priority || 'No priority';
        const start = this.state.pendingChanges?.start_date || p.start_date || null;
        const target = this.state.pendingChanges?.target_date || p.target_date || null;
        const leads = Array.isArray(p.lead_ids) ? p.lead_ids : (p.lead_id ? [p.lead_id] : []);
        const members = Array.isArray(p.member_ids) ? p.member_ids : [];
        const leadNames = (leads || []).map((id) => this.getUserName(id)).join(', ') || 'None';
        const memberNames = (members || []).map((id) => this.getUserName(id)).join(', ') || 'None';
        const milestones = Array.isArray(p.milestones) ? p.milestones : [];

        return (
            <div>
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card style={{ marginBottom: '3%', borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Project"
                                        primaryPageLink="/project"
                                        isSecondaryPage={true}
                                        secondaryPageName={p.project_name || 'Details'} />
                                </CardContent>
                            </Card>

                            <Card style={{ marginBottom: 16, borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                                <CardContent>
                                    <Tabs
                                        value={this.state.currentTab}
                                        onChange={this.handleTabChange}
                                        aria-label="project tabs"
                                        textColor="primary"
                                        indicatorColor="primary"
                                        variant="fullWidth"
                                    >
                                        <Tab label="Overview" id={`tab-0`} aria-controls={`tabpanel-0`} style={{ textTransform: 'none', fontWeight: 600 }} />
                                        <Tab label="Issues" id={`tab-1`} aria-controls={`tabpanel-1`} style={{ textTransform: 'none', fontWeight: 600 }} />
                                    </Tabs>
                                </CardContent>
                            </Card>

                            <TabPanel value={this.state.currentTab} index={0}>
                                <Card style={{ marginBottom: 16, borderRadius: 16, boxShadow: '0 6px 18px rgba(0,0,0,0.06)', background: isDark ? '#1e1e1e' : 'linear-gradient(180deg, #ffffff 0%, #f8fbfd 100%)', border: isDark ? '1px solid #333' : '1px solid #e6eff5' }}>
                                    <CardContent style={{ padding: 24 }}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item xs={12}>
                                                {this.state.editingName ? (
                                                    <div>
                                                        <TextField
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            value={this.state.nameDraft}
                                                            onChange={(e) => this.setState({ nameDraft: e.target.value })}
                                                        />
                                                        <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                            <Button className="btn-cancel" onClick={this.cancelEditName}>Cancel</Button>
                                                            <Button className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff', boxShadow: '0 2px 6px rgba(3,109,218,0.35)' }} onClick={this.saveName}>Save</Button>
                                                        </Box>
                                                    </div>
                                                ) : (
                                                    <Typography variant="h4" align="left" style={{ marginBottom: 6, letterSpacing: 0.2, color: isDark ? '#ffffff' : '#4c545f', fontWeight: 700, cursor: this.canEditAllOverview() ? 'text' : 'default' }} onClick={this.canEditAllOverview() ? this.startEditName : this.showNotAllowed}>{p.project_name || 'Project'}</Typography>
                                                )}
                                            </Grid>
                                            <Grid item xs={12}>
                                                {this.state.editingSummary ? (
                                                    <div>
                                                        <TextField
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            value={this.state.summaryDraft}
                                                            onChange={(e) => this.setState({ summaryDraft: e.target.value })}
                                                        />
                                                        <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                            <Button className="btn-cancel" onClick={this.cancelEditSummary}>Cancel</Button>
                                                            <Button className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff', boxShadow: '0 2px 6px rgba(3,109,218,0.35)' }} onClick={this.saveSummary}>Save</Button>
                                                        </Box>
                                                    </div>
                                                ) : (
                                                    <Typography variant="body2" align="left" style={{ color: isDark ? '#b0b0b0' : '#5b6b7a', cursor: this.canEditAllOverview() ? 'text' : 'default' }} onClick={this.canEditAllOverview() ? this.startEditSummary : this.showNotAllowed}>
                                                        {p.summary || ''}
                                                    </Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                        {/* Scoped styles for Start Date hover button */}
                                        <style>{`
                                        .sd-btn-container { position: relative; display: inline-flex; align-items: center; justify-content: center; --sd-btn-color: rgb(27,126,207); --sd-duration: 250ms; }
                                        .sd-btn { position: relative; min-width: 125px; min-height: 30px; border-radius: 16px; border: none; padding: 8px 16px; background: linear-gradient(#fff2, #0001), var(--sd-btn-color); box-shadow: 1px 1px 2px -1px #fff inset, 0 2px 1px #00000010, 0 4px 2px #00000010, 0 8px 4px #00000010; transition: transform var(--sd-duration), filter var(--sd-duration); cursor: pointer; }
                                        .sd-btn-text { font-size: 13px; font-weight: 700; color: #fff; filter: drop-shadow(0 1px 0 #0002); transition: transform var(--sd-duration), filter var(--sd-duration), color var(--sd-duration); }
                                        .sd-btn-drawer { position: absolute; top: 0; left: 0; transform: translateY(0); display: flex; align-items: center; justify-content: center; min-height: 28px; border-radius: 10px 10px 0 0; border: 1px solid #0002; padding: 4px 10px; font-size: 12px; font-weight: 600; color: #f1f1f1; background: #645f5f; opacity: 0; filter: blur(2px); transition: transform calc(0.5 * var(--sd-duration)) ease, opacity calc(0.5 * var(--sd-duration)) ease, filter var(--sd-duration); pointer-events: none; white-space: nowrap; }
                                        .sd-btn-container:hover .sd-btn { transform: scale(1.05); filter: drop-shadow(0 12px 12px #0002); }
                                        .sd-btn-container:hover .sd-btn-drawer { transform: translateY(-24px); opacity: 1; filter: blur(0px); }

                                        /* EDITOR POPUP GLOBAL FIX */
                                        .editor-popup-fix {
                                            position: fixed !important;
                                            top: 50% !important;
                                            left: 50% !important;
                                            transform: translate(-50%, -50%) !important;
                                            z-index: 9999 !important;
                                            background-color: ${isDark ? '#1f2937' : '#ffffff'} !important;
                                            border: 1px solid ${isDark ? '#374151' : '#e5e7eb'} !important;
                                            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                                            padding: 24px !important;
                                            border-radius: 12px !important;
                                            width: 420px !important;
                                            max-width: 90vw !important;
                                            max-height: 80vh !important;
                                            overflow-y: auto !important;
                                        }
                                        /* Primary Action Button (Add) */
                                        .editor-popup-fix button:first-of-type,
                                        .editor-popup-fix input[type="button"]:first-of-type,
                                        .editor-popup-fix .rdw-link-modal-btn:first-child,
                                        .editor-popup-fix .rdw-embedded-modal-btn:first-child,
                                        .editor-popup-fix .rdw-image-modal-btn:first-child {
                                            background-color: #036dda !important;
                                            color: #ffffff !important;
                                            border: 1px solid #036dda !important;
                                            margin-right: 12px !important;
                                            opacity: 1 !important;
                                            background-image: none !important;
                                            text-shadow: none !important;
                                            box-shadow: none !important;
                                        }
                                        .editor-popup-fix button:first-of-type:hover,
                                        .editor-popup-fix input[type="button"]:first-of-type:hover {
                                            background-color: #155a7a !important;
                                        }

                                        /* Secondary Action Button (Cancel) */
                                        .editor-popup-fix button:last-of-type,
                                        .editor-popup-fix input[type="button"]:last-of-type,
                                        .editor-popup-fix .rdw-link-modal-btn:last-child,
                                        .editor-popup-fix .rdw-embedded-modal-btn:last-child,
                                        .editor-popup-fix .rdw-image-modal-btn:last-child {
                                            background-color: transparent !important;
                                            color: ${isDark ? '#ffffff' : '#64748b'} !important;
                                            border: 1px solid ${isDark ? '#4b5563' : '#cbd5e0'} !important;
                                            background-image: none !important;
                                            text-shadow: none !important;
                                            box-shadow: none !important;
                                        }
                                        .editor-popup-fix label {
                                            color: ${isDark ? '#e2e8f0' : '#4c545f'} !important;
                                            font-weight: 600 !important;
                                        }
                                        .editor-popup-fix input:not([type="button"]) {
                                            background-color: ${isDark ? '#374151' : '#ffffff'} !important;
                                            color: ${isDark ? '#ffffff' : '#1f2937'} !important;
                                            border: 1px solid ${isDark ? '#4b5563' : '#cbd5e0'} !important;
                                            border-radius: 6px !important;
                                            padding: 8px !important;
                                        }
                                        /* Emoji picker override if needed */
                                        .editor-popup-fix .emoji-picker-modal { position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; }
                                    `}</style>
                                        {(() => {
                                            const priorityLabel = this.state.pendingChanges.priority || priorityValue;
                                            const priorityStyles = {
                                                background: 'linear-gradient(180deg, #3b82f6 0%, #2563eb 100%)',
                                                color: '#fff',
                                                boxShadow: '0 2px 6px rgba(37,99,235,0.35)'
                                            };
                                            if (priorityLabel === 'Low') {
                                                priorityStyles.background = 'linear-gradient(180deg, #22c55e 0%, #16a34a 100%)';
                                            } else if (priorityLabel === 'Medium') {
                                                priorityStyles.background = 'linear-gradient(180deg, #fbbf24 0%, #f59e0b 100%)';
                                            } else if (priorityLabel === 'High') {
                                                priorityStyles.background = 'linear-gradient(180deg, #ef4444 0%, #dc2626 100%)';
                                            } else if (priorityLabel === 'No priority') {
                                                priorityStyles.background = 'linear-gradient(180deg, #64748b 0%, #475569 100%)';
                                            }
                                            return (




                                                <Box
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    alignItems="center"
                                                    style={{
                                                        gap: 12,
                                                        marginTop: 10
                                                    }}
                                                >

                                                    {/* PROPERTIES LABEL */}
                                                    <Box
                                                        component="span"
                                                        style={{
                                                            color: '#4c545f',
                                                            fontWeight: 800,
                                                            letterSpacing: 0.4,
                                                            fontSize: 12,
                                                            textTransform: 'uppercase',
                                                        }}
                                                    >
                                                        Properties
                                                    </Box>

                                                    {/* STATUS */}
                                                    {(() => {
                                                        const st = this.state.pendingChanges.status || statusValue;
                                                        const stStyles = {
                                                            background: 'linear-gradient(180deg, #64748b 0%, #475569 100%)',
                                                            color: '#fff',
                                                            boxShadow: '0 2px 6px rgba(100,116,139,0.35)',
                                                            borderRadius: 6,
                                                            height: 24,
                                                            padding: '0 10px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        };

                                                        if (st === 'Planned') stStyles.background = 'linear-gradient(180deg, #facc15 0%, #eab308 100%)';
                                                        if (st === 'In Progress') stStyles.background = 'linear-gradient(180deg, #3b82f6 0%, #2563eb 100%)';
                                                        if (st === 'Completed') stStyles.background = 'linear-gradient(180deg, #22c55e 0%, #16a34a 100%)';
                                                        if (st === 'Canceled') stStyles.background = 'linear-gradient(180deg, #9ca3af 0%, #6b7280 100%)';

                                                        const canClick = this.canEditAllOverview();

                                                        return (
                                                            <Tooltip title={`Status: ${st}`}>
                                                                <Chip
                                                                    label={st}
                                                                    size="small"
                                                                    onClick={(e) => canClick ? this.handleOpen('status', e) : this.showNotAllowed()}
                                                                    style={{
                                                                        ...stStyles,
                                                                        cursor: canClick ? 'pointer' : 'default',
                                                                        fontWeight: 600
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        );
                                                    })()}

                                                    {/* PRIORITY */}
                                                    <Tooltip title={`Priority: ${priorityLabel}`}>
                                                        <Chip
                                                            label={priorityLabel}
                                                            size="small"
                                                            onClick={(e) =>
                                                                (this.canEditAllOverview() || this.canEditLimitedOverview())
                                                                    ? this.handleOpen('priority', e)
                                                                    : this.showNotAllowed()
                                                            }
                                                            style={{
                                                                ...priorityStyles,
                                                                borderRadius: 6,
                                                                height: 24,
                                                                padding: "0 10px",
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                cursor: (this.canEditAllOverview() || this.canEditLimitedOverview())
                                                                    ? 'pointer' : 'default',
                                                                opacity: (this.canEditAllOverview() || this.canEditLimitedOverview()) ? 1 : 0.7,
                                                                fontWeight: 600
                                                            }}
                                                        />
                                                    </Tooltip>

                                                    {/* LEADS */}
                                                    <Tooltip title={`Leads: ${leadNames}`}>
                                                        <Box
                                                            onClick={(e) => this.canEditAllOverview() ? this.handleOpen('lead', e) : this.showNotAllowed()}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                height: 26,
                                                                padding: '0 10px',
                                                                borderRadius: 8,
                                                                cursor: this.canEditAllOverview() ? 'pointer' : 'default',
                                                                opacity: this.canEditAllOverview() ? 1 : 0.7,
                                                                background: isDark ? '#2d2d2d' : '#f8fafc',
                                                                border: isDark ? '1px solid #444' : '1px solid #cbd5e1',
                                                                gap: 8,
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                        >
                                                            <Typography variant="caption" style={{ fontWeight: 800, color: isDark ? '#94a3b8' : '#475569', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Lead</Typography>
                                                            <Box display="flex" alignItems="center">
                                                                {leads.length > 0 ? leads.slice(0, 3).map((id, idx) => {
                                                                    const initials = this.getUserName(id).slice(0, 2).toUpperCase();
                                                                    const photo = this.getUserPhoto(id);
                                                                    return (
                                                                        <Box
                                                                            key={`lead-${id}`}
                                                                            style={{
                                                                                width: 18,
                                                                                height: 18,
                                                                                borderRadius: '50%',
                                                                                overflow: 'hidden',
                                                                                marginLeft: idx === 0 ? 0 : -6,
                                                                                background: 'linear-gradient(135deg, #fda4af 0%, #f43f5e 100%)',
                                                                                border: '1.5px solid #fff',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                zIndex: 3 - idx,
                                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                            }}
                                                                        >
                                                                            {photo ? (
                                                                                <img src={photo} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                            ) : (
                                                                                <span style={{ fontSize: 8, fontWeight: 700, color: '#fff' }}>{initials}</span>
                                                                            )}
                                                                        </Box>
                                                                    );
                                                                }) : (
                                                                    <Typography variant="caption" style={{ color: '#94a3b8', fontSize: 13, fontWeight: 700 }}>+</Typography>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    </Tooltip>

                                                    {/* MEMBERS */}
                                                    <Tooltip title={`Members: ${memberNames}`}>
                                                        <Box
                                                            onClick={(e) => this.canEditAllOverview() ? this.handleOpen('members', e) : this.showNotAllowed()}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                height: 26,
                                                                padding: '0 10px',
                                                                borderRadius: 8,
                                                                cursor: this.canEditAllOverview() ? 'pointer' : 'default',
                                                                opacity: this.canEditAllOverview() ? 1 : 0.7,
                                                                background: isDark ? '#2d2d2d' : '#f8fafc',
                                                                border: isDark ? '1px solid #444' : '1px solid #cbd5e1',
                                                                gap: 8,
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                        >
                                                            <Typography variant="caption" style={{ fontWeight: 800, color: isDark ? '#94a3b8' : '#475569', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Member</Typography>
                                                            <Box display="flex" alignItems="center">
                                                                {members.length > 0 ? members.slice(0, 3).map((id, idx) => {
                                                                    const initials = this.getUserName(id).slice(0, 2).toUpperCase();
                                                                    const photo = this.getUserPhoto(id);
                                                                    return (
                                                                        <Box
                                                                            key={`mem-${id}`}
                                                                            style={{
                                                                                width: 18,
                                                                                height: 18,
                                                                                borderRadius: '50%',
                                                                                overflow: 'hidden',
                                                                                marginLeft: idx === 0 ? 0 : -6,
                                                                                background: 'linear-gradient(135deg, #e2e8f0 0%, #94a3b8 100%)',
                                                                                border: '1.5px solid #fff',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                zIndex: 3 - idx,
                                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                            }}
                                                                        >
                                                                            {photo ? (
                                                                                <img src={photo} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                            ) : (
                                                                                <span style={{ fontSize: 8, fontWeight: 700, color: '#1e293b' }}>{initials}</span>
                                                                            )}
                                                                        </Box>
                                                                    );
                                                                }) : (
                                                                    <Typography variant="caption" style={{ color: '#94a3b8', fontSize: 13, fontWeight: 700 }}>+</Typography>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    </Tooltip>

                                                    {/* START DATE (perfect center) */}
                                                    <div
                                                        onClick={(e) => (this.canEditAllOverview() || this.canEditLimitedOverview()) ? this.handleOpen('start', e) : this.showNotAllowed()}
                                                        style={{
                                                            background: '#22c55e',
                                                            borderRadius: 6,
                                                            height: 24,
                                                            padding: '0 10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: (this.canEditAllOverview() || this.canEditLimitedOverview()) ? 'pointer' : 'default',
                                                            opacity: (this.canEditAllOverview() || this.canEditLimitedOverview()) ? 1 : 0.7,
                                                            fontWeight: 600,
                                                            fontSize: 12,
                                                            color: '#fff',
                                                            lineHeight: 1
                                                        }}
                                                    >
                                                        {this.formatDateDMY(start) || 'Start'}
                                                    </div>

                                                    {/* TARGET DATE (perfect center) */}
                                                    <div
                                                        onClick={(e) => (this.canEditAllOverview() || this.canEditLimitedOverview()) ? this.handleOpen('target', e) : this.showNotAllowed()}
                                                        style={{
                                                            background: '#dc2626',
                                                            borderRadius: 6,
                                                            height: 24,
                                                            padding: '0 10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: (this.canEditAllOverview() || this.canEditLimitedOverview()) ? 'pointer' : 'default',
                                                            opacity: (this.canEditAllOverview() || this.canEditLimitedOverview()) ? 1 : 0.7,
                                                            fontWeight: 600,
                                                            fontSize: 12,
                                                            color: '#fff',
                                                            lineHeight: 1
                                                        }}
                                                    >
                                                        {this.formatDateDMY(target) || 'Target'}
                                                    </div>

                                                </Box>

                                            );
                                        })()}
                                    </CardContent>
                                </Card>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Card style={{ borderRadius: 16, boxShadow: '0 10px 28px rgba(2,6,23,0.08)', border: isDark ? '1px solid #333' : '1px solid #e6eff5', background: isDark ? '#1e1e1e' : '#ffffff' }}>
                                            <CardContent style={{ padding: 20 }}>
                                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                    <Typography variant="h6" style={{ fontWeight: 800, color: isDark ? '#ffffff' : '#0f172a', letterSpacing: 0.2 }}>Latest updates</Typography>
                                                    <Box display="flex" alignItems="center" gridGap={12}>
                                                        <Button size="small" variant="outlined" startIcon={<VisibilityOutlinedIcon />} onClick={this.openUpdatesModal} style={{ textTransform: 'none', fontWeight: 700, fontSize: 13, borderColor: isDark ? '#444' : '#e2e8f0', color: isDark ? '#b0b0b0' : '#475569' }}>See all</Button>
                                                        <Button size="small" color="primary" variant="contained" startIcon={<AddCircleOutlineIcon />} onClick={() => (this.canEditAllOverview() || this.canEditLimitedOverview()) ? this.openUpdateComposer() : this.showNotAllowed()} style={{ textTransform: 'none', fontWeight: 700, fontSize: 13, boxShadow: '0 6px 14px rgba(3,109,218,0.30)', backgroundColor: '#036dda' }}>New update</Button>
                                                    </Box>
                                                </Box>

                                                {/* Composer now shown in modal; inline composer removed */}

                                                {/* Latest item */}
                                                {this.state.isLoadingUpdates ? (
                                                    <Typography variant="body2" style={{ color: '#64748b' }}>Loading...</Typography>
                                                ) : (
                                                    <div>
                                                        {Array.isArray(this.state.updates) && this.state.updates.length > 0 ? (
                                                            <Box>
                                                                {(() => {
                                                                    const list = this.state.showAllUpdates ? this.state.updates : [this.state.updates[0]];
                                                                    return list.map((u, ui) => {
                                                                        const id = u.id || u._id;
                                                                        const status = (u.status || 'On track');
                                                                        const colorMap = { 'On track': '#16a34a', 'At risk': '#f59e0b', 'Off track': '#dc2626' };
                                                                        const dotColor = colorMap[status] || '#64748b';

                                                                        const statusStyles = { background: isDark ? '#2d2d2d' : '#f8fafc', color: isDark ? '#ffffff' : '#0f172a', border: isDark ? '1px solid #444' : '1px solid #e2e8f0' };
                                                                        const comments = Array.isArray(u.comments) ? u.comments : [];
                                                                        const { roots, byParent } = this.buildCommentIndex(comments);
                                                                        const commentsCount = comments.length;
                                                                        const authorInitials = this.getInitialsFromUser(u.author);
                                                                        return (
                                                                            <Box key={`upd-${id || ui}`}>
                                                                                {/* Header */}
                                                                                <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
                                                                                    <Box display="flex" alignItems="center" gridGap={10}>
                                                                                        {(() => {
                                                                                            const photo = this.getPhotoFromUser(u.author);
                                                                                            if (photo) {
                                                                                                return (
                                                                                                    <img src={photo} alt={this.getDisplayNameFromUser(u.author)} style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover', border: '2px solid #cbd5e1' }} />
                                                                                                );
                                                                                            }
                                                                                            return (
                                                                                                <Box style={{ width: 32, height: 32, borderRadius: '50%', background: '#e2e8f0', color: '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>
                                                                                                    {authorInitials}
                                                                                                </Box>
                                                                                            );
                                                                                        })()}
                                                                                        <Box>
                                                                                            <Box display="flex" alignItems="center" gridGap={8}>
                                                                                                <Typography variant="body2" style={{ color: isDark ? '#ffffff' : '#1f2937', fontWeight: 700 }}>{this.getDisplayNameFromUser(u.author)}</Typography>
                                                                                                <Chip icon={<FiberManualRecordIcon style={{ color: dotColor }} />} label={status} size="small" style={{ ...statusStyles, height: 22, fontSize: 11, borderRadius: 9999 }} />
                                                                                            </Box>
                                                                                            <Typography variant="caption" style={{ color: '#64748b', display: 'block', position: 'relative', left: '-49px', top: '-3px' }}>{u.created_at ? String(this.formatDateDMYTime(u.created_at)).trim() : ''}</Typography>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>

                                                                                {/* Body */}
                                                                                <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: 16, boxShadow: '0 4px 12px rgba(2,6,23,0.04)' }}>
                                                                                    <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#334155', whiteSpace: 'pre-wrap', textAlign: 'left', lineHeight: 1.55 }}>{u.text || u.message || ''}</Typography>
                                                                                </Box>

                                                                                {/* Comments header toggle */}
                                                                                {commentsCount > 0 && (
                                                                                    <Box mt={1.25} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                                                        <Box role="button" onClick={() => this.toggleComments(id)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e2e8f0', borderRadius: 9999, padding: '6px 12px', color: isDark ? '#b0b0b0' : '#475569', background: isDark ? '#2d2d2d' : '#ffffff', boxShadow: '0 2px 6px rgba(2,6,23,0.04)' }}>
                                                                                            <ChatBubbleOutlineIcon style={{ fontSize: 16, color: '#64748b', marginRight: 8 }} />
                                                                                            <span style={{ fontSize: 12, fontWeight: 600 }}>{commentsCount} comment{commentsCount !== 1 ? 's' : ''}</span>
                                                                                        </Box>
                                                                                    </Box>
                                                                                )}

                                                                                {/* Comments list */}
                                                                                {comments.length > 0 && this.state.showComments[id] === true && (
                                                                                    <Box mt={1}>
                                                                                        {roots.map((c) => this.renderComment(id, c, byParent))}
                                                                                    </Box>
                                                                                )}

                                                                                {/* Actions + composer */}
                                                                                {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                                    <Box mt={1.25} display="flex" alignItems="center" justifyContent="flex-start" gridGap={8}>
                                                                                        <Button size="small" variant="outlined" startIcon={<ChatBubbleOutlineIcon />} onClick={() => this.toggleComments(id)} style={{ textTransform: 'none', borderRadius: 9999, padding: '4px 12px', borderColor: isDark ? '#444' : '#c7d9e5', color: isDark ? '#b0b0b0' : '#4c545f' }}>Add Your Comment</Button>
                                                                                    </Box>
                                                                                )}
                                                                                {(this.canEditAllOverview() || this.canEditLimitedOverview()) && this.state.showComments[id] === true && (
                                                                                    <Box mt={1} display="flex" alignItems="flex-start" gridGap={10}>
                                                                                        {(() => {
                                                                                            const currentUser = ls.get("user") || {};
                                                                                            const currentUserPhoto = this.getPhotoFromUser(currentUser);
                                                                                            if (currentUserPhoto) {
                                                                                                return (
                                                                                                    <img src={currentUserPhoto} alt={this.getDisplayNameFromUser(currentUser)} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '2px solid #cbd5e1' }} />
                                                                                                );
                                                                                            }
                                                                                            return (
                                                                                                <Box style={{ width: 28, height: 28, borderRadius: '50%', background: '#e2e8f0', color: '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>
                                                                                                    {this.getInitialsFromUser(currentUser)}
                                                                                                </Box>
                                                                                            );
                                                                                        })()}
                                                                                        <Box flex={1}>
                                                                                            <Box
                                                                                                style={{
                                                                                                    border: '2px solid #036dda',
                                                                                                    borderRadius: 10,
                                                                                                    padding: 10,
                                                                                                    background: isDark ? '#2d2d2d' : '#ffffff',
                                                                                                    minHeight: '56px',
                                                                                                    display: 'flex',
                                                                                                    flexDirection: 'column',
                                                                                                    alignItems: 'flex-start',
                                                                                                    width: '100%'
                                                                                                }}
                                                                                            >
                                                                                                <TextField
                                                                                                    fullWidth
                                                                                                    placeholder="Write a comment..."
                                                                                                    variant="standard"
                                                                                                    InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#ffffff' : 'inherit' } }}
                                                                                                    size="small"
                                                                                                    multiline
                                                                                                    rows={2}
                                                                                                    value={(this.state.commentDrafts || {})[id] || ''}
                                                                                                    onChange={(e) => this.setCommentDraft(id, e.target.value)}
                                                                                                    style={{ background: 'none' }}
                                                                                                />
                                                                                                {(() => {
                                                                                                    const previewUrl = (this.state.commentFilePreviews || {})[id] || null;
                                                                                                    const fileObj = (this.state.commentFiles || {})[id] || null;
                                                                                                    if (!previewUrl && (!fileObj || !fileObj.name)) return null;
                                                                                                    const isImage = previewUrl != null;
                                                                                                    return (
                                                                                                        <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                                            {isImage ? (
                                                                                                                <>
                                                                                                                    <img
                                                                                                                        src={previewUrl}
                                                                                                                        alt="Preview"
                                                                                                                        style={{
                                                                                                                            maxWidth: '220px',
                                                                                                                            maxHeight: '160px',
                                                                                                                            borderRadius: 10,
                                                                                                                            border: '1px solid #e5e7eb',
                                                                                                                            objectFit: 'cover',
                                                                                                                            display: 'block',
                                                                                                                            marginLeft: 0,
                                                                                                                            marginRight: 0
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    <span
                                                                                                                        title="Remove"
                                                                                                                        onClick={() => {
                                                                                                                            this.setCommentDraftFile(id, null); // implement to clear file/preview for this id
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            position: 'absolute',
                                                                                                                            top: 2,
                                                                                                                            right: 2,
                                                                                                                            background: '#fff',
                                                                                                                            border: '1px solid #bbb',
                                                                                                                            borderRadius: '50%',
                                                                                                                            cursor: 'pointer',
                                                                                                                            width: 22,
                                                                                                                            height: 22,
                                                                                                                            display: 'flex',
                                                                                                                            alignItems: 'center',
                                                                                                                            justifyContent: 'center',
                                                                                                                            fontWeight: 700,
                                                                                                                            fontSize: 15
                                                                                                                        }}
                                                                                                                    >×</span>
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                                    {(() => { const ext = this.getFileExtensionFromMeta(fileObj.name, null, fileObj.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                                    <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(fileObj.name, fileObj.name, fileObj.type)}</span>
                                                                                                                    <span
                                                                                                                        title="Remove"
                                                                                                                        onClick={() => {
                                                                                                                            this.setCommentDraftFile(id, null); // implement to clear file/preview for this id
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            marginLeft: 6,
                                                                                                                            color: '#555',
                                                                                                                            cursor: 'pointer',
                                                                                                                            borderRadius: '50%',
                                                                                                                            border: '1px solid #bbb',
                                                                                                                            width: 18,
                                                                                                                            height: 18,
                                                                                                                            display: 'inline-flex',
                                                                                                                            alignItems: 'center',
                                                                                                                            justifyContent: 'center',
                                                                                                                            fontWeight: 700,
                                                                                                                            fontSize: 13
                                                                                                                        }}
                                                                                                                    >×</span>
                                                                                                                </Box>
                                                                                                            )}
                                                                                                        </Box>
                                                                                                    );
                                                                                                })()}
                                                                                            </Box>
                                                                                            <Box display="flex" justifyContent="flex-end" mt={1}>
                                                                                                <Box display="flex" alignItems="center" gridGap={8}>
                                                                                                    <input id={`attach-update-${id}`} type="file" style={{ display: 'none' }} onChange={(e) => this.onAttachToUpdateComment(id, null, e)} />
                                                                                                    <Button size="small" onClick={() => this.triggerAttachmentInput(`attach-update-${id}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                                                                    {/* Emoji trigger */}
                                                                                                    <Button size="small" onClick={(e) => {
                                                                                                        this.setState({
                                                                                                            showEmojiForUpdate: { ...(this.state.showEmojiForUpdate || {}), [id]: true },
                                                                                                            updateEmojiAnchorEls: { ...(this.state.updateEmojiAnchorEls || {}), [id]: e.currentTarget },
                                                                                                            activeEmojiUpdateId: id
                                                                                                        });
                                                                                                    }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                                                                    {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                                                        <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.postComment(id)}>Reply</Button>
                                                                                                    )}
                                                                                                </Box>
                                                                                            </Box>
                                                                                            {/* Emoji Picker floating panel */}
                                                                                            <Popover
                                                                                                open={Boolean((this.state.showEmojiForUpdate || {})[id])}
                                                                                                anchorEl={(this.state.updateEmojiAnchorEls || {})[id] || null}
                                                                                                onClose={() => this.setState({ showEmojiForUpdate: { ...(this.state.showEmojiForUpdate || {}), [id]: false }, activeEmojiUpdateId: null })}
                                                                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                                                PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                                                            >
                                                                                                {(() => {
                                                                                                    try {
                                                                                                        const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                                                        const onPick = (emojiData) => {
                                                                                                            const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                                                            const current = (this.state.commentDrafts || {})[id] || '';
                                                                                                            this.setCommentDraft(id, current + emoji);
                                                                                                        };
                                                                                                        return (
                                                                                                            <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                                                        );
                                                                                                    } catch (_) { return null; }
                                                                                                })()}
                                                                                            </Popover>
                                                                                        </Box>
                                                                                    </Box>
                                                                                )}
                                                                            </Box>
                                                                        );
                                                                    });
                                                                })()}
                                                            </Box>
                                                        ) : (
                                                            <Typography variant="body2" style={{ color: '#64748b' }}>No updates yet</Typography>
                                                        )}
                                                    </div>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                        <Card style={{ borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                            <CardContent style={{ padding: 20 }}>
                                                <style>{`
                                                    .project-desc-editor img {
                                                        width: 350px !important;
                                                        height: 250px !important;
                                                        object-fit: cover !important;
                                                        display: block;
                                                    }
                                                `}</style>
                                                <Box display="flex" alignItems="center" mb={2}>
                                                    <Box style={{ width: 6, height: 22, background: 'linear-gradient(180deg, #38bdf8 0%, #036dda 100%)', borderRadius: 3, marginRight: 12 }} />
                                                    <Typography variant="h6" style={{ color: isDark ? '#ffffff' : '#0f172a', fontWeight: 800, letterSpacing: 0.2 }}>Description</Typography>
                                                </Box>
                                                {this.state.editingDescription ? (
                                                    <div>
                                                        <div style={{ border: '1px solid #ccc', padding: '5px', minHeight: '200px', borderRadius: '4px' }}>
                                                            <Editor
                                                                editorState={this.state.editorState}
                                                                onEditorStateChange={this.handleEditorChange}
                                                                handleKeyCommand={this.handleKeyCommand}
                                                                editorClassName="project-desc-editor"
                                                                toolbar={{
                                                                    options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                                    inline: { inDropdown: true },
                                                                    list: { inDropdown: true },
                                                                    textAlign: { inDropdown: true },
                                                                    link: { inDropdown: true },
                                                                    history: { inDropdown: true },
                                                                    image: {
                                                                        uploadCallback: this.uploadImageCallBack,
                                                                        previewImage: true,
                                                                        alt: { present: true, mandatory: false },
                                                                        inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                                                        popupClassName: 'editor-popup-fix',
                                                                    },
                                                                    embedded: { popupClassName: 'editor-popup-fix' },
                                                                    link: { popupClassName: 'editor-popup-fix' },
                                                                    emoji: { popupClassName: 'editor-popup-fix' }
                                                                }}
                                                                placeholder="Enter description here..."
                                                                popupClassName="editor-popup-fix"
                                                            />
                                                        </div>
                                                        <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                            <Button className="btn-cancel" onClick={this.cancelEditDescription}>Cancel</Button>
                                                            <Button className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={this.saveDescription}>Save</Button>
                                                        </Box>
                                                    </div>
                                                ) : (
                                                    <Box
                                                        style={{ background: isDark ? '#2d2d2d' : '#f8fafc', border: isDark ? '1px solid #444' : '1px solid #e2e8f0', borderRadius: 8, padding: 16, minHeight: 60 }}
                                                        onClick={this.canEditAllOverview() ? this.startEditDescription : this.showNotAllowed}
                                                    >
                                                        {(() => {
                                                            const rawDesc = p.description;
                                                            try {
                                                                const parsed = JSON.parse(rawDesc || '{}');
                                                                if (parsed && parsed.blocks) {
                                                                    const viewState = EditorState.createWithContent(convertFromRaw(parsed));
                                                                    return (
                                                                        <Editor
                                                                            editorState={viewState}
                                                                            readOnly
                                                                            toolbarHidden
                                                                            editorClassName="project-desc-editor"
                                                                            editorStyle={{
                                                                                textAlign: 'left',
                                                                                color: isDark ? '#d0d0d0' : '#4c545f',
                                                                                lineHeight: 1.6,
                                                                                background: 'transparent'
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                            } catch (_) { }
                                                            return (
                                                                <Typography
                                                                    variant="body1"
                                                                    style={{ whiteSpace: 'pre-wrap', textAlign: 'left', cursor: this.canEditAllOverview() ? 'text' : 'default', color: isDark ? '#d0d0d0' : '#4c545f', lineHeight: 1.6 }}
                                                                >
                                                                    {rawDesc || 'No description provided.'}
                                                                </Typography>
                                                            );
                                                        })()}
                                                    </Box>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Card style={{ borderRadius: 16, boxShadow: '0 6px 18px rgba(0,0,0,0.06)', border: '1px solid #e6eff5' }}>
                                            <CardContent style={{ padding: 20 }}>
                                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                    <Box display="flex" alignItems="center">
                                                        <Box style={{ width: 6, height: 22, background: 'linear-gradient(180deg, #38bdf8 0%, #036dda 100%)', borderRadius: 3, marginRight: 12 }} />
                                                        <Typography variant="h6" style={{ color: isDark ? '#ffffff' : '#0f172a', fontWeight: 800, letterSpacing: 0.2 }}>Milestones</Typography>
                                                    </Box>
                                                    <Tooltip title="Add milestone from Project List modal">
                                                        <span style={{ fontSize: 12, color: '#64748b' }}></span>
                                                    </Tooltip>
                                                </Box>
                                                {milestones.length === 0 ? (
                                                    <Box style={{ background: isDark ? '#1e1e1e' : '#f8fafc', border: isDark ? '1px dashed #444' : '1px dashed #cbd5e1', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                                                        <Typography variant="body2" style={{ color: isDark ? '#b0b0b0' : '#64748b', marginBottom: 12 }}>No milestones yet</Typography>
                                                        <Box display="flex" alignItems="center" justifyContent="center" style={{ color: '#036dda', cursor: this.canEditAllOverview() ? 'pointer' : 'default', opacity: this.canEditAllOverview() ? 1 : 0.7 }} onClick={this.openAddMilestoneDialog}>
                                                            <span style={{ fontSize: 16, marginRight: 8 }}>+</span>
                                                            <span style={{ fontWeight: 600 }}>Add Milestone</span>
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <div>
                                                        {milestones.map((m, i) => {
                                                            const rawDue = m?.dueDate || m?.due_date || m?.due || m?.deadline || m?.date || null;
                                                            const due = this.formatDateDMY(rawDue);
                                                            const issuesText = this.getMilestoneIssues(m);
                                                            const percentText = this.getMilestonePercent(m);
                                                            // meta is composed inline in the right-aligned box now
                                                            const done = Boolean(m?.done || m?.completed || Number(m?.status) === 1 || Number(m?.complete) === 1);
                                                            const overdue = !done && (m?.overdue || (m?.dueDate && new Date(m.dueDate) < new Date()));
                                                            const diamondColor = done ? '#3b82f6' : (overdue ? '#ef4444' : '#94a3b8');
                                                            return (
                                                                <React.Fragment key={`ms-${i}`}>
                                                                    <Box style={{ background: isDark ? '#1e1e1e' : '#ffffff', border: isDark ? '1px solid #333' : '1px solid #e6eff5', borderRadius: 12, padding: 16, marginBottom: 12, boxShadow: '0 3px 10px rgba(2,6,23,0.04)' }}>
                                                                        <Box display="flex" alignItems="flex-start" justifyContent="space-between">
                                                                            <Box display="flex" alignItems="flex-start" gridGap={12}>
                                                                                {/* Status indicator */}
                                                                                <Box style={{ width: 12, height: 12, backgroundColor: diamondColor, borderRadius: 6, marginTop: 6, flexShrink: 0, boxShadow: '0 0 0 2px rgba(0,0,0,0.03)' }} />
                                                                                <Box flex={1}>
                                                                                    <Box display="flex" alignItems="center" gridGap={8} mb={1}>
                                                                                        <Typography variant="subtitle1" style={{ fontWeight: 700, color: isDark ? '#ffffff' : '#4c545f' }}>
                                                                                            {m?.name || m?.title || `Milestone ${i + 1}`}
                                                                                        </Typography>
                                                                                        {m?.link && (
                                                                                            <Box style={{ fontSize: 10, border: '1px solid #475569', padding: '2px 4px', borderRadius: 4, color: '#475569' }}>↗</Box>
                                                                                        )}
                                                                                        {(this.canEditAllOverview()) && (
                                                                                            <Box display="flex" gridGap={4}>
                                                                                                <IconButton size="small" onClick={() => this.openEditMilestone(i)} style={{ padding: 4 }}>
                                                                                                    <EditIcon style={{ fontSize: 16, color: isDark ? '#94a3b8' : '#64748b' }} />
                                                                                                </IconButton>
                                                                                                <IconButton size="small" onClick={() => this.deleteMilestone(i)} style={{ padding: 4 }}>
                                                                                                    <DeleteIcon style={{ fontSize: 16, color: '#ef4444' }} />
                                                                                                </IconButton>
                                                                                            </Box>
                                                                                        )}
                                                                                        <Box
                                                                                            onClick={() => this.toggleMilestone(i)}
                                                                                            style={{
                                                                                                width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                                                                border: '1px solid #cbd5e1', borderRadius: 8, cursor: 'pointer', userSelect: 'none',
                                                                                                backgroundColor: '#f8fafc', color: '#64748b'
                                                                                            }}
                                                                                        >
                                                                                            {this.state.expandedMilestones[i] ? '▾' : '▸'}
                                                                                        </Box>
                                                                                    </Box>
                                                                                    {m?.description && this.state.expandedMilestones[i] && (
                                                                                        <Typography variant="body2" style={{ color: isDark ? '#b0b0b0' : '#5b6b7a', marginTop: 8, lineHeight: 1.6, textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                                                                                            {this.renderDescriptionContent(m.description)}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Box>
                                                                            </Box>
                                                                            <Box style={{ color: '#64748b', whiteSpace: 'nowrap', textAlign: 'right' }}>
                                                                                {rawDue ? (
                                                                                    <Box
                                                                                        onClick={(e) => this.openMilestoneDate(i, e)}
                                                                                        style={{
                                                                                            cursor: 'pointer', color: '#036dda',
                                                                                            fontWeight: 700, fontSize: 13, background: '#e2f2f9', padding: '6px 10px', borderRadius: 9999, display: 'inline-block'
                                                                                        }}
                                                                                    >
                                                                                        {due}
                                                                                    </Box>
                                                                                ) : (
                                                                                    <Box
                                                                                        onClick={(e) => this.openMilestoneDate(i, e)}
                                                                                        style={{
                                                                                            cursor: 'pointer', color: '#036dda',
                                                                                            fontWeight: 700, fontSize: 13, background: '#e2f2f9', padding: '6px 10px', borderRadius: 9999, display: 'inline-block'
                                                                                        }}
                                                                                    >
                                                                                        Set due date
                                                                                    </Box>
                                                                                )}
                                                                                {issuesText || percentText ? (
                                                                                    <Typography variant="caption" style={{ color: '#94a3b8', display: 'block', marginTop: 6 }}>
                                                                                        {[issuesText, percentText].filter(Boolean).join(' · ')}
                                                                                    </Typography>
                                                                                ) : null}
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                        <Box
                                                            mt={2}
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            style={{
                                                                color: '#036dda',
                                                                cursor: this.canEditAllOverview() ? 'pointer' : 'default',
                                                                background: isDark ? '#1e1e1e' : '#f8fafc',
                                                                border: isDark ? '2px dashed #444' : '2px dashed #cbd5e1',
                                                                borderRadius: 12,
                                                                padding: 16,
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                            onClick={this.openAddMilestoneDialog}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.background = isDark ? '#2d2d2d' : '#f1f5f9';
                                                                e.target.style.borderColor = '#036dda';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.background = isDark ? '#1e1e1e' : '#f8fafc';
                                                                e.target.style.borderColor = isDark ? '#444' : '#cbd5e1';
                                                            }}
                                                        >
                                                            <span style={{ fontSize: 18, marginRight: 8, fontWeight: 600 }}>+</span>
                                                            <span style={{ fontWeight: 600 }}>Add Milestone</span>
                                                        </Box>
                                                    </div>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    {/* Resources Section */}
                                    <Grid item xs={12}>
                                        <Card style={{ borderRadius: 16, boxShadow: '0 10px 28px rgba(2,6,23,0.08)', border: isDark ? '1px solid #333' : '1px solid #e6eff5', background: isDark ? '#1e1e1e' : '#ffffff' }}>
                                            <CardContent style={{ padding: 20 }}>
                                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                    <Box display="flex" alignItems="center">
                                                        <Box style={{ width: 6, height: 22, background: 'linear-gradient(180deg, #38bdf8 0%, #036dda 100%)', borderRadius: 3, marginRight: 12 }} />
                                                        <Typography variant="h6" style={{ color: isDark ? '#ffffff' : '#0f172a', fontWeight: 800, letterSpacing: 0.2 }}>Resources</Typography>
                                                    </Box>
                                                    {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                        <Box display="flex" alignItems="center" gridGap={8}>
                                                            <input id="project-resource-file-input" type="file" style={{ display: 'none' }} onChange={this.onResourceFilePicked} />
                                                            <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff', borderRadius: 8, textTransform: 'none', boxShadow: '0 3px 10px rgba(3,109,218,0.25)' }} onClick={this.triggerFilePicker}>
                                                                Add Document
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </Box>
                                                {this.state.isLoadingResources || this.state.isUploadingResource ? (
                                                    <Typography variant="body2" style={{ color: '#64748b' }}>Loading...</Typography>
                                                ) : Array.isArray(this.state.resources) && this.state.resources.length > 0 ? (
                                                    <Box display="flex" flexWrap="wrap" gridGap={12}>
                                                        {this.state.resources.map((r) => {
                                                            const label = (r && r.title && String(r.title).trim()) ? String(r.title).trim() : 'Resource';
                                                            // Hover should match modal header logic for resources (non-comment): file_name || title
                                                            const hoverTitle = (r && (r.file_name || r.original_name))
                                                                ? String((r.file_name || r.original_name))
                                                                : ((r && r.title) ? String(r.title) : 'Resource');
                                                            // size not displayed on tile view
                                                            // const size = typeof r.size_bytes === 'number' ? r.size_bytes : null;
                                                            const url = r.public_url || r.url || '';
                                                            const mime = r.mime_type || '';
                                                            const isImg = mime.startsWith('image/') || (url && url.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                            // handled by generic ext-based icon below via extension icon mapping
                                                            // const isPdf = mime === 'application/pdf' || (url && url.toLowerCase().endsWith('.pdf'));
                                                            if (isImg) {
                                                                return (
                                                                    <Box key={`res-img-${r.id || r._id}`} title={hoverTitle} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e6eff5', borderRadius: 14, padding: 8, background: isDark ? '#2d2d2d' : '#fff', width: 100, height: 124, justifyContent: 'center', boxShadow: '0 6px 14px rgba(2,6,23,0.06)', cursor: 'pointer', transition: 'transform .12s ease, box-shadow .12s ease' }} onClick={() => this.openResourcePreview(r)} onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 10px 22px rgba(2,6,23,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }} onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 6px 14px rgba(2,6,23,0.06)'; e.currentTarget.style.transform = 'none'; }}>
                                                                        <img src={url} alt={hoverTitle || 'image-resource'} style={{ width: 84, height: 84, objectFit: 'cover', borderRadius: 10 }} />
                                                                        {(this.canEditAllOverview()) && (
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={(e) => { e.stopPropagation(); this.deleteResource(r.id || r._id); }}
                                                                                style={{ position: 'absolute', top: 8, right: 8, background: '#ffffff', border: '1px solid #ef4444', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, boxShadow: '0 2px 6px rgba(2,6,23,0.06)', color: '#ef4444' }}
                                                                            >×</span>
                                                                        )}
                                                                        <Typography variant="caption" style={{ position: 'absolute', bottom: 8, left: 8, right: 8, color: isDark ? '#d0d0d0' : '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>{label}</Typography>
                                                                    </Box>
                                                                );
                                                            }
                                                            // Non-image: render square icon by extension (like comment chips)
                                                            {
                                                                const ext = this.getFileExtensionFromMeta(r.original_name || label, url, mime);
                                                                const meta = this.getAttachmentIconMeta(ext);
                                                                return (
                                                                    <Box key={`res-file-${r.id || r._id}`} title={hoverTitle} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e6eff5', borderRadius: 14, padding: 8, background: isDark ? '#2d2d2d' : '#fff', width: 100, height: 124, justifyContent: 'center', boxShadow: '0 6px 14px rgba(2,6,23,0.06)', cursor: 'pointer', transition: 'transform .12s ease, box-shadow .12s ease' }} onClick={() => this.openResourcePreview(r)} onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 10px 22px rgba(2,6,23,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; }} onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 6px 14px rgba(2,6,23,0.06)'; e.currentTarget.style.transform = 'none'; }}>
                                                                        <i className={meta.cls} style={{ fontSize: 40, color: meta.color }} />
                                                                        {(this.canEditAllOverview()) && (
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={(e) => { e.stopPropagation(); this.deleteResource(r.id || r._id); }}
                                                                                style={{ position: 'absolute', top: 8, right: 8, background: '#ffffff', border: '1px solid #ef4444', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, boxShadow: '0 2px 6px rgba(2,6,23,0.06)', color: '#ef4444' }}
                                                                            >×</span>
                                                                        )}
                                                                        <Typography variant="caption" style={{ position: 'absolute', bottom: 8, left: 8, right: 8, color: isDark ? '#d0d0d0' : '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>{hoverTitle || label}</Typography>
                                                                    </Box>
                                                                );
                                                            }
                                                        })}
                                                    </Box>
                                                ) : (
                                                    <Typography variant="body2" style={{ color: '#64748b' }}>No resources yet</Typography>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value={this.state.currentTab} index={1}>
                                <Card style={{ borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <CardContent style={{ padding: 20 }}>
                                        {/* Top Header — Title on Left, Search + Create Button on Right */}
                                        <Box
                                            display="flex"
                                            alignItems="flex-start"
                                            justifyContent="space-between"
                                            flexWrap="wrap"
                                            mb={2}
                                            gap={2}
                                        >
                                            {/* Left: Title and Count */}
                                            <Box display="flex" alignItems="center">
                                                <Box
                                                    style={{
                                                        width: 4,
                                                        height: 20,
                                                        backgroundColor: '#036dda',
                                                        borderRadius: 2,
                                                        marginRight: 12,
                                                    }}
                                                />
                                                <Typography variant="h6" style={{ color: isDark ? '#ffffff' : '#1f2937', fontWeight: 700 }}>
                                                    Issues
                                                </Typography>
                                                <Box ml={2} style={{ color: isDark ? '#94a3b8' : '#64748b', fontSize: 13, fontWeight: 600 }}>
                                                    {(Array.isArray((this.state.project || {}).issues)
                                                        ? this.state.project.issues.length
                                                        : 0)}{' '}
                                                    total
                                                </Box>
                                            </Box>

                                            <Box display="flex" flexDirection="column" alignItems="flex-end" gap={8}>
                                                <Box display="flex" alignItems="center" sx={{ gap: '16px' }}>
                                                    <TextField
                                                        label="Search"
                                                        variant="outlined"
                                                        value={this.state.issueSearch || ''}
                                                        onChange={(e) => this.setState({ issueSearch: e.target.value })}
                                                        InputLabelProps={{
                                                            shrink: (this.state.issueSearch || '') !== "",
                                                            style: {
                                                                color: '#036dda',
                                                                transform: (this.state.issueSearch || '') !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                                                transition: 'transform 0.2s ease-in-out'
                                                            }
                                                        }}
                                                        InputProps={{
                                                            style: {
                                                                backgroundColor: 'lightgray',
                                                                borderRadius: '25px',
                                                                height: "40px",
                                                                color: '#1a202c',
                                                                width: '250px'
                                                            },
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {(this.state.issueSearch || '') && (
                                                                        <ClearIcon onClick={() => this.setState({ issueSearch: '' })} style={{ cursor: 'pointer' }} />
                                                                    )}
                                                                    <SearchIcon style={{ cursor: 'pointer' }} />
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />

                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: '#036dda',
                                                            color: '#fff',
                                                            borderRadius: 8,
                                                            textTransform: 'capitalize',
                                                            fontWeight: 600,
                                                            height: 36,
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                        onClick={this.openIssueDialog}
                                                    >
                                                        Create issue
                                                    </Button>
                                                </Box>

                                                {/* Filter Buttons */}
                                                <Box
                                                    style={{
                                                        display: 'grid',
                                                        gridAutoFlow: 'column',
                                                        gridGap: 6,
                                                        background: isDark ? '#333' : '#e5e7eb',
                                                        borderRadius: 9999,
                                                        padding: 4,
                                                        width: 'fit-content',
                                                        marginTop: 8,
                                                    }}
                                                >
                                                    {['All', 'Backlog', 'Todo', 'In Progress', 'Done', 'Canceled'].map(
                                                        (lab) => {
                                                            const active = (this.state.issueFilterStatus || 'All') === lab;
                                                            const allIssues = (this.state.project || {}).issues || [];
                                                            const count = lab === 'All'
                                                                ? allIssues.length
                                                                : allIssues.filter(i => (i.status || 'Backlog') === lab).length;

                                                            return (
                                                                <Button
                                                                    key={`flt-${lab}`}
                                                                    size="small"
                                                                    onClick={() => this.setState({ issueFilterStatus: lab })}
                                                                    style={{
                                                                        textTransform: 'none',
                                                                        borderRadius: 9999,
                                                                        fontWeight: 700,
                                                                        padding: '4px 10px',
                                                                        backgroundColor: active ? '#036dda' : 'transparent',
                                                                        color: active ? '#ffffff' : (isDark ? '#e2e8f0' : '#111827'),
                                                                    }}
                                                                >
                                                                    {lab}
                                                                    <span style={{ marginLeft: 6, opacity: 0.8, fontSize: 11 }}>({count})</span>
                                                                </Button>
                                                            );
                                                        }
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* === Issue List === */}
                                        {Array.isArray((this.state.project || {}).issues) &&
                                            this.state.project.issues.length > 0 ? (
                                            <div>
                                                {(() => {
                                                    let issues = this.state.project.issues;

                                                    // Apply search filter
                                                    const search = (this.state.issueSearch || '').trim().toLowerCase();
                                                    let filteredIssues = issues;

                                                    if (search) {
                                                        filteredIssues = issues.filter((it) =>
                                                            String(it.title || '').toLowerCase().includes(search)
                                                        );
                                                    }

                                                    // Apply status filter
                                                    const statusFilter = this.state.issueFilterStatus || 'All';
                                                    if (statusFilter !== 'All') {
                                                        filteredIssues = filteredIssues.filter(
                                                            (it) => (it.status || 'Backlog') === statusFilter
                                                        );
                                                    }

                                                    const milestones = Array.isArray(
                                                        (this.state.project || {}).milestones
                                                    )
                                                        ? this.state.project.milestones
                                                        : [];

                                                    // Group issues by milestone
                                                    const groupedIssues = {};
                                                    const unassignedIssues = [];

                                                    filteredIssues.forEach((issue) => {
                                                        const milestoneId =
                                                            issue?.milestone?.id ||
                                                            issue?.milestone?._id ||
                                                            issue?.milestone_id;
                                                        if (milestoneId) {
                                                            const milestoneIndex = milestones.findIndex(
                                                                (m) => (m.id || m._id) === milestoneId
                                                            );
                                                            const milestoneKey =
                                                                milestoneIndex >= 0 ? milestoneIndex : 'unknown';
                                                            if (!groupedIssues[milestoneKey]) {
                                                                groupedIssues[milestoneKey] = {
                                                                    milestone:
                                                                        milestoneIndex >= 0
                                                                            ? milestones[milestoneIndex]
                                                                            : { name: 'Unknown Milestone' },
                                                                    issues: [],
                                                                };
                                                            }
                                                            groupedIssues[milestoneKey].issues.push(issue);
                                                        } else {
                                                            unassignedIssues.push(issue);
                                                        }
                                                    });

                                                    const sortedMilestoneKeys = Object.keys(groupedIssues).sort(
                                                        (a, b) => {
                                                            if (a === 'unknown') return 1;
                                                            if (b === 'unknown') return -1;
                                                            return Number(a) - Number(b);
                                                        }
                                                    );

                                                    // ✅ Auto-expand milestone(s) that contain searched issue(s)
                                                    const issuesGroupExpanded = { ...this.state.issuesGroupExpanded };

                                                    if (search) {
                                                        Object.keys(groupedIssues).forEach((key) => {
                                                            issuesGroupExpanded[key] = true;
                                                        });
                                                        if (unassignedIssues.length > 0) {
                                                            issuesGroupExpanded['unassigned'] = true;
                                                        }
                                                    }

                                                    this.state.issuesGroupExpanded = issuesGroupExpanded;

                                                    return (
                                                        <div>
                                                            {filteredIssues.length === 0 && (
                                                                <Box mt={4} textAlign="center">
                                                                    <Typography variant="body1" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
                                                                        No issues for this status
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                            {/* Unassigned Issues */}
                                                            {unassignedIssues.length > 0 && (
                                                                <Box
                                                                    mb={3}
                                                                    style={{
                                                                        background: isDark ? '#1e1e1e' : '#ffffff',
                                                                        border: isDark ? '1px solid #333' : '1px solid #e2e8f0',
                                                                        borderRadius: 12,
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                                    }}
                                                                >
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        justifyContent="space-between"
                                                                        style={{
                                                                            padding: '16px 20px',
                                                                            borderBottom: isDark ? '1px solid #333' : '1px solid #e2e8f0',
                                                                            background: isDark ? '#2d2d2d' : '#f8fafc',
                                                                            borderTopLeftRadius: 12,
                                                                            borderTopRightRadius: 12,
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => this.toggleIssuesGroup('unassigned')}
                                                                    >
                                                                        <Box display="flex" alignItems="center">
                                                                            <Box
                                                                                style={{
                                                                                    width: 10,
                                                                                    height: 10,
                                                                                    backgroundColor: '#94a3b8',
                                                                                    borderRadius: '50%',
                                                                                    marginRight: 12,
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="subtitle1"
                                                                                style={{ fontWeight: 700, color: isDark ? '#e2e8f0' : '#4c545f' }}
                                                                            >
                                                                                No Milestone
                                                                            </Typography>
                                                                            <Box
                                                                                ml={2}
                                                                                style={{
                                                                                    color: '#64748b',
                                                                                    fontSize: 14,
                                                                                    fontWeight: 600,
                                                                                }}
                                                                            >
                                                                                {unassignedIssues.length} issue
                                                                                {unassignedIssues.length !== 1 ? 's' : ''}
                                                                            </Box>
                                                                        </Box>
                                                                        {this.renderGroupToggle(
                                                                            issuesGroupExpanded['unassigned'] === true,
                                                                            () => this.toggleIssuesGroup('unassigned')
                                                                        )}
                                                                    </Box>

                                                                    {issuesGroupExpanded['unassigned'] === true && (
                                                                        <Box style={{ padding: 16 }}>
                                                                            {unassignedIssues.map((it, idx) =>
                                                                                this.renderIssueCard(it, idx, 'unassigned')
                                                                            )}
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {/* Milestone Groups */}
                                                            {sortedMilestoneKeys.map((milestoneKey) => {
                                                                const group = groupedIssues[milestoneKey];
                                                                const milestone = group.milestone;
                                                                const milestoneIssues = group.issues;
                                                                const isExpanded =
                                                                    issuesGroupExpanded[String(milestoneKey)] === true;

                                                                if (milestoneIssues.length === 0) return null;

                                                                return (
                                                                    <Box
                                                                        key={`milestone-group-${milestoneKey}`}
                                                                        mb={3}
                                                                        style={{
                                                                            background: isDark ? '#1e1e1e' : '#ffffff',
                                                                            border: isDark ? '1px solid #333' : '1px solid #e2e8f0',
                                                                            borderRadius: 12,
                                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            justifyContent="space-between"
                                                                            style={{
                                                                                padding: '16px 20px',
                                                                                borderBottom: isDark ? '1px solid #333' : '1px solid #e2e8f0',
                                                                                background: isDark ? '#2d2d2d' : '#f8fafc',
                                                                                borderTopLeftRadius: 12,
                                                                                borderTopRightRadius: 12,
                                                                                cursor: 'pointer',
                                                                            }}
                                                                            onClick={() =>
                                                                                this.toggleIssuesGroup(String(milestoneKey))
                                                                            }
                                                                        >
                                                                            <Box display="flex" alignItems="center">
                                                                                <Box
                                                                                    style={{
                                                                                        width: 10,
                                                                                        height: 10,
                                                                                        backgroundColor: '#036dda',
                                                                                        borderRadius: '50%',
                                                                                        marginRight: 12,
                                                                                    }}
                                                                                />
                                                                                <Typography
                                                                                    variant="subtitle1"
                                                                                    style={{ fontWeight: 700, color: isDark ? '#e2e8f0' : '#4c545f' }}
                                                                                >
                                                                                    {milestone.name ||
                                                                                        milestone.title ||
                                                                                        `Milestone ${Number(milestoneKey) + 1}`}
                                                                                </Typography>
                                                                                <Box
                                                                                    ml={2}
                                                                                    style={{
                                                                                        color: '#64748b',
                                                                                        fontSize: 14,
                                                                                        fontWeight: 600,
                                                                                    }}
                                                                                >
                                                                                    {milestoneIssues.length} issue
                                                                                    {milestoneIssues.length !== 1 ? 's' : ''}
                                                                                </Box>
                                                                            </Box>

                                                                            {this.renderGroupToggle(isExpanded, () =>
                                                                                this.toggleIssuesGroup(String(milestoneKey))
                                                                            )}
                                                                        </Box>

                                                                        {isExpanded && (
                                                                            <Box style={{ padding: 16 }}>
                                                                                {milestoneIssues.map((it, idx) =>
                                                                                    this.renderIssueCard(it, idx, milestoneKey)
                                                                                )}
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        ) : (
                                            <Box
                                                textAlign="center"
                                                py={6}
                                                style={{
                                                    background: isDark ? '#1e1e1e' : '#f8fafc',
                                                    border: isDark ? '1px solid #333' : '1px solid #e2e8f0',
                                                    borderRadius: 12,
                                                    marginTop: 16,
                                                }}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    style={{ color: isDark ? '#b0b0b0' : '#64748b', marginBottom: 8, fontWeight: 600 }}
                                                >
                                                    No issues found
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    style={{ color: isDark ? '#94a3b8' : '#94a3b8', marginBottom: 16 }}
                                                >
                                                    Try a different search or filter
                                                </Typography>
                                            </Box>
                                        )}
                                    </CardContent>
                                </Card>
                            </TabPanel>







                        </div>
                    }
                />
                <Footer {...this.props} />

                {/* Priority Popover */}
                <Popover
                    open={Boolean(this.state.priorityAnchorEl)}
                    anchorEl={this.state.priorityAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 10, minWidth: 240, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                >
                    <Box px={2} py={1.5} style={{ fontWeight: 600, color: isDark ? '#ffffff' : '#334155' }}>Set priority</Box>
                    <Divider />
                    {['No priority', 'Low', 'Medium', 'High'].map((popt) => {
                        const selected = (this.state.pendingChanges.priority || '') === popt;
                        const colorMap = { 'No priority': '#94a3b8', Low: '#22c55e', Medium: '#f59e0b', High: '#ef4444' };
                        const dotColor = colorMap[popt] || '#94a3b8';
                        return (
                            <MenuItem key={popt} value={popt} onClick={() => this.handlePendingChange('priority', popt)} style={{ padding: '8px 12px' }}>
                                <Box display="flex" alignItems="center" width="100%">
                                    <Box mr={1} display="flex" alignItems="center">
                                        <FiberManualRecordIcon style={{ color: dotColor }} fontSize="small" />
                                    </Box>
                                    <ListItemText primary={popt} />
                                    {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                </Box>
                            </MenuItem>
                        );
                    })}
                    <Divider />
                    <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                        <Button size="small" className="btn-cancel" onClick={this.handleCloseAll}>Cancel</Button>
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Status Popover */}
                <Popover
                    open={Boolean(this.state.statusAnchorEl)}
                    anchorEl={this.state.statusAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 10, minWidth: 260, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                >
                    <Box px={2} py={1.5} style={{ fontWeight: 600, color: isDark ? '#ffffff' : '#334155' }}>Set status</Box>
                    <Divider />
                    {['Backlog', 'Planned', 'In Progress', 'Completed', 'Canceled'].map((opt) => {
                        const current = this.state.pendingChanges.status || (this.state.project || {}).status || 'Backlog';
                        const selected = current === opt;
                        const colorMap = {
                            Backlog: '#64748b',
                            Planned: '#eab308',
                            'In Progress': '#3b82f6',
                            Completed: '#22c55e',
                            Canceled: '#9ca3af'
                        };
                        const dotColor = colorMap[opt] || '#64748b';
                        return (
                            <MenuItem key={`proj-status-${opt}`} value={opt} onClick={() => this.handlePendingChange('status', opt)} style={{ padding: '8px 12px' }}>
                                <Box display="flex" alignItems="center" width="100%">
                                    <Box mr={1} display="flex" alignItems="center">
                                        <FiberManualRecordIcon style={{ color: dotColor }} fontSize="small" />
                                    </Box>
                                    <ListItemText primary={opt} />
                                    {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                </Box>
                            </MenuItem>
                        );
                    })}
                    <Divider />
                    <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                        <Button size="small" className="btn-cancel" onClick={this.handleCloseAll}>Cancel</Button>
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Leads Popover */}
                <Popover
                    open={Boolean(this.state.leadAnchorEl)}
                    anchorEl={this.state.leadAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                >
                    <Box px={2} py={1.5} style={{ color: isDark ? '#ffffff' : '#334155', fontWeight: 600 }}>Select project leads (multiple allowed)</Box>
                    <Divider />
                    {(this.state.allUsers || []).map((user) => {
                        const id = Number(user.id);
                        const current = this.state.pendingChanges.lead_ids.map(Number);
                        const selected = current.includes(id);
                        return (
                            <MenuItem key={`lead-opt-${id}`} value={id} onClick={() => {
                                const exists = current.includes(id);
                                const next = exists ? current.filter((x) => x !== id) : [...current, id];
                                this.handlePendingChange('lead_ids', next);
                            }} style={{ padding: '8px 12px' }}>
                                <Box display="flex" alignItems="center" width="100%">
                                    <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                    {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                </Box>
                            </MenuItem>
                        );
                    })}
                    <Divider />
                    <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                        <Button size="small" className="btn-cancel" onClick={this.handleCloseAll}>Cancel</Button>
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Members Popover */}
                <Popover
                    open={Boolean(this.state.membersAnchorEl)}
                    anchorEl={this.state.membersAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: '#ffffff', color: '#1a202c', borderRadius: 10, minWidth: 340, boxShadow: '0 10px 30px rgba(2,6,23,0.15)' } }}
                >
                    <Box px={2} py={1.5} style={{ color: isDark ? '#ffffff' : '#334155', fontWeight: 600 }}>Select project members</Box>
                    <Divider />
                    {(this.state.allUsers || []).map((user) => {
                        const id = Number(user.id);
                        const current = this.state.pendingChanges.member_ids.map(Number);
                        const selected = current.includes(id);
                        return (
                            <MenuItem key={`mem-opt-${id}`} value={id} onClick={() => {
                                const exists = current.includes(id);
                                const next = exists ? current.filter((x) => x !== id) : [...current, id];
                                this.handlePendingChange('member_ids', next);
                            }} style={{ padding: '8px 12px' }}>
                                <Box display="flex" alignItems="center" width="100%">
                                    <ListItemText primary={user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.name || user.email || `User ${user.id}`)} />
                                    {selected ? <CheckIcon style={{ color: '#16a34a' }} /> : null}
                                </Box>
                            </MenuItem>
                        );
                    })}
                    <Divider />
                    <Box p={1} display="flex" justifyContent="flex-end" gridGap={8}>
                        <Button size="small" className="btn-cancel" onClick={this.handleCloseAll}>Cancel</Button>
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Start Date Popover */}
                <Popover
                    open={Boolean(this.state.startAnchorEl)}
                    anchorEl={this.state.startAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 8, padding: 12 } }}
                >
                    <TextField
                        type="date"
                        variant="outlined"
                        value={this.state.pendingChanges.start_date || ''}
                        onChange={(e) => this.handlePendingChange('start_date', e.target.value)}
                        InputLabelProps={{ shrink: true, style: { color: isDark ? '#94a3b8' : 'inherit' } }}
                        style={{ background: isDark ? '#2d2d2d' : '#ffffff' }}
                        InputProps={{ style: { color: isDark ? '#e2e8f0' : 'inherit' } }}
                    />
                    <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Target Date Popover */}
                <Popover
                    open={Boolean(this.state.targetAnchorEl)}
                    anchorEl={this.state.targetAnchorEl}
                    onClose={this.handleCloseAll}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 8, padding: 12 } }}
                >
                    <TextField
                        type="date"
                        variant="outlined"
                        value={this.state.pendingChanges.target_date || ''}
                        onChange={(e) => this.handlePendingChange('target_date', e.target.value)}
                        InputLabelProps={{ shrink: true, style: { color: isDark ? '#94a3b8' : 'inherit' } }}
                        style={{ background: isDark ? '#2d2d2d' : '#ffffff' }}
                        InputProps={{ style: { color: isDark ? '#e2e8f0' : 'inherit' } }}
                        inputProps={{
                            min: this.state.pendingChanges.start_date || undefined
                        }}
                    />
                    <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button size="small" className="btn-success" onClick={this.saveChanges} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Add Milestone Dialog */}
                <Dialog open={this.state.isAddMilestoneDialogOpen} onClose={this.closeAddMilestoneDialog} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: 12 } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)',
                                color: '#ffffff',
                                padding: '12px 12px',
                                display: 'grid',
                                gridTemplateColumns: '28px 1fr 28px',
                                alignItems: 'center',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        >
                            <span />
                            <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>{this.state.editingMilestoneIndex !== null ? 'Edit Milestone' : 'Add Milestone'}</Typography>
                            <IconButton aria-label="close" onClick={this.closeAddMilestoneDialog} style={{ width: 28, height: 28, backgroundColor: '#ffffff', color: '#036dda', borderRadius: '50%', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#1e1e1e' : '#f8fafc', paddingTop: 16 }}>
                        <Box display="flex" flexDirection="column" gridGap={12}>
                            <TextField
                                label="Milestone name"
                                variant="outlined"
                                value={this.state.newMilestone.name || ''}
                                onChange={(e) => this.handleNewMilestoneChange('name', e.target.value)}
                                size="small"
                                fullWidth
                                style={{ background: isDark ? '#2d2d2d' : '#ffffff' }}
                                InputProps={{ style: { color: isDark ? '#e2e8f0' : 'inherit' } }}
                                InputLabelProps={{ style: { color: isDark ? '#94a3b8' : 'inherit' } }}
                            />
                            <Box>
                                <Typography variant="subtitle2" style={{ color: isDark ? '#94a3b8' : '#64748b', fontWeight: 600, marginBottom: 6 }}>Description</Typography>
                                <div style={{ border: isDark ? '1px solid #444' : '1px solid #ccc', padding: '5px', minHeight: '160px', borderRadius: '4px', background: isDark ? '#2d2d2d' : '#fff' }}>
                                    <Editor
                                        editorState={this.state.newMilestoneEditorState}
                                        onEditorStateChange={this.handleNewMilestoneEditorChange}
                                        handleKeyCommand={this.handleKeyCommand}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'emoji', 'remove', 'history'],
                                            inline: { inDropdown: true },
                                            list: { inDropdown: true },
                                            textAlign: { inDropdown: true },
                                            link: { inDropdown: true },
                                            emoji: { popupClassName: 'editor-popup-fix' }
                                        }}
                                        placeholder="Enter milestone description..."
                                    />
                                </div>
                            </Box>
                            <TextField
                                label="Due date"
                                type="date"
                                variant="outlined"
                                value={this.state.newMilestone.due_date || ''}
                                onChange={(e) => this.handleNewMilestoneChange('due_date', e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true, style: { color: isDark ? '#94a3b8' : 'inherit' } }}
                                style={{ background: isDark ? '#2d2d2d' : '#ffffff' }}
                                InputProps={{ style: { color: isDark ? '#e2e8f0' : 'inherit' } }}
                                inputProps={{
                                    min: (() => {
                                        const d = this.state.project && this.state.project.start_date;
                                        if (!d) return undefined;
                                        const s = String(d).split('T')[0].trim();
                                        const p = s.split(/[\.\-\/]/);
                                        if (p.length === 3) {
                                            if (p[2].length === 4) return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`; // DD-MM-YYYY -> YYYY-MM-DD
                                            if (p[0].length === 4) return `${p[0]}-${p[1].padStart(2, '0')}-${p[2].padStart(2, '0')}`; // YYYY-MM-DD -> YYYY-MM-DD
                                        }
                                        return s;
                                    })(),
                                    max: (() => {
                                        const d = this.state.project && this.state.project.target_date;
                                        if (!d) return undefined;
                                        const s = String(d).split('T')[0].trim();
                                        const p = s.split(/[\.\-\/]/);
                                        if (p.length === 3) {
                                            if (p[2].length === 4) return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
                                            if (p[0].length === 4) return `${p[0]}-${p[1].padStart(2, '0')}-${p[2].padStart(2, '0')}`;
                                        }
                                        return s;
                                    })()
                                }}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ background: isDark ? '#1e1e1e' : '#f8fafc', padding: '10px 16px' }}>
                        <Button className="btn-cancel" onClick={this.closeAddMilestoneDialog} style={{ color: isDark ? '#e2e8f0' : 'inherit' }}>Cancel</Button>
                        <Button size="small" className="btn-success" onClick={this.saveNewMilestone} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Milestone Date Popover */}
                <Popover
                    open={Boolean(this.state.editMilestoneDateAnchorEl)}
                    anchorEl={this.state.editMilestoneDateAnchorEl}
                    onClose={() => this.setState({ editMilestoneDateAnchorEl: null, editingMilestoneIndex: null })}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c', borderRadius: 8, padding: 12 } }}
                >
                    <TextField
                        type="date"
                        variant="outlined"
                        value={this.state.milestoneDateDraft || ''}
                        onChange={(e) => this.setState({ milestoneDateDraft: e.target.value })}
                        InputLabelProps={{ shrink: true, style: { color: isDark ? '#94a3b8' : 'inherit' } }}
                        style={{ background: isDark ? '#2d2d2d' : '#ffffff' }}
                        InputProps={{ style: { color: isDark ? '#e2e8f0' : 'inherit' } }}
                        inputProps={{
                            min: (() => {
                                const d = this.state.project && this.state.project.start_date;
                                if (!d) return undefined;
                                const s = String(d).split('T')[0].trim();
                                const p = s.split(/[\.\-\/]/);
                                if (p.length === 3) {
                                    if (p[2].length === 4) return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
                                    if (p[0].length === 4) return `${p[0]}-${p[1].padStart(2, '0')}-${p[2].padStart(2, '0')}`;
                                }
                                return s;
                            })(),
                            max: (() => {
                                const d = this.state.project && this.state.project.target_date;
                                if (!d) return undefined;
                                const s = String(d).split('T')[0].trim();
                                const p = s.split(/[\.\-\/]/);
                                if (p.length === 3) {
                                    if (p[2].length === 4) return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
                                    if (p[0].length === 4) return `${p[0]}-${p[1].padStart(2, '0')}-${p[2].padStart(2, '0')}`;
                                }
                                return s;
                            })()
                        }}
                    />
                    <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button size="small" className="btn-success" onClick={this.saveMilestoneDate} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </Box>
                </Popover>

                {/* Create Issue Dialog */}
                <Dialog open={this.state.isUpdatesModalOpen} onClose={this.closeUpdatesModal} fullWidth maxWidth="md" PaperProps={{ style: { borderRadius: 12 } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)',
                                color: '#ffffff',
                                padding: '12px 12px',
                                display: 'grid',
                                gridTemplateColumns: '28px 1fr 28px',
                                alignItems: 'center',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        >
                            <span />
                            <Box>
                                <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>Project activity</Typography>
                                {(() => {
                                    const total = Array.isArray(this.state.timeline) ? this.state.timeline.length : 0;
                                    const updates = Array.isArray(this.state.timeline) ? this.state.timeline.filter((x) => x.kind !== 'activity').length : 0;
                                    const activities = total - updates;
                                    return (
                                        <Typography variant="caption" style={{ color: '#e2e8f0', display: 'block', textAlign: 'center' }}>{total} items · {updates} updates · {activities} activities</Typography>
                                    );
                                })()}
                            </Box>
                            <IconButton
                                aria-label="close"
                                onClick={this.closeUpdatesModal}
                                style={{
                                    width: 28,
                                    height: 28,
                                    backgroundColor: '#ffffff',
                                    color: '#036dda',
                                    borderRadius: '50%',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                            >
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#121212' : '#f8fafc', paddingTop: 16, maxHeight: '70vh', overflowY: 'auto' }}>
                        {/* Activity & Comments Tabs for Project Activity Modal */}
                        <Box mb={1.5} display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle2" style={{ color: isDark ? '#ffffff' : '#111827', fontWeight: 700 }}>{(this.state.updatesModalActiveTab || 'activity') === 'activity' ? 'Activity' : 'Comments'}</Typography>
                            <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, background: isDark ? '#2d2d2d' : '#e5e7eb', borderRadius: 9999, padding: 4 }}>
                                {(() => {
                                    const active = this.state.updatesModalActiveTab || 'activity';
                                    return (
                                        <>
                                            <Button
                                                size="small"
                                                disableElevation
                                                aria-label="Show Activity"
                                                onClick={() => this.setState({ updatesModalActiveTab: 'activity' })}
                                                style={{
                                                    textTransform: 'none',
                                                    borderRadius: 9999,
                                                    fontWeight: 700,
                                                    padding: '4px 12px',
                                                    backgroundColor: active === 'activity' ? '#036dda' : 'transparent',
                                                    color: active === 'activity' ? '#ffffff' : (isDark ? '#b0b0b0' : '#111827'),
                                                }}
                                            >
                                                Activity
                                            </Button>
                                            <Button
                                                size="small"
                                                disableElevation
                                                aria-label="Show Comments"
                                                onClick={() => this.setState({ updatesModalActiveTab: 'comments' })}
                                                style={{
                                                    textTransform: 'none',
                                                    borderRadius: 9999,
                                                    fontWeight: 700,
                                                    padding: '4px 12px',
                                                    backgroundColor: active === 'comments' ? '#036dda' : 'transparent',
                                                    color: active === 'comments' ? '#ffffff' : (isDark ? '#b0b0b0' : '#111827'),
                                                }}
                                            >
                                                Comments
                                            </Button>
                                        </>
                                    );
                                })()}
                            </Box>
                        </Box>
                        {Array.isArray(this.state.timeline) && this.state.timeline.length > 0 ? (
                            <Box>
                                {(() => {
                                    const active = this.state.updatesModalActiveTab || 'activity';
                                    const allItems = this.state.timeline;

                                    // Filter first, then slice
                                    const filteredItems = active === 'activity'
                                        ? allItems.filter(it => it.kind === 'activity')
                                        : allItems.filter(it => it.kind !== 'activity');

                                    const visibleItems = this.state.showAllTimeline
                                        ? filteredItems
                                        : filteredItems.slice(0, 10);

                                    if (filteredItems.length === 0) {
                                        return (
                                            <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>
                                                {active === 'activity' ? 'No activity yet' : 'No comments yet'}
                                            </Typography>
                                        );
                                    }

                                    return (
                                        <>
                                            {visibleItems.map((it, ui) => {
                                                if (active === 'activity') {
                                                    const actor = it.author || {};
                                                    const photo = this.getPhotoFromUser(actor);
                                                    const initials = this.getInitialsFromUser(actor);
                                                    const msg = it.message || this.getActivityMessage(it);
                                                    return (
                                                        <Box key={`tl-${it.kind}-${it.id || ui}`} mb={1.5} style={{ background: isDark ? '#1e1e1e' : '#ffffff', border: isDark ? '1px solid #333' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                                            <Box display="flex" alignItems="flex-start" gridGap={10}>
                                                                {photo ? (
                                                                    <img src={photo} alt={this.getDisplayNameFromUser(actor)} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                                ) : (
                                                                    <Box style={{ width: 28, height: 28, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initials}</Box>
                                                                )}
                                                                <Box flex={1}>
                                                                    <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f' }}>
                                                                        <strong style={{ color: isDark ? '#ffffff' : 'inherit' }}>{this.getDisplayNameFromUser(actor)}</strong> {msg}
                                                                    </Typography>
                                                                    <Typography variant="caption" style={{ color: '#64748b' }}>{this.formatDateDMYTime(it.created_at)}</Typography>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    );
                                                } else {
                                                    // Comments tab
                                                    const item = it;
                                                    const id = item.id || item._id || ui;
                                                    const status = (item.status || 'On track');
                                                    const statusStyles = { background: '#64748b', color: '#fff' };
                                                    if (status === 'On track') statusStyles.background = '#16a34a';
                                                    if (status === 'At risk') statusStyles.background = '#f59e0b';
                                                    if (status === 'Off track') statusStyles.background = '#dc2626';
                                                    const photo = this.getPhotoFromUser(item.author);
                                                    const comments = Array.isArray(item.comments) ? item.comments : [];
                                                    const { roots, byParent } = this.buildCommentIndex(comments);
                                                    const hasComments = roots.length > 0;
                                                    return (
                                                        <Box key={`activity-comments-${id}`} mb={1.5} style={{ background: isDark ? '#1e1e1e' : '#ffffff', border: isDark ? '1px solid #333' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                                            <Box display="flex" gridGap={10} alignItems="flex-start">
                                                                {photo ? (
                                                                    <img src={photo} alt={this.getDisplayNameFromUser(item.author)} style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                                ) : (
                                                                    <Box style={{ width: 28, height: 28, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>
                                                                        {this.getInitialsFromUser(item.author)}
                                                                    </Box>
                                                                )}
                                                                <Box flex={1}>
                                                                    <Box display="flex" alignItems="center" gridGap={8}>
                                                                        <Typography variant="body2" style={{ color: isDark ? '#ffffff' : '#4c545f', fontWeight: 600 }}>{this.getDisplayNameFromUser(item.author)}</Typography>
                                                                        <Chip label={status} size="small" style={{ ...statusStyles, height: 20, fontSize: 11 }} />
                                                                        <Typography variant="caption" style={{ color: '#64748b' }}>{item.created_at ? this.formatDateDMYTime(item.created_at) : ''}</Typography>
                                                                    </Box>
                                                                    <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f', marginTop: 4, whiteSpace: 'pre-wrap' }}>{item.text || item.message || ''}</Typography>
                                                                    <Box mt={1}>
                                                                        {hasComments ? (
                                                                            roots.map((c) => this.renderComment(id, c, byParent))
                                                                        ) : (
                                                                            <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>No comments</Typography>
                                                                        )}
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    );
                                                }
                                            })}

                                            {filteredItems.length > 10 && (
                                                <Box mt={2} textAlign="center">
                                                    <Button
                                                        variant="outlined"
                                                        onClick={this.toggleShowAllTimeline}
                                                        style={{
                                                            borderRadius: 8,
                                                            textTransform: 'none',
                                                            fontWeight: 600,
                                                            borderColor: '#036dda',
                                                            color: '#036dda'
                                                        }}
                                                    >
                                                        {this.state.showAllTimeline
                                                            ? 'Show less'
                                                            : `Show ${filteredItems.length - 10} more ${active === 'activity' ? 'activities' : 'updates'}`
                                                        }
                                                    </Button>
                                                </Box>
                                            )}
                                        </>
                                    );
                                })()}
                            </Box>
                        ) : (
                            <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>No activity yet</Typography>
                        )}
                    </DialogContent>
                    {/* <DialogActions style={{ background: '#f8fafc', padding: '10px 16px' }}>
                        <Button onClick={this.closeUpdatesModal} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Close</Button>
                    </DialogActions> */}
                </Dialog>
                {/* Resource Preview Dialog */}
                <Dialog open={this.state.isResourcePreviewOpen} onClose={this.closeResourcePreview} fullWidth maxWidth="md" PaperProps={{ style: { borderRadius: 12 } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box style={{ background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)', color: '#ffffff', padding: '12px 12px', display: 'grid', gridTemplateColumns: '28px 1fr 28px', alignItems: 'center', borderTopLeftRadius: 12, borderTopRightRadius: 12 }}>
                            <span />
                            <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>{(() => { const pr = this.state.previewResource || {}; return pr._fromComment ? (pr.title || pr.file_name || 'Preview') : (pr.file_name || pr.title || 'Preview'); })()}</Typography>
                            <IconButton aria-label="close" onClick={this.closeResourcePreview} style={{ width: 28, height: 28, backgroundColor: '#ffffff', color: '#036dda', borderRadius: '50%', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}>
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#1e1e1e' : '#f8fafc', paddingTop: 16 }}>
                        {(() => {
                            const href = (this.state.previewResource && this.state.previewResource.href) || '';
                            const mime = (this.state.previewResource && this.state.previewResource.mime) || '';
                            if (!href) {
                                return <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>No preview available</Typography>;
                            }
                            const isImage = mime.startsWith('image/');
                            const isPdf = mime === 'application/pdf' || href.toLowerCase().endsWith('.pdf');
                            if (isImage) {
                                return (
                                    <Box display="flex" justifyContent="center">
                                        <img src={href} alt={this.state.previewResource?.title || 'Resource'} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8, border: isDark ? '1px solid #444' : '1px solid #e5e7eb' }} />
                                    </Box>
                                );
                            }
                            if (isPdf) {
                                return (
                                    <Box>
                                        <iframe title="resource-preview" src={href} style={{ width: '100%', height: '70vh', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 8 }} />
                                    </Box>
                                );
                            }
                            return (
                                <Box>
                                    <Typography variant="body2" style={{ color: isDark ? '#94a3b8' : '#64748b', marginBottom: 8 }}>Preview not supported. You can open the file in a new tab.</Typography>
                                    <Button variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}>Open in new tab</Button>
                                </Box>
                            );
                        })()}
                    </DialogContent>
                </Dialog>
                {/* New Update Modal */}
                <Dialog open={this.state.updateComposer.open} onClose={this.closeUpdateComposer} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: 12, backgroundColor: isDark ? '#2d2d2d' : '#ffffff' } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)',
                                color: '#ffffff',
                                padding: '12px 12px',
                                display: 'grid',
                                gridTemplateColumns: '28px 1fr 28px',
                                alignItems: 'center',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        >
                            <span />
                            <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>New project update</Typography>
                            <IconButton
                                aria-label="close"
                                onClick={this.closeUpdateComposer}
                                style={{
                                    width: 28,
                                    height: 28,
                                    backgroundColor: '#ffffff',
                                    color: '#036dda',
                                    borderRadius: '50%',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                            >
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#2d2d2d' : '#f8fafc', paddingTop: 16 }}>
                        <Box mb={1}>
                            {(() => {
                                const cur = (this.state.updateComposer.status || 'On track');
                                const mkBtn = (label, color) => {
                                    const selected = cur === label;
                                    const baseStyle = selected
                                        ? { backgroundColor: color, color: '#fff', borderColor: color }
                                        : { backgroundColor: '#fff', color: color, borderColor: color };
                                    return (
                                        <Button key={label} size="small" variant={selected ? 'contained' : 'outlined'} onClick={() => this.setState({ updateComposer: { ...this.state.updateComposer, status: label } })} style={{ marginRight: 6, ...baseStyle }}>
                                            {label}
                                        </Button>
                                    );
                                };
                                return (
                                    <>
                                        {mkBtn('On track', '#16a34a')}
                                        {mkBtn('At risk', '#f59e0b')}
                                        {mkBtn('Off track', '#dc2626')}
                                    </>
                                );
                            })()}
                        </Box>
                        <TextField
                            fullWidth
                            placeholder="Share an update..."
                            variant="outlined"
                            multiline
                            rows={4}
                            value={this.state.updateComposer.text}
                            onChange={(e) => this.setState({ updateComposer: { ...this.state.updateComposer, text: e.target.value } })}
                        />
                    </DialogContent>
                    <DialogActions style={{ background: isDark ? '#1e1e1e' : '#f8fafc', padding: '10px 16px' }}>
                        <Button className="btn-cancel" onClick={this.closeUpdateComposer}>Cancel</Button>
                        <Button variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={this.postProjectUpdate}>Post update</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.isIssueDialogOpen} onClose={this.closeIssueDialog} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: 12 } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)',
                                color: '#ffffff',
                                padding: '12px 12px',
                                display: 'grid',
                                gridTemplateColumns: '28px 1fr 28px',
                                alignItems: 'center',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        >
                            <span />
                            <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>Create Issue</Typography>
                            <IconButton
                                aria-label="close"
                                onClick={this.closeIssueDialog}
                                style={{
                                    width: 28,
                                    height: 28,
                                    backgroundColor: '#ffffff',
                                    color: '#036dda',
                                    borderRadius: '50%',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                            >
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#1e1e1e' : '#f8fafc', paddingTop: 16 }}>
                        <Box display="flex" flexDirection="column" gridGap={16}>
                            {/* Details */}
                            <Box>
                                <Typography variant="subtitle2" style={{ color: isDark ? '#94a3b8' : '#64748b', fontWeight: 600, marginBottom: 6 }}>Details</Typography>
                                <Box display="flex" flexDirection="column" gridGap={12}>
                                    <TextField
                                        label="Title"
                                        variant="outlined"
                                        value={this.state.issueDraft.title}
                                        onChange={(e) => this.handleIssueDraftChange('title', e.target.value)}
                                        fullWidth
                                        size="small"
                                    />
                                    <Box>
                                        <Typography variant="subtitle2" style={{ color: isDark ? '#94a3b8' : '#64748b', fontWeight: 600, marginBottom: 6 }}>Description</Typography>
                                        <div style={{ border: isDark ? '1px solid #444' : '1px solid #ccc', padding: '5px', minHeight: '140px', borderRadius: '4px', background: isDark ? '#2d2d2d' : '#fff' }}>
                                            <Editor
                                                editorState={this.state.issueEditorState}
                                                onEditorStateChange={this.handleIssueEditorChange}
                                                handleKeyCommand={this.handleKeyCommand}
                                                toolbar={{
                                                    options: ['inline', 'list', 'textAlign', 'link', 'emoji', 'remove', 'history'],
                                                    inline: { inDropdown: true },
                                                    list: { inDropdown: true },
                                                    textAlign: { inDropdown: true },
                                                    link: { inDropdown: true }
                                                }}
                                                placeholder="Add a description"
                                            />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                            <Divider />
                            {/* Properties */}
                            {(() => {
                                const status = this.state.issueDraft.status || 'Backlog';
                                const priority = this.state.issueDraft.priority || 'Medium';
                                const assigneeId = this.state.issueDraft.assigneeId || '';
                                const milestoneIndex = this.state.issueDraft.milestoneIndex;
                                const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];

                                const statusStyles = { background: '#64748b', color: '#fff' };
                                if (status === 'Backlog') statusStyles.background = '#64748b';
                                if (status === 'Todo') statusStyles.background = '#9ca3af';
                                if (status === 'In Progress') statusStyles.background = '#2563eb';
                                if (status === 'Done') statusStyles.background = '#16a34a';
                                if (status === 'Canceled') statusStyles.background = '#6b7280';
                                if (status === 'Duplicate') statusStyles.background = '#94a3b8';

                                const priorityStyles = { background: '#475569', color: '#fff' };
                                if (priority === 'Low') priorityStyles.background = '#16a34a';
                                if (priority === 'Medium') priorityStyles.background = '#f59e0b';
                                if (priority === 'High') priorityStyles.background = '#dc2626';

                                const assigneeName = assigneeId ? this.getUserName(assigneeId) : 'Assignee';
                                const milestoneName = milestoneIndex !== '' && milestoneIndex != null
                                    ? (milestones[milestoneIndex]?.name || milestones[milestoneIndex]?.title || `Milestone ${Number(milestoneIndex) + 1}`)
                                    : 'Milestone';

                                return (
                                    <Box>
                                        <Typography variant="subtitle2" style={{ color: '#64748b', fontWeight: 600, marginBottom: 6 }}>Properties</Typography>
                                        <Box display="flex" flexWrap="wrap" gridGap={8} alignItems="center">
                                            <Tooltip title={`Status: ${status}`}>
                                                <Chip label={status} size="small" onClick={(e) => this.openIssueMenu('status', e)} style={{ ...statusStyles, cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Priority: ${priority}`}>
                                                <Chip label={priority} size="small" onClick={(e) => this.openIssueMenu('priority', e)} style={{ ...priorityStyles, cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Assignee`}>
                                                <Chip label={assigneeName} size="small" onClick={(e) => this.openIssueMenu('assignee', e)} style={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Milestone`}>
                                                <Chip label={milestoneName} size="small" onClick={(e) => this.openIssueMenu('milestone', e)} style={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                );
                            })()}
                            <Divider />
                            {/* Sub-issues */}
                            <Box>
                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                    <Typography variant="subtitle2" style={{ color: '#64748b', fontWeight: 600 }}>Sub-issues</Typography>
                                    <Button size="small" variant="outlined" onClick={this.addSubIssue} style={{ textTransform: 'capitalize' }}>Add sub-issue</Button>
                                </Box>
                                <Box display="flex" flexDirection="column" gridGap={12}>
                                    {(Array.isArray(this.state.issueDraft.subIssues) ? this.state.issueDraft.subIssues : []).map((s, i) => {
                                        const status = s.status || 'Backlog';
                                        const priority = s.priority || 'Medium';
                                        const assigneeId = s.assigneeId || '';
                                        const milestoneIndex = s.milestoneIndex;
                                        const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];
                                        const statusStyles = { background: '#64748b', color: '#fff' };
                                        if (status === 'Backlog') statusStyles.background = '#64748b';
                                        if (status === 'Todo') statusStyles.background = '#9ca3af';
                                        if (status === 'In Progress') statusStyles.background = '#2563eb';
                                        if (status === 'Done') statusStyles.background = '#16a34a';
                                        if (status === 'Canceled') statusStyles.background = '#6b7280';
                                        if (status === 'Duplicate') statusStyles.background = '#94a3b8';
                                        const priorityStyles = { background: '#475569', color: '#fff' };
                                        if (priority === 'Low') priorityStyles.background = '#16a34a';
                                        if (priority === 'Medium') priorityStyles.background = '#f59e0b';
                                        if (priority === 'High') priorityStyles.background = '#dc2626';
                                        const assigneeName = assigneeId ? this.getUserName(assigneeId) : 'Assignee';
                                        const milestoneName = milestoneIndex !== '' && milestoneIndex != null
                                            ? (milestones[milestoneIndex]?.name || milestones[milestoneIndex]?.title || `Milestone ${Number(milestoneIndex) + 1}`)
                                            : 'Milestone';
                                        return (
                                            <Box key={`sub-${i}`} style={{ border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 8, padding: 12, background: isDark ? '#1e1e1e' : '#ffffff' }}>
                                                <Box display="flex" alignItems="center" gridGap={8}>
                                                    {(this.state.editingSubIssueTitles || {})[String(i)] ? (
                                                        <TextField
                                                            placeholder={`Sub-issue ${i + 1}`}
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            value={s.title || ''}
                                                            onChange={(e) => this.updateSubIssueTitle(i, e.target.value)}
                                                        />
                                                    ) : (
                                                        <Box
                                                            onClick={() => this.setState({ editingSubIssueTitles: { ...(this.state.editingSubIssueTitles || {}), [String(i)]: true } })}
                                                            style={{
                                                                border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                                borderRadius: 6,
                                                                padding: '8px 10px',
                                                                background: isDark ? '#2d2d2d' : '#ffffff',
                                                                cursor: 'text',
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#111827' }}>
                                                                {s.title || `Click to add sub-issue ${i + 1} title`}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    <Button size="small" onClick={() => this.removeEditSubIssue(i)}>Remove</Button>
                                                </Box>
                                                <Box mt={1} />
                                                <Box>
                                                    <Typography variant="caption" style={{ color: '#64748b' }}>Description</Typography>
                                                    {(this.state.editingSubIssueDescriptions || {})[String(s._tmpIndex || '')] ? (
                                                        <div style={{ border: isDark ? '1px solid #444' : '1px solid #e5e7eb', padding: 5, minHeight: 100, borderRadius: 6, background: isDark ? '#2d2d2d' : '#fff' }}>
                                                            <Editor
                                                                editorState={(this.state.subIssueEditorStates || {})[String(s._tmpIndex || '')] || EditorState.createEmpty()}
                                                                onEditorStateChange={(st) => this.handleSubIssueEditorChange(s._tmpIndex, st)}
                                                                handleKeyCommand={this.handleKeyCommand}
                                                                toolbar={{ options: ['inline', 'list', 'emoji', 'remove', 'history'], inline: { inDropdown: true }, list: { inDropdown: true } }}
                                                                placeholder="Add description..."
                                                            />
                                                        </div>
                                                    ) : (
                                                        <Box
                                                            onClick={() => this.setState({ editingSubIssueDescriptions: { ...(this.state.editingSubIssueDescriptions || {}), [String(s._tmpIndex || '')]: true } })}
                                                            style={{
                                                                border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                                borderRadius: 6,
                                                                padding: 10,
                                                                background: isDark ? '#2d2d2d' : '#ffffff',
                                                                minHeight: 56,
                                                                textAlign: 'left',
                                                                cursor: 'text'
                                                            }}
                                                        >
                                                            {(() => {
                                                                const st = (this.state.subIssueEditorStates || {})[String(s._tmpIndex || '')] || EditorState.createEmpty();
                                                                const raw = convertToRaw(st.getCurrentContent());
                                                                const html = draftToHtml(raw);
                                                                const hasContent = (raw.blocks || []).some(b => b.text && b.text.trim().length > 0);
                                                                if (!hasContent) return (
                                                                    <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#111827' }}>Click to add description</Typography>
                                                                );
                                                                return (
                                                                    <div style={{ color: isDark ? '#e2e8f0' : '#111827' }}>{parse(html)}</div>
                                                                );
                                                            })()}
                                                        </Box>
                                                    )}
                                                </Box>
                                                <Box mt={1} display="flex" flexWrap="wrap" gridGap={8} alignItems="center">
                                                    <Tooltip title={`Status: ${status}`}>
                                                        <Chip label={status} size="small" onClick={(e) => this.openSubDetailMenu('status', i, e)} style={{ ...statusStyles, cursor: 'pointer' }} />
                                                    </Tooltip>
                                                    <Tooltip title={`Priority: ${priority}`}>
                                                        <Chip label={priority} size="small" onClick={(e) => this.openSubDetailMenu('priority', i, e)} style={{ ...priorityStyles, cursor: 'pointer' }} />
                                                    </Tooltip>
                                                    <Tooltip title={`Assignee`}>
                                                        <Chip label={assigneeName} size="small" onClick={(e) => this.openSubDetailMenu('assignee', i, e)} style={{ cursor: 'pointer' }} />
                                                    </Tooltip>
                                                    <Tooltip title={`Milestone`}>
                                                        <Chip label={milestoneName} size="small" onClick={(e) => this.openSubDetailMenu('milestone', i, e)} style={{ cursor: 'pointer' }} />
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ background: isDark ? '#1e1e1e' : '#f8fafc', padding: '10px 16px' }}>
                        <Button className="btn-cancel" onClick={this.closeIssueDialog} style={{ textTransform: 'capitalize' }}>Cancel</Button>
                        <Button onClick={this.saveIssue} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff', textTransform: 'capitalize' }}>Create</Button>
                    </DialogActions>
                </Dialog>
                {/* Issue Menus for chips */}
                <Menu
                    anchorEl={this.state.issueMenus.statusAnchor}
                    open={Boolean(this.state.issueMenus.statusAnchor)}
                    onClose={this.closeIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Backlog', 'Todo', 'In Progress', 'Done', 'Canceled', 'Duplicate'].map((opt) => (
                        <MenuItem key={`status-${opt}`} onClick={() => { this.handleIssueDraftChange('status', opt); this.closeIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                {/* Menus for Issue Detail chips */}
                <Menu
                    anchorEl={this.state.detailMenus.statusAnchor}
                    open={Boolean(this.state.detailMenus.statusAnchor)}
                    onClose={this.closeDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Backlog', 'Todo', 'In Progress', 'Done', 'Canceled', 'Duplicate'].map((opt) => (
                        <MenuItem key={`det-stat-${opt}`} onClick={() => { this.handleEditIssueChange('status', opt); this.closeDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.detailMenus.priorityAnchor}
                    open={Boolean(this.state.detailMenus.priorityAnchor)}
                    onClose={this.closeDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 200 } }}
                >
                    {['Low', 'Medium', 'High'].map((opt) => (
                        <MenuItem key={`det-pri-${opt}`} onClick={() => { this.handleEditIssueChange('priority', opt); this.closeDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.detailMenus.assigneeAnchor}
                    open={Boolean(this.state.detailMenus.assigneeAnchor)}
                    onClose={this.closeDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {(this.state.allUsers || []).map((u) => (
                        <MenuItem key={`det-ass-${u.id}`} onClick={() => { this.handleEditIssueChange('assigneeId', u.id); this.closeDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)}</span>
                        </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => { this.handleEditIssueChange('assigneeId', ''); this.closeDetailMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'Unassigned'}</span>
                    </MenuItem>
                </Menu>
                <Menu
                    anchorEl={this.state.detailMenus.milestoneAnchor}
                    open={Boolean(this.state.detailMenus.milestoneAnchor)}
                    onClose={this.closeDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    <MenuItem onClick={() => { this.handleEditIssueChange('milestoneIndex', ''); this.closeDetailMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'No milestone'}</span>
                    </MenuItem>
                    {((Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [])).map((m, i) => (
                        <MenuItem key={`det-ms-${i}`} onClick={() => { this.handleEditIssueChange('milestoneIndex', String(i)); this.closeDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{m?.name || m?.title || `Milestone ${i + 1}`}</span>
                        </MenuItem>
                    ))}
                </Menu>
                {/* Sub-issue menus inside Issue Detail */}
                <Menu
                    anchorEl={this.state.subDetailMenus.statusAnchor}
                    open={Boolean(this.state.subDetailMenus.statusAnchor)}
                    onClose={this.closeSubDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Backlog', 'Todo', 'In Progress', 'Done', 'Canceled', 'Duplicate'].map((opt) => (
                        <MenuItem key={`det-sub-stat-${opt}`} onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'status', opt); } this.closeSubDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.subDetailMenus.priorityAnchor}
                    open={Boolean(this.state.subDetailMenus.priorityAnchor)}
                    onClose={this.closeSubDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Low', 'Medium', 'High'].map((opt) => (
                        <MenuItem key={`det-sub-pri-${opt}`} onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'priority', opt); } this.closeSubDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.subDetailMenus.assigneeAnchor}
                    open={Boolean(this.state.subDetailMenus.assigneeAnchor)}
                    onClose={this.closeSubDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {(this.state.allUsers || []).map((u) => (
                        <MenuItem key={`det-sub-ass-${u.id}`} onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'assigneeId', u.id); } this.closeSubDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)}</span>
                        </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'assigneeId', ''); } this.closeSubDetailMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'Unassigned'}</span>
                    </MenuItem>
                </Menu>
                <Menu
                    anchorEl={this.state.subDetailMenus.milestoneAnchor}
                    open={Boolean(this.state.subDetailMenus.milestoneAnchor)}
                    onClose={this.closeSubDetailMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    <MenuItem onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'milestoneIndex', ''); } this.closeSubDetailMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'No milestone'}</span>
                    </MenuItem>
                    {((Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [])).map((m, i) => (
                        <MenuItem key={`det-sub-ms-${i}`} onClick={() => { if (this.state.subDetailMenus.index != null) { this.updateEditSubIssueField(this.state.subDetailMenus.index, 'milestoneIndex', String(i)); } this.closeSubDetailMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{m?.name || m?.title || `Milestone ${i + 1}`}</span>
                        </MenuItem>
                    ))}
                </Menu>
                {/* Issue Detail Modal */}
                <Dialog open={this.state.isIssueDetailOpen} onClose={this.closeIssueDetail} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: 12 } }}>
                    <DialogTitle disableTypography style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: 'linear-gradient(90deg, #036dda 0%, #134e70 100%)',
                                color: '#ffffff',
                                padding: '12px 12px',
                                display: 'grid',
                                gridTemplateColumns: '28px 1fr 28px',
                                alignItems: 'center',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        >
                            <span />
                            <Typography variant="h6" style={{ color: '#ffffff', fontWeight: 700, textAlign: 'center' }}>Edit Issue</Typography>
                            <IconButton
                                aria-label="close"
                                onClick={this.closeIssueDetail}
                                style={{
                                    width: 28,
                                    height: 28,
                                    backgroundColor: '#ffffff',
                                    color: '#036dda',
                                    borderRadius: '50%',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                            >
                                <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ background: isDark ? '#1e1e1e' : '#f8fafc', paddingTop: 16, maxHeight: '75vh', overflowY: 'auto' }}>
                        {(() => {
                            const draft = this.state.editIssueDraft || {};
                            const milestones = Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [];
                            const status = draft.status || 'Backlog';
                            const priority = draft.priority || 'Medium';
                            const assigneeId = draft.assigneeId || '';
                            const milestoneIndex = draft.milestoneIndex;
                            const statusStyles = { background: '#64748b', color: '#fff' };
                            if (status === 'Backlog') statusStyles.background = '#64748b';
                            if (status === 'Todo') statusStyles.background = '#9ca3af';
                            if (status === 'In Progress') statusStyles.background = '#2563eb';
                            if (status === 'Done') statusStyles.background = '#16a34a';
                            if (status === 'Canceled') statusStyles.background = '#6b7280';
                            if (status === 'Duplicate') statusStyles.background = '#94a3b8';
                            const prioStyles = { background: '#475569', color: '#fff' };
                            if (priority === 'Low') prioStyles.background = '#16a34a';
                            if (priority === 'Medium') prioStyles.background = '#f59e0b';
                            if (priority === 'High') prioStyles.background = '#dc2626';
                            const assigneeName = assigneeId ? this.getUserName(assigneeId) : 'Assignee';
                            const milestoneName = milestoneIndex !== '' && milestoneIndex != null
                                ? (milestones[milestoneIndex]?.name || milestones[milestoneIndex]?.title || `Milestone ${Number(milestoneIndex) + 1}`)
                                : 'Milestone';
                            return (
                                <Box display="flex" flexDirection="column" gridGap={16}>
                                    <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                        <Typography variant="subtitle2" style={{ color: isDark ? '#e2e8f0' : '#111827', fontWeight: 700, marginBottom: 6 }}>Details</Typography>
                                        <Box display="flex" flexDirection="column" gridGap={12}>
                                            {this.state.editingIssueTitle ? (
                                                <TextField
                                                    label="Title"
                                                    variant="outlined"
                                                    value={draft.title || ''}
                                                    onChange={(e) => this.handleEditIssueChange('title', e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                />
                                            ) : (
                                                <Box
                                                    onClick={() => this.setState({ editingIssueTitle: true })}
                                                    style={{
                                                        border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                        borderRadius: 6,
                                                        padding: '10px 12px',
                                                        background: isDark ? '#1e1e1e' : '#ffffff',
                                                        cursor: 'text'
                                                    }}
                                                >
                                                    <Typography variant="body1" style={{ color: isDark ? '#e2e8f0' : '#111827' }}>
                                                        {draft.title || 'Click to add title'}
                                                    </Typography>
                                                </Box>
                                            )}
                                            <Box>
                                                <Typography variant="subtitle2" style={{ color: isDark ? '#94a3b8' : '#64748b', fontWeight: 600, marginBottom: 6 }}>Description</Typography>
                                                {this.state.editingIssueDescription ? (
                                                    <div style={{ border: isDark ? '1px solid #444' : '1px solid #ccc', padding: '5px', minHeight: '140px', borderRadius: '4px', background: isDark ? '#1e1e1e' : '#fff' }}>
                                                        <Editor
                                                            editorState={this.state.editIssueEditorState}
                                                            onEditorStateChange={this.handleEditIssueEditorChange}
                                                            handleKeyCommand={this.handleKeyCommand}
                                                            toolbar={{ options: ['inline', 'list', 'textAlign', 'link', 'emoji', 'remove', 'history'], inline: { inDropdown: true }, list: { inDropdown: true }, textAlign: { inDropdown: true }, link: { inDropdown: true } }}
                                                            placeholder="Edit description"
                                                        />
                                                    </div>
                                                ) : (
                                                    <Box
                                                        onClick={() => this.setState({ editingIssueDescription: true })}
                                                        style={{
                                                            border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                            borderRadius: 6,
                                                            padding: 10,
                                                            background: isDark ? '#1e1e1e' : '#ffffff',
                                                            minHeight: 56,
                                                            textAlign: 'left',
                                                            cursor: 'text'
                                                        }}
                                                    >
                                                        <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#111827', whiteSpace: 'pre-wrap' }}>
                                                            {draft.description ? '' : 'Click to add description'}
                                                        </Typography>
                                                        {draft.description && (
                                                            <div style={{ color: isDark ? '#e2e8f0' : '#111827' }}>
                                                                {this.renderDescriptionContent(draft.description)}
                                                            </div>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                    {/* Activity & Comments Tabs */}
                                    <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ marginBottom: 6 }}>
                                            <Typography variant="subtitle2" style={{ color: isDark ? '#ffffff' : '#111827', fontWeight: 700 }}>{(this.state.issueDetailActiveTab || 'activity') === 'activity' ? 'Activity' : 'Comments'}</Typography>
                                            <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, background: isDark ? '#444' : '#e5e7eb', borderRadius: 9999, padding: 4 }}>
                                                {(() => {
                                                    const active = this.state.issueDetailActiveTab || 'activity';
                                                    return (
                                                        <>
                                                            <Button
                                                                size="small"
                                                                disableElevation
                                                                aria-label="Show Activity"
                                                                onClick={() => this.setState({ issueDetailActiveTab: 'activity' })}
                                                                style={{
                                                                    textTransform: 'none',
                                                                    borderRadius: 9999,
                                                                    fontWeight: 700,
                                                                    padding: '4px 12px',
                                                                    backgroundColor: active === 'activity' ? '#036dda' : 'transparent',
                                                                    color: active === 'activity' ? '#ffffff' : (isDark ? '#e2e8f0' : '#111827'),
                                                                }}
                                                            >
                                                                Activity
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                disableElevation
                                                                aria-label="Show Comments"
                                                                onClick={() => this.setState({ issueDetailActiveTab: 'comments' })}
                                                                style={{
                                                                    textTransform: 'none',
                                                                    borderRadius: 9999,
                                                                    fontWeight: 700,
                                                                    padding: '4px 12px',
                                                                    backgroundColor: active === 'comments' ? '#036dda' : 'transparent',
                                                                    color: active === 'comments' ? '#ffffff' : (isDark ? '#e2e8f0' : '#111827'),
                                                                }}
                                                            >
                                                                Comments
                                                            </Button>
                                                        </>
                                                    );
                                                })()}
                                            </Box>
                                        </Box>
                                        {(() => {
                                            const items = Array.isArray(this.state.issueActivity) ? this.state.issueActivity : [];
                                            const activities = items.filter((it) => (it.kind || (it.action ? 'activity' : 'comment')) === 'activity');
                                            const comments = items.filter((it) => (it.kind || (it.action ? 'activity' : 'comment')) === 'comment');
                                            // Build threaded comments index
                                            const { roots, byParent } = this.buildCommentIndex(comments);
                                            // Prepare list based on active tab only, sort by date desc
                                            const activeTab = this.state.issueDetailActiveTab || 'activity';
                                            const merged = (activeTab === 'activity'
                                                ? activities.map((a) => ({ type: 'activity', item: a, created_at: a.created_at }))
                                                : roots.map((c) => ({ type: 'comment', item: c, created_at: c.created_at }))
                                            ).sort((a, b) => {
                                                const da = new Date(a.created_at || 0).getTime();
                                                const db = new Date(b.created_at || 0).getTime();
                                                return db - da;
                                            });
                                            if (merged.length === 0) {
                                                return (
                                                    <Typography variant="body2" style={{ color: '#64748b' }}>
                                                        {activeTab === 'activity' ? 'No activity yet' : 'No comments yet'}
                                                    </Typography>
                                                );
                                            }
                                            const showAllFlag = (activeTab === 'activity' ? this.state.issueShowAllActivities : this.state.issueShowAllComments);
                                            const visible = showAllFlag ? merged : merged.slice(0, 5);
                                            const showToggle = merged.length > 5;
                                            const renderIssueComment = (c) => {
                                                const cid = c.comment_id || c.id || c._id;
                                                const isEditing = (this.state.issueEditingCommentIds || {})[cid] === true;
                                                const replies = byParent[cid] || [];
                                                const showReplyBox = (this.state.issueShowReplies || {})[cid] === true;
                                                const showMore = (this.state.issueShowMoreReplies || {})[cid] === true;
                                                const visibleReplies = showMore ? replies : replies.slice(0, 1);
                                                const commenter = c.author || {};
                                                const cPhoto = this.getPhotoFromUser(commenter);
                                                const cInitials = this.getInitialsFromUser(commenter);
                                                return (
                                                    <Box key={`iss-cmt-${cid}`} mb={1.25} display="flex" alignItems="flex-start" gridGap={10}>
                                                        {cPhoto ? (
                                                            <img src={cPhoto} alt={this.getDisplayNameFromUser(commenter)} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                        ) : (
                                                            <Box style={{ width: 24, height: 24, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600 }}>{cInitials}</Box>
                                                        )}
                                                        <Box flex={1}>
                                                            <Box display="flex" alignItems="baseline" gridGap={8}>
                                                                <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#4c545f', fontWeight: 600 }}>{this.getDisplayNameFromUser(commenter)}</Typography>
                                                                <Typography variant="caption" style={{ color: isDark ? '#94a3b8' : '#64748b' }}>{this.formatDateDMYTime(c.created_at)}</Typography>
                                                            </Box>
                                                            {isEditing ? (
                                                                <Box>
                                                                    <Box
                                                                        style={{
                                                                            border: '2px solid #227aad',
                                                                            borderRadius: 6,
                                                                            padding: 8,
                                                                            background: isDark ? '#1e1e1e' : '#fff',
                                                                            minHeight: '56px',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'flex-start',
                                                                            width: '100%'
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            fullWidth
                                                                            variant="standard"
                                                                            InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                                            size="small"
                                                                            multiline
                                                                            rows={2}
                                                                            value={(this.state.issueEditCommentDrafts || {})[cid] || ''}
                                                                            onChange={(e) => this.setIssueEditCommentDraft(cid, e.target.value)}
                                                                            style={{ background: 'none' }}
                                                                        />
                                                                        {(() => {
                                                                            // Render newly selected file during edit (takes precedence)
                                                                            const selPreview = (this.state.issueEditingCommentFilePreviews || {})[cid] || null;
                                                                            const selFile = (this.state.issueEditingCommentFiles || {})[cid] || null;
                                                                            if (selFile) {
                                                                                const isImg = !!selPreview;
                                                                                return (
                                                                                    <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                        {isImg ? (
                                                                                            <>
                                                                                                <img src={selPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                                                                <span title="Remove" onClick={() => { const files = { ...(this.state.issueEditingCommentFiles || {}) }; const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const prev = previews[cid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[cid]; delete previews[cid]; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews }); }} style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                                                            </>
                                                                                        ) : (
                                                                                            <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                {(() => { const ext = this.getFileExtensionFromMeta(selFile.name, null, selFile.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(selFile.name, selFile.name, selFile.type)}</span>
                                                                                                <span title="Remove" onClick={() => { const files = { ...(this.state.issueEditingCommentFiles || {}) }; const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const prev = previews[cid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[cid]; delete previews[cid]; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews }); }} style={{ marginLeft: 6, color: '#555', cursor: 'pointer', borderRadius: '50%', border: '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                                                            </Box>
                                                                                        )}
                                                                                    </Box>
                                                                                );
                                                                            }
                                                                            const removed = (this.state.issueEditingCommentRemovedFile || {})[cid] === true;
                                                                            if (removed) return null;
                                                                            const href = c.file_url || c.fileUrl || null;
                                                                            const mime = c.file_mime || c.mime_type || '';
                                                                            if (!href) return null;
                                                                            const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                                            return (
                                                                                <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                    {isImage ? (
                                                                                        <>
                                                                                            <img src={href} alt={c.file_name || 'Attachment'} style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                                                            <span title="Remove" onClick={() => this.setState({ issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [cid]: true } })} style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff', position: 'relative', marginRight: 6 }}>
                                                                                            {(() => { const ext = this.getFileExtensionFromMeta(c.file_name, href, mime); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                            <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(c.file_name, href, mime)}</span>
                                                                                            <span title="Remove" onClick={() => this.setState({ issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [cid]: true } })} style={{ marginLeft: 6, color: isDark ? '#aaa' : '#555', cursor: 'pointer', borderRadius: '50%', border: isDark ? '1px solid #666' : '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            );
                                                                        })()}
                                                                    </Box>
                                                                    <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                                        <input id={`edit-attach-issue-${cid}`} type="file" style={{ display: 'none' }} onChange={(e) => { const f = (e && e.target && e.target.files && e.target.files[0]) || null; if (!f) { return; } const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const files = { ...(this.state.issueEditingCommentFiles || {}) }; files[cid] = f; previews[cid] = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews, issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [cid]: true } }); try { e.target.value = ''; } catch (_) { } }} />
                                                                        <Button size="small" onClick={() => this.triggerAttachmentInput(`edit-attach-issue-${cid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                                        <Button size="small" onClick={(e) => { this.setState({ issueShowEmojiForEdit: { ...(this.state.issueShowEmojiForEdit || {}), [cid]: true }, issueEditEmojiAnchorEls: { ...(this.state.issueEditEmojiAnchorEls || {}), [cid]: e.currentTarget }, activeIssueEditId: cid }); }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                                        <Button size="small" className="btn-cancel" onClick={() => this.cancelEditIssueActivityComment(cid)}>Cancel</Button>
                                                                        <Button size="small" className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.saveIssueActivityComment(cid)}>Save</Button>
                                                                    </Box>
                                                                    <Popover
                                                                        open={Boolean((this.state.issueShowEmojiForEdit || {})[cid])}
                                                                        anchorEl={(this.state.issueEditEmojiAnchorEls || {})[cid] || null}
                                                                        onClose={() => this.setState({ issueShowEmojiForEdit: { ...(this.state.issueShowEmojiForEdit || {}), [cid]: false }, activeIssueEditId: null })}
                                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                        PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                                    >
                                                                        {(() => {
                                                                            try {
                                                                                const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                                const onPick = (emojiData) => {
                                                                                    const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                                    const current = (this.state.issueEditCommentDrafts || {})[cid] || '';
                                                                                    this.setState({ issueEditCommentDrafts: { ...(this.state.issueEditCommentDrafts || {}), [cid]: current + emoji } });
                                                                                };
                                                                                return (
                                                                                    <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                                );
                                                                            } catch (_) { return null; }
                                                                        })()}
                                                                    </Popover>
                                                                </Box>
                                                            ) : (
                                                                <>
                                                                    <Box style={{ background: isDark ? '#1e1e1e' : '#ffffff', border: isDark ? '1px solid #333' : '1px solid #e2e8f0', borderRadius: 8, padding: 10, marginTop: 4 }}>
                                                                        <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f', textAlign: 'left' }}>{c.text || ''}</Typography>
                                                                        {(() => {
                                                                            const href = c.file_url || c.fileUrl || c.public_url || c.url || c.attachment_url || c.attachmentUrl || c.file || null;
                                                                            const mime = c.file_mime || c.mime_type || c.mime || '';
                                                                            if (!href) return null;
                                                                            const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                                            return (
                                                                                <Box mt={1} style={{ textAlign: 'left' }}>
                                                                                    {isImage ? (
                                                                                        <img
                                                                                            src={href}
                                                                                            alt={c.file_name || 'Attachment'}
                                                                                            style={{ maxWidth: '240px', maxHeight: '180px', borderRadius: 8, border: isDark ? '1px solid #444' : '1px solid #e2e8f0', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }}
                                                                                        />
                                                                                    ) : (
                                                                                        this.renderAttachmentChip(c.file_name, href, mime, () => this.openResourcePreview({ url: href, mime_type: mime, original_name: c.file_name || 'Attachment', _fromComment: true }))
                                                                                    )}
                                                                                </Box>
                                                                            );
                                                                        })()}
                                                                    </Box>
                                                                    <Box mt={0.5} display="flex" gridGap={8}>
                                                                        {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                            <Button size="small" style={{ color: '#1d4ed8', fontWeight: 600 }} onClick={() => this.replyToIssueComment(c)}>Reply</Button>
                                                                        )}
                                                                        {this.canEditIssueComment(c) && (
                                                                            <Button size="small" style={{ color: '#6b7280' }} onClick={() => this.startEditIssueActivityComment(cid, c.text)}>Edit</Button>
                                                                        )}
                                                                        {this.canEditIssueComment(c) && (
                                                                            <Button size="small" style={{ color: '#dc2626' }} onClick={() => this.deleteIssueActivityComment(cid)}>Delete</Button>
                                                                        )}
                                                                    </Box>
                                                                </>
                                                            )}

                                                            {showReplyBox && (
                                                                <Box mt={1} display="flex" alignItems="flex-start" gridGap={10}>
                                                                    {(() => {
                                                                        const currentUser = ls.get("user") || {};
                                                                        const currentUserPhoto = this.getPhotoFromUser(currentUser);
                                                                        if (currentUserPhoto) {
                                                                            return (
                                                                                <img src={currentUserPhoto} alt={this.getDisplayNameFromUser(currentUser)} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                                            );
                                                                        }
                                                                        return (
                                                                            <Box style={{ width: 24, height: 24, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600 }}>
                                                                                {this.getInitialsFromUser(currentUser)}
                                                                            </Box>
                                                                        );
                                                                    })()}
                                                                    <Box flex={1}>
                                                                        <Box
                                                                            style={{
                                                                                border: '2px solid #227aad',
                                                                                borderRadius: 6,
                                                                                padding: 8,
                                                                                background: isDark ? '#1e1e1e' : '#fff',
                                                                                minHeight: '56px',
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                alignItems: 'flex-start',
                                                                                width: '100%'
                                                                            }}
                                                                        >
                                                                            <TextField
                                                                                fullWidth
                                                                                placeholder="Write a reply..."
                                                                                variant="standard"
                                                                                InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                                                size="small"
                                                                                multiline
                                                                                rows={2}
                                                                                value={(this.state.issueReplyDrafts || {})[cid] || ''}
                                                                                onChange={(e) => this.setState({ issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [cid]: e.target.value } })}
                                                                                style={{ background: 'none' }}
                                                                            />
                                                                            {/* Attachment preview inside the input box */}
                                                                            {(() => {
                                                                                const previewUrl = (this.state.issueReplyFilePreviews || {})[cid] || null;
                                                                                const fileObj = (this.state.issueReplyFiles || {})[cid] || null;
                                                                                if (!previewUrl && (!fileObj || !fileObj.name)) return null;
                                                                                const isImage = previewUrl != null;
                                                                                return (
                                                                                    <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                        {isImage ? (
                                                                                            <>
                                                                                                <img
                                                                                                    src={previewUrl}
                                                                                                    alt="Preview"
                                                                                                    style={{
                                                                                                        maxWidth: '200px',
                                                                                                        maxHeight: '140px',
                                                                                                        borderRadius: 8,
                                                                                                        border: '1px solid #e5e7eb',
                                                                                                        objectFit: 'cover',
                                                                                                        display: 'block',
                                                                                                        marginLeft: 0,
                                                                                                        marginRight: 0
                                                                                                    }}
                                                                                                />
                                                                                                <span
                                                                                                    title="Remove"
                                                                                                    onClick={() => this.setIssueReplyFile(cid, null)}
                                                                                                    style={{
                                                                                                        position: 'absolute',
                                                                                                        top: 2,
                                                                                                        right: 2,
                                                                                                        background: isDark ? '#333' : '#fff',
                                                                                                        border: isDark ? '1px solid #555' : '1px solid #bbb',
                                                                                                        borderRadius: '50%',
                                                                                                        cursor: 'pointer',
                                                                                                        width: 22,
                                                                                                        height: 22,
                                                                                                        display: 'flex',
                                                                                                        alignItems: 'center',
                                                                                                        justifyContent: 'center',
                                                                                                        fontWeight: 700,
                                                                                                        fontSize: 15,
                                                                                                        color: isDark ? '#fff' : '#000'
                                                                                                    }}
                                                                                                >×</span>
                                                                                            </>
                                                                                        ) : (
                                                                                            <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                {(() => { const ext = this.getFileExtensionFromMeta(fileObj.name, null, fileObj.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(fileObj.name, fileObj.name, fileObj.type)}</span>
                                                                                                <span
                                                                                                    title="Remove"
                                                                                                    onClick={() => this.setIssueReplyFile(cid, null)}
                                                                                                    style={{
                                                                                                        marginLeft: 6,
                                                                                                        color: isDark ? '#aaa' : '#555',
                                                                                                        cursor: 'pointer',
                                                                                                        borderRadius: '50%',
                                                                                                        border: isDark ? '1px solid #666' : '1px solid #bbb',
                                                                                                        width: 18,
                                                                                                        height: 18,
                                                                                                        display: 'inline-flex',
                                                                                                        alignItems: 'center',
                                                                                                        justifyContent: 'center',
                                                                                                        fontWeight: 700,
                                                                                                        fontSize: 13
                                                                                                    }}
                                                                                                >×</span>
                                                                                            </Box>
                                                                                        )}
                                                                                    </Box>
                                                                                );
                                                                            })()}
                                                                        </Box>
                                                                        <Box display="flex" justifyContent="flex-end" mt={1}>
                                                                            <Box>
                                                                                <input id={`attach-issue-reply-${cid}`} type="file" style={{ display: 'none' }} onChange={(e) => this.onAttachToIssueComment(cid, e)} />
                                                                                <Button size="small" onClick={() => this.triggerAttachmentInput(`attach-issue-reply-${cid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                                                <Button size="small" onClick={(e) => {
                                                                                    this.setState({
                                                                                        showIssueEmojiForReply: { ...(this.state.showIssueEmojiForReply || {}), [cid]: true },
                                                                                        issueReplyEmojiAnchorEls: { ...(this.state.issueReplyEmojiAnchorEls || {}), [cid]: e.currentTarget },
                                                                                        activeIssueEmojiReplyParentId: cid
                                                                                    });
                                                                                }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                                                {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                                    <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.postIssueReply(cid)}>Reply</Button>
                                                                                )}
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            )}

                                                            <Popover
                                                                open={Boolean((this.state.showIssueEmojiForReply || {})[cid])}
                                                                anchorEl={(this.state.issueReplyEmojiAnchorEls || {})[cid] || null}
                                                                onClose={() => this.setState({ showIssueEmojiForReply: { ...(this.state.showIssueEmojiForReply || {}), [cid]: false }, activeIssueEmojiReplyParentId: null })}
                                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                            >
                                                                {(() => {
                                                                    try {
                                                                        const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                        const onPick = (emojiData) => {
                                                                            const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                            const current = (this.state.issueReplyDrafts || {})[cid] || '';
                                                                            this.setState({ issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [cid]: current + emoji } });
                                                                        };
                                                                        return (
                                                                            <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                        );
                                                                    } catch (_) { return null; }
                                                                })()}
                                                            </Popover>

                                                            {replies.length > 0 && (
                                                                <Box mt={1} style={{ marginLeft: 16, borderLeft: '2px solid #e2e8f0', paddingLeft: 12 }}>
                                                                    {visibleReplies.map((rc) => {
                                                                        const rcid = rc.comment_id || rc.id || rc._id;
                                                                        const rIsEditing = (this.state.issueEditingCommentIds || {})[rcid] === true;
                                                                        const rShowReplyBox = (this.state.issueShowReplies || {})[rcid] === true;
                                                                        return (
                                                                            <Box key={`iss-reply-${rcid}`} display="flex" alignItems="flex-start" gridGap={8} style={{ marginTop: 8 }}>
                                                                                {(() => {
                                                                                    const rPhoto = this.getPhotoFromUser(rc.author);
                                                                                    if (rPhoto) {
                                                                                        return (
                                                                                            <img src={rPhoto} alt={this.getDisplayNameFromUser(rc.author)} style={{ width: 20, height: 20, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                                                        );
                                                                                    }
                                                                                    return (
                                                                                        <Box style={{ width: 20, height: 20, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 600 }}>
                                                                                            {this.getInitialsFromUser(rc.author)}
                                                                                        </Box>
                                                                                    );
                                                                                })()}
                                                                                <Box flex={1}>
                                                                                    <Box display="flex" alignItems="baseline" gridGap={6}>
                                                                                        <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#4c545f', fontWeight: 600, fontSize: 13 }}>{this.getDisplayNameFromUser(rc.author)}</Typography>
                                                                                        <Typography variant="caption" style={{ color: isDark ? '#94a3b8' : '#64748b', fontSize: 11 }}>{this.formatDateDMYTime(rc.created_at)}</Typography>
                                                                                    </Box>
                                                                                    {rIsEditing ? (
                                                                                        <Box>
                                                                                            <Box
                                                                                                style={{
                                                                                                    border: '2px solid #227aad',
                                                                                                    borderRadius: 6,
                                                                                                    padding: 8,
                                                                                                    background: isDark ? '#1e1e1e' : '#fff',
                                                                                                    minHeight: '56px',
                                                                                                    display: 'flex',
                                                                                                    flexDirection: 'column',
                                                                                                    alignItems: 'flex-start',
                                                                                                    width: '100%'
                                                                                                }}
                                                                                            >
                                                                                                <TextField
                                                                                                    fullWidth
                                                                                                    placeholder="Edit reply..."
                                                                                                    variant="standard"
                                                                                                    InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                                                                    size="small"
                                                                                                    multiline
                                                                                                    rows={2}
                                                                                                    value={(this.state.issueEditCommentDrafts || {})[rcid] || ''}
                                                                                                    onChange={(e) => this.setIssueEditCommentDraft(rcid, e.target.value)}
                                                                                                    style={{ background: 'none' }}
                                                                                                />
                                                                                                {(() => {
                                                                                                    const selPreview = (this.state.issueEditingCommentFilePreviews || {})[rcid] || null;
                                                                                                    const selFile = (this.state.issueEditingCommentFiles || {})[rcid] || null;
                                                                                                    if (selFile) {
                                                                                                        const isImg = !!selPreview;
                                                                                                        return (
                                                                                                            <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                                                {isImg ? (
                                                                                                                    <>
                                                                                                                        <img src={selPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                                                                                        <span title="Remove" onClick={() => { const files = { ...(this.state.issueEditingCommentFiles || {}) }; const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const prev = previews[rcid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[rcid]; delete previews[rcid]; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews }); }} style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                                        {(() => { const ext = this.getFileExtensionFromMeta(selFile.name, null, selFile.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                                        <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(selFile.name, selFile.name, selFile.type)}</span>
                                                                                                                        <span title="Remove" onClick={() => { const files = { ...(this.state.issueEditingCommentFiles || {}) }; const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const prev = previews[rcid]; if (prev) { try { URL.revokeObjectURL(prev); } catch (_) { } } delete files[rcid]; delete previews[rcid]; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews }); }} style={{ marginLeft: 6, color: '#555', cursor: 'pointer', borderRadius: '50%', border: '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                                                                                    </Box>
                                                                                                                )}
                                                                                                            </Box>
                                                                                                        );
                                                                                                    }
                                                                                                    const removed = (this.state.issueEditingCommentRemovedFile || {})[rcid] === true;
                                                                                                    if (removed) return null;
                                                                                                    const href = rc.file_url || rc.fileUrl || null;
                                                                                                    const mime = rc.file_mime || rc.mime_type || '';
                                                                                                    if (!href) return null;
                                                                                                    const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                                                                    return (
                                                                                                        <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                                            {isImage ? (
                                                                                                                <>
                                                                                                                    <img src={href} alt={rc.file_name || 'Attachment'} style={{ maxWidth: '200px', maxHeight: '140px', borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }} />
                                                                                                                    <span title="Remove" onClick={() => this.setState({ issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [rcid]: true } })} style={{ position: 'absolute', top: 2, right: 2, background: '#fff', border: '1px solid #bbb', borderRadius: '50%', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 15 }}>×</span>
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <Box style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                                    {(() => { const ext = this.getFileExtensionFromMeta(rc.file_name, href, mime); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                                    <span style={{ fontSize: 12, color: '#374151' }}>{this.formatAttachmentLabel(rc.file_name, href, mime)}</span>
                                                                                                                    <span title="Remove" onClick={() => this.setState({ issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [rcid]: true } })} style={{ marginLeft: 6, color: '#555', cursor: 'pointer', borderRadius: '50%', border: '1px solid #bbb', width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13 }}>×</span>
                                                                                                                </Box>
                                                                                                            )}
                                                                                                        </Box>
                                                                                                    );
                                                                                                })()}
                                                                                            </Box>
                                                                                            <Box display="flex" justifyContent="flex-end" mt={1} gridGap={8}>
                                                                                                <input id={`edit-attach-issue-${rcid}`} type="file" style={{ display: 'none' }} onChange={(e) => { const f = (e && e.target && e.target.files && e.target.files[0]) || null; if (!f) { return; } const previews = { ...(this.state.issueEditingCommentFilePreviews || {}) }; const files = { ...(this.state.issueEditingCommentFiles || {}) }; files[rcid] = f; previews[rcid] = f.type && f.type.startsWith('image/') ? URL.createObjectURL(f) : null; this.setState({ issueEditingCommentFiles: files, issueEditingCommentFilePreviews: previews, issueEditingCommentRemovedFile: { ...(this.state.issueEditingCommentRemovedFile || {}), [rcid]: true } }); try { e.target.value = ''; } catch (_) { } }} />
                                                                                                <Button size="small" onClick={() => this.triggerAttachmentInput(`edit-attach-issue-${rcid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                                                                <Button size="small" onClick={(e) => { this.setState({ issueShowEmojiForEdit: { ...(this.state.issueShowEmojiForEdit || {}), [rcid]: true }, issueEditEmojiAnchorEls: { ...(this.state.issueEditEmojiAnchorEls || {}), [rcid]: e.currentTarget }, activeIssueEditId: rcid }); }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                                                                <Button size="small" className="btn-cancel" onClick={() => this.cancelEditIssueActivityComment(rcid)}>Cancel</Button>
                                                                                                <Button size="small" className="btn-success" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.saveIssueActivityComment(rcid)}>Save</Button>
                                                                                            </Box>
                                                                                            <Popover
                                                                                                open={Boolean((this.state.issueShowEmojiForEdit || {})[rcid])}
                                                                                                anchorEl={(this.state.issueEditEmojiAnchorEls || {})[rcid] || null}
                                                                                                onClose={() => this.setState({ issueShowEmojiForEdit: { ...(this.state.issueShowEmojiForEdit || {}), [rcid]: false }, activeIssueEditId: null })}
                                                                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                                                PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                                                            >
                                                                                                {(() => {
                                                                                                    try {
                                                                                                        const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                                                        const onPick = (emojiData) => {
                                                                                                            const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                                                            const current = (this.state.issueEditCommentDrafts || {})[rcid] || '';
                                                                                                            this.setState({ issueEditCommentDrafts: { ...(this.state.issueEditCommentDrafts || {}), [rcid]: current + emoji } });
                                                                                                        };
                                                                                                        return (
                                                                                                            <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                                                        );
                                                                                                    } catch (_) { return null; }
                                                                                                })()}
                                                                                            </Popover>
                                                                                        </Box>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Box style={{ background: isDark ? '#1e1e1e' : '#f8fafc', border: isDark ? '1px solid #333' : '1px solid #e2e8f0', borderRadius: 6, padding: 8, marginTop: 2 }}>
                                                                                                <Typography variant="body2" style={{ color: isDark ? '#d0d0d0' : '#4c545f', textAlign: 'left', fontSize: 13 }}>{rc.text}</Typography>
                                                                                                {(() => {
                                                                                                    const href = rc.file_url || rc.fileUrl || rc.public_url || rc.url || rc.attachment_url || rc.attachmentUrl || rc.file || null;
                                                                                                    const mime = rc.file_mime || rc.mime_type || rc.mime || '';
                                                                                                    if (!href) return null;
                                                                                                    const isImage = String(mime).startsWith('image/') || (typeof href === 'string' && href.toLowerCase().match(/\.(png|jpe?g|gif|webp|bmp|svg)$/));
                                                                                                    return (
                                                                                                        <Box mt={1} style={{ textAlign: 'left' }}>
                                                                                                            {isImage ? (
                                                                                                                <img
                                                                                                                    src={href}
                                                                                                                    alt={rc.file_name || 'Attachment'}
                                                                                                                    style={{ maxWidth: '240px', maxHeight: '180px', borderRadius: 8, border: '1px solid #e2e8f0', objectFit: 'cover', display: 'block', marginLeft: 0, marginRight: 0 }}
                                                                                                                />
                                                                                                            ) : (
                                                                                                                this.renderAttachmentChip(rc.file_name, href, mime, () => this.openResourcePreview({ url: href, mime_type: mime, original_name: rc.file_name || 'Attachment', _fromComment: true }))
                                                                                                            )}
                                                                                                        </Box>
                                                                                                    );
                                                                                                })()}
                                                                                            </Box>
                                                                                            <Box mt={0.5} display="flex" gridGap={8}>
                                                                                                {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                                                    <Button size="small" style={{ color: '#1d4ed8', fontWeight: 600 }} onClick={() => this.setState({ issueShowReplies: { ...(this.state.issueShowReplies || {}), [rcid]: !rShowReplyBox } })}>Reply</Button>
                                                                                                )}
                                                                                                {this.canEditIssueComment(rc) && (
                                                                                                    <Button size="small" style={{ color: '#6b7280' }} onClick={() => this.startEditIssueActivityComment(rcid, rc.text)}>Edit</Button>
                                                                                                )}
                                                                                                {this.canEditIssueComment(rc) && (
                                                                                                    <Button size="small" style={{ color: '#dc2626' }} onClick={() => this.deleteIssueActivityComment(rcid)}>Delete</Button>
                                                                                                )}
                                                                                            </Box>
                                                                                        </>
                                                                                    )}

                                                                                    {rShowReplyBox && (
                                                                                        <Box mt={1} display="flex" alignItems="flex-start" gridGap={10}>
                                                                                            {(() => {
                                                                                                const currentUser = ls.get("user") || {};
                                                                                                const currentUserPhoto = this.getPhotoFromUser(currentUser);
                                                                                                if (currentUserPhoto) {
                                                                                                    return (
                                                                                                        <img src={currentUserPhoto} alt={this.getDisplayNameFromUser(currentUser)} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                                                                    );
                                                                                                }
                                                                                                return (
                                                                                                    <Box style={{ width: 24, height: 24, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600 }}>
                                                                                                        {this.getInitialsFromUser(currentUser)}
                                                                                                    </Box>
                                                                                                );
                                                                                            })()}
                                                                                            <Box flex={1}>
                                                                                                <Box
                                                                                                    style={{
                                                                                                        border: '2px solid #227aad',
                                                                                                        borderRadius: 6,
                                                                                                        padding: 8,
                                                                                                        background: isDark ? '#1e1e1e' : '#fff',
                                                                                                        minHeight: '56px',
                                                                                                        display: 'flex',
                                                                                                        flexDirection: 'column',
                                                                                                        alignItems: 'flex-start',
                                                                                                        width: '100%'
                                                                                                    }}
                                                                                                >
                                                                                                    <TextField
                                                                                                        fullWidth
                                                                                                        placeholder="Write a reply..."
                                                                                                        variant="standard"
                                                                                                        InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                                                                        size="small"
                                                                                                        multiline
                                                                                                        rows={2}
                                                                                                        value={(this.state.issueReplyDrafts || {})[rcid] || ''}
                                                                                                        onChange={(e) => this.setState({ issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [rcid]: e.target.value } })}
                                                                                                        style={{ background: 'none' }}
                                                                                                    />
                                                                                                    {/* Attachment preview inside the input box */}
                                                                                                    {(() => {
                                                                                                        const previewUrl = (this.state.issueReplyFilePreviews || {})[rcid] || null;
                                                                                                        const fileObj = (this.state.issueReplyFiles || {})[rcid] || null;
                                                                                                        if (!previewUrl && (!fileObj || !fileObj.name)) return null;
                                                                                                        const isImage = previewUrl != null;
                                                                                                        return (
                                                                                                            <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                                                                {isImage ? (
                                                                                                                    <>
                                                                                                                        <img
                                                                                                                            src={previewUrl}
                                                                                                                            alt="Preview"
                                                                                                                            style={{
                                                                                                                                maxWidth: '200px',
                                                                                                                                maxHeight: '140px',
                                                                                                                                borderRadius: 8,
                                                                                                                                border: '1px solid #e5e7eb',
                                                                                                                                objectFit: 'cover',
                                                                                                                                display: 'block',
                                                                                                                                marginLeft: 0,
                                                                                                                                marginRight: 0
                                                                                                                            }}
                                                                                                                        />
                                                                                                                        <span
                                                                                                                            title="Remove"
                                                                                                                            onClick={() => this.setIssueReplyFile(rcid, null)}
                                                                                                                            style={{
                                                                                                                                position: 'absolute',
                                                                                                                                top: 2,
                                                                                                                                right: 2,
                                                                                                                                background: isDark ? '#333' : '#fff',
                                                                                                                                border: isDark ? '1px solid #555' : '1px solid #bbb',
                                                                                                                                borderRadius: '50%',
                                                                                                                                cursor: 'pointer',
                                                                                                                                width: 22,
                                                                                                                                height: 22,
                                                                                                                                display: 'flex',
                                                                                                                                alignItems: 'center',
                                                                                                                                justifyContent: 'center',
                                                                                                                                fontWeight: 700,
                                                                                                                                fontSize: 15,
                                                                                                                                color: isDark ? '#fff' : '#000'
                                                                                                                            }}
                                                                                                                        >×</span>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff', position: 'relative', marginRight: 6 }}>
                                                                                                                        {(() => { const ext = this.getFileExtensionFromMeta(fileObj.name, null, fileObj.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                                                                        <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(fileObj.name, fileObj.name, fileObj.type)}</span>
                                                                                                                        <span
                                                                                                                            title="Remove"
                                                                                                                            onClick={() => this.setIssueReplyFile(rcid, null)}
                                                                                                                            style={{
                                                                                                                                marginLeft: 6,
                                                                                                                                color: isDark ? '#aaa' : '#555',
                                                                                                                                cursor: 'pointer',
                                                                                                                                borderRadius: '50%',
                                                                                                                                border: isDark ? '1px solid #666' : '1px solid #bbb',
                                                                                                                                width: 18,
                                                                                                                                height: 18,
                                                                                                                                display: 'inline-flex',
                                                                                                                                alignItems: 'center',
                                                                                                                                justifyContent: 'center',
                                                                                                                                fontWeight: 700,
                                                                                                                                fontSize: 13
                                                                                                                            }}
                                                                                                                        >×</span>
                                                                                                                    </Box>
                                                                                                                )}
                                                                                                            </Box>
                                                                                                        );
                                                                                                    })()}
                                                                                                </Box>
                                                                                                <Box display="flex" justifyContent="flex-end" mt={1}>
                                                                                                    <Box>
                                                                                                        <input id={`attach-issue-reply-${rcid}`} type="file" style={{ display: 'none' }} onChange={(e) => this.onAttachToIssueComment(rcid, e)} />
                                                                                                        <Button size="small" onClick={() => this.triggerAttachmentInput(`attach-issue-reply-${rcid}`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                                                                        <Button size="small" onClick={(e) => {
                                                                                                            this.setState({
                                                                                                                showIssueEmojiForReply: { ...(this.state.showIssueEmojiForReply || {}), [rcid]: true },
                                                                                                                issueReplyEmojiAnchorEls: { ...(this.state.issueReplyEmojiAnchorEls || {}), [rcid]: e.currentTarget },
                                                                                                                activeIssueEmojiReplyParentId: rcid
                                                                                                            });
                                                                                                        }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                                                                        {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                                                                            <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={() => this.postIssueReply(rcid)}>Reply</Button>
                                                                                                        )}
                                                                                                    </Box>
                                                                                                </Box>
                                                                                                <Popover
                                                                                                    open={Boolean((this.state.showIssueEmojiForReply || {})[rcid])}
                                                                                                    anchorEl={(this.state.issueReplyEmojiAnchorEls || {})[rcid] || null}
                                                                                                    onClose={() => this.setState({ showIssueEmojiForReply: { ...(this.state.showIssueEmojiForReply || {}), [rcid]: false }, activeIssueEmojiReplyParentId: null })}
                                                                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                                                    PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                                                                >
                                                                                                    {(() => {
                                                                                                        try {
                                                                                                            const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                                                                            const onPick = (emojiData) => {
                                                                                                                const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                                                                const current = (this.state.issueReplyDrafts || {})[rcid] || '';
                                                                                                                this.setState({ issueReplyDrafts: { ...(this.state.issueReplyDrafts || {}), [rcid]: current + emoji } });
                                                                                                            };
                                                                                                            return (
                                                                                                                <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                                                                            );
                                                                                                        } catch (_) { return null; }
                                                                                                    })()}
                                                                                                </Popover>
                                                                                            </Box>
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            </Box>
                                                                        );
                                                                    })}
                                                                    {replies.length > 1 && (
                                                                        <Box mt={1}>
                                                                            <Button size="small" onClick={() => this.setState({ issueShowMoreReplies: { ...(this.state.issueShowMoreReplies || {}), [cid]: !showMore } })} style={{ fontSize: 11, textTransform: 'none', color: '#1d4ed8' }}>
                                                                                {showMore ? 'Hide replies' : `Show ${replies.length - 1} more repl${replies.length - 1 === 1 ? 'y' : 'ies'}`}
                                                                            </Button>
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                );
                                            };
                                            return (
                                                <>
                                                    {visible.map((entry, idx) => {
                                                        if (entry.type === 'activity') {
                                                            const it = entry.item;
                                                            const actor = it.author || it.actor || {};
                                                            const photo = this.getPhotoFromUser(actor);
                                                            const initials = this.getInitialsFromUser(actor);
                                                            const msg = it.action === 'commented'
                                                                ? 'commented'
                                                                : (it.message || this.getActivityMessage({ action: it.action, entity_type: 'issue', changes: it.changes, author: actor }));
                                                            return (
                                                                <Box key={`iss-act-${it.id || idx}`} mb={1.25} display="flex" alignItems="flex-start" gridGap={10}>
                                                                    {photo ? (
                                                                        <img
                                                                            src={photo}
                                                                            alt={this.getDisplayNameFromUser(actor)}
                                                                            style={{
                                                                                width: 24,
                                                                                height: 24,
                                                                                borderRadius: '50%',
                                                                                objectFit: 'cover',
                                                                                border: '1px solid #cbd5e1'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Box
                                                                            style={{
                                                                                width: 24,
                                                                                height: 24,
                                                                                borderRadius: '50%',
                                                                                background: '#e2e8f0',
                                                                                color: '#4c545f',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontSize: 10,
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            {initials}
                                                                        </Box>
                                                                    )}

                                                                    <Box flex={1}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            style={{
                                                                                color: isDark ? '#ffffff' : '#4c545f'
                                                                            }}
                                                                        >
                                                                            <strong>{this.getDisplayNameFromUser(actor)}</strong> {msg}
                                                                        </Typography>

                                                                        <Typography
                                                                            variant="caption"
                                                                            style={{
                                                                                color: isDark ? '#ffffff' : '#64748b'
                                                                            }}
                                                                        >
                                                                            {this.formatDateDMYTime(it.created_at)}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>

                                                            );
                                                        }
                                                        // comment entry
                                                        return (
                                                            <Box key={`iss-cmt-root-${entry.item.comment_id || entry.item.id || idx}`}>
                                                                {renderIssueComment(entry.item)}
                                                            </Box>
                                                        );
                                                    })}
                                                    {showToggle ? (
                                                        <Box mt={1} textAlign="center">
                                                            <Button
                                                                variant="outlined"
                                                                onClick={() => this.setState(
                                                                    this.state.issueDetailActiveTab === 'activity'
                                                                        ? { issueShowAllActivities: !this.state.issueShowAllActivities }
                                                                        : { issueShowAllComments: !this.state.issueShowAllComments }
                                                                )}
                                                                style={{
                                                                    borderRadius: 8,
                                                                    textTransform: 'none',
                                                                    fontWeight: 600,
                                                                    borderColor: '#036dda',
                                                                    color: '#036dda'
                                                                }}
                                                            >
                                                                {(this.state.issueDetailActiveTab === 'activity'
                                                                    ? (this.state.issueShowAllActivities ? 'Show less' : `Show ${Math.max(0, merged.length - 5)} more activities`)
                                                                    : (this.state.issueShowAllComments ? 'Show less' : `Show ${Math.max(0, merged.length - 5)} more comments`)
                                                                )}
                                                            </Button>
                                                        </Box>
                                                    ) : null}
                                                </>
                                            );
                                        })()}
                                    </Box>
                                    {/* Issue Comment box */}
                                    <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                        <Typography variant="subtitle2" style={{ color: isDark ? '#e2e8f0' : '#111827', fontWeight: 700, marginBottom: 6 }}>Leave a comment</Typography>
                                        <Box display="flex" alignItems="flex-start" gridGap={10}>
                                            {(() => {
                                                const currentUser = ls.get("user") || {};
                                                const currentUserPhoto = this.getPhotoFromUser(currentUser);
                                                if (currentUserPhoto) {
                                                    return (
                                                        <img src={currentUserPhoto} alt={this.getDisplayNameFromUser(currentUser)} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                                    );
                                                }
                                                return (
                                                    <Box style={{ width: 24, height: 24, borderRadius: '50%', background: isDark ? '#333' : '#e2e8f0', color: isDark ? '#ddd' : '#4c545f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 600 }}>
                                                        {this.getInitialsFromUser(currentUser)}
                                                    </Box>
                                                );
                                            })()}
                                            <Box flex={1}>
                                                <Box display="flex" alignItems="flex-start" width="100%" style={{ background: isDark ? '#2d2d2d' : '#fff' }}>
                                                    <Box
                                                        style={{
                                                            border: '2px solid #227aad',
                                                            borderRadius: 6,
                                                            padding: 8,
                                                            background: isDark ? '#1e1e1e' : '#fff',
                                                            minHeight: '56px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-start',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <TextField
                                                            fullWidth
                                                            placeholder="Write a comment..."
                                                            variant="standard"
                                                            InputProps={{ disableUnderline: true, style: { fontSize: 15, color: isDark ? '#fff' : 'inherit' } }}
                                                            size="small"
                                                            multiline
                                                            rows={2}
                                                            value={this.state.issueCommentDraft}
                                                            onChange={(e) => this.setState({ issueCommentDraft: e.target.value })}
                                                            style={{ background: 'none' }}
                                                        />
                                                        {(() => {
                                                            const previewUrl = this.state.issueRootFilePreview || null;
                                                            const fileObj = this.state.issueRootFile || null;
                                                            if (!previewUrl && (!fileObj || !fileObj.name)) return null;
                                                            const isImage = previewUrl != null;
                                                            return (
                                                                <Box mt={1} mb={1} style={{ textAlign: 'left', position: 'relative', display: 'inline-block' }}>
                                                                    {isImage ? (
                                                                        <>
                                                                            <img
                                                                                src={previewUrl}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: '200px',
                                                                                    maxHeight: '140px',
                                                                                    borderRadius: 8,
                                                                                    border: '1px solid #e5e7eb',
                                                                                    objectFit: 'cover',
                                                                                    display: 'block',
                                                                                    marginLeft: 0,
                                                                                    marginRight: 0
                                                                                }}
                                                                            />
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={() => {
                                                                                    this.setIssueRootFile(null);
                                                                                }}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: -8,
                                                                                    right: -8,
                                                                                    background: '#ef4444',
                                                                                    color: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    cursor: 'pointer',
                                                                                    fontWeight: 700,
                                                                                    fontSize: 15
                                                                                }}
                                                                            >×</span>
                                                                        </>
                                                                    ) : (
                                                                        <Box style={{ display: 'inline-flex', alignItems: 'center', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 12, padding: '6px 10px', background: isDark ? '#2d2d2d' : '#fff', position: 'relative', marginRight: 6 }}>
                                                                            {(() => { const ext = this.getFileExtensionFromMeta(fileObj.name, null, fileObj.type); const meta = this.getAttachmentIconMeta(ext); return (<i className={meta.cls} style={{ fontSize: 16, color: meta.color, marginRight: 8 }} />); })()}
                                                                            <span style={{ fontSize: 12, color: isDark ? '#ccc' : '#374151' }}>{this.formatAttachmentLabel(fileObj.name, fileObj.name, fileObj.type)}</span>
                                                                            <span
                                                                                title="Remove"
                                                                                onClick={() => {
                                                                                    this.setIssueRootFile(null);
                                                                                }}
                                                                                style={{
                                                                                    marginLeft: 6,
                                                                                    color: isDark ? '#aaa' : '#555',
                                                                                    cursor: 'pointer',
                                                                                    borderRadius: '50%',
                                                                                    border: isDark ? '1px solid #666' : '1px solid #bbb',
                                                                                    width: 18,
                                                                                    height: 18,
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontWeight: 700,
                                                                                    fontSize: 13
                                                                                }}
                                                                            >×</span>
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            );
                                                        })()}
                                                    </Box>
                                                </Box>
                                                <Box display="flex" justifyContent="flex-end" mt={1}>
                                                    <Box>
                                                        <input id={`attach-issue-root`} type="file" style={{ display: 'none' }} onChange={(e) => this.onAttachToIssueComment(null, e)} />
                                                        <Button size="small" onClick={() => this.triggerAttachmentInput(`attach-issue-root`)} startIcon={<AttachFileIcon />} style={{ textTransform: 'none' }}>Attach</Button>
                                                        <Button size="small" onClick={(e) => {
                                                            this.setState({ showIssueEmojiRoot: true, issueEmojiRootAnchorEl: e.currentTarget, activeIssueEmojiRoot: true });
                                                        }} style={{ textTransform: 'none' }}>😀 Emoji</Button>
                                                        {(this.canEditAllOverview() || this.canEditLimitedOverview()) && (
                                                            <Button size="small" variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }} onClick={this.postIssueComment}>Reply</Button>
                                                        )}
                                                    </Box>
                                                </Box>
                                                <Popover
                                                    open={Boolean(this.state.showIssueEmojiRoot)}
                                                    anchorEl={this.state.issueEmojiRootAnchorEl || null}
                                                    onClose={() => this.setState({ showIssueEmojiRoot: false, activeIssueEmojiRoot: false })}
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                    PaperProps={{ style: { zIndex: 3000, padding: 8 } }}
                                                >
                                                    {(() => {
                                                        try {
                                                            const Picker = require('emoji-picker-react').default || require('emoji-picker-react');
                                                            const onPick = (emojiData) => {
                                                                const emoji = emojiData?.emoji || emojiData?.native || '';
                                                                const current = this.state.issueCommentDraft || '';
                                                                this.setState({ issueCommentDraft: current + emoji });
                                                            };
                                                            return (
                                                                <Picker onEmojiClick={(arg1, arg2) => { const data = (arg1 && (arg1.emoji || arg1.native)) ? arg1 : arg2; if (data) onPick(data); }} searchDisabled={false} height="350px" width="310px" lazyLoadEmojis theme={isDark ? 'dark' : 'light'} />
                                                            );
                                                        } catch (_) { return null; }
                                                    })()}
                                                </Popover>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                        <Typography variant="subtitle2" style={{ color: isDark ? '#e2e8f0' : '#111827', fontWeight: 700, marginBottom: 6 }}>Properties</Typography>
                                        <Box display="flex" flexWrap="wrap" gridGap={8}>
                                            <Tooltip title={`Status: ${status}`}>
                                                <Chip size="small" label={status} onClick={(e) => this.openDetailMenu('status', e)} style={{ ...statusStyles, cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Priority: ${priority}`}>
                                                <Chip size="small" label={priority} onClick={(e) => this.openDetailMenu('priority', e)} style={{ ...prioStyles, cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Assignee`}>
                                                <Chip size="small" label={assigneeName} onClick={(e) => this.openDetailMenu('assignee', e)} style={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                            <Tooltip title={`Milestone`}>
                                                <Chip size="small" label={milestoneName} onClick={(e) => this.openDetailMenu('milestone', e)} style={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                    <Box style={{ background: isDark ? '#2d2d2d' : '#ffffff', border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 10, padding: 12 }}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                            <Typography variant="subtitle2" style={{ color: isDark ? '#e2e8f0' : '#111827', fontWeight: 700 }}>Sub-issues</Typography>
                                            <Button size="small" variant="outlined" onClick={this.addEditSubIssue}>Add sub-issue</Button>
                                        </Box>
                                        <Box display="flex" flexDirection="column" gridGap={12}>
                                            {(Array.isArray(draft.subIssues) ? draft.subIssues : []).map((s, i) => {
                                                const sStatus = s.status || 'Backlog';
                                                const sPriority = s.priority || 'Medium';
                                                const sAssigneeId = s.assigneeId || '';
                                                const sMilestoneIndex = s.milestoneIndex;
                                                const sStatusStyles = { background: '#64748b', color: '#fff' };
                                                if (sStatus === 'Backlog') sStatusStyles.background = '#64748b';
                                                if (sStatus === 'Todo') sStatusStyles.background = '#9ca3af';
                                                if (sStatus === 'In Progress') sStatusStyles.background = '#2563eb';
                                                if (sStatus === 'Done') sStatusStyles.background = '#16a34a';
                                                if (sStatus === 'Canceled') sStatusStyles.background = '#6b7280';
                                                if (sStatus === 'Duplicate') sStatusStyles.background = '#94a3b8';
                                                const sPrioStyles = { background: '#475569', color: '#fff' };
                                                if (sPriority === 'Low') sPrioStyles.background = '#16a34a';
                                                if (sPriority === 'Medium') sPrioStyles.background = '#f59e0b';
                                                if (sPriority === 'High') sPrioStyles.background = '#dc2626';
                                                const sAssigneeName = sAssigneeId ? this.getUserName(sAssigneeId) : 'Assignee';
                                                const sMilestoneName = sMilestoneIndex !== '' && sMilestoneIndex != null
                                                    ? (milestones[sMilestoneIndex]?.name || milestones[sMilestoneIndex]?.title || `Milestone ${Number(sMilestoneIndex) + 1}`)
                                                    : 'Milestone';
                                                return (
                                                    <Box key={`sub-edit-${i}`} style={{ border: isDark ? '1px solid #444' : '1px solid #e5e7eb', borderRadius: 8, padding: 12, background: isDark ? '#1e1e1e' : '#ffffff' }}>
                                                        <Box display="flex" alignItems="center" gridGap={8}>
                                                            {(this.state.editingEditSubIssueTitles || {})[String(i)] ? (
                                                                <TextField
                                                                    placeholder={`Sub-issue ${i + 1}`}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    value={s.title || ''}
                                                                    onChange={(e) => this.updateEditSubIssueField(i, 'title', e.target.value)}
                                                                />
                                                            ) : (
                                                                <Box
                                                                    onClick={() => this.setState({ editingEditSubIssueTitles: { ...(this.state.editingEditSubIssueTitles || {}), [String(i)]: true } })}
                                                                    style={{
                                                                        border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                                        borderRadius: 6,
                                                                        padding: '8px 10px',
                                                                        background: isDark ? '#2d2d2d' : '#ffffff',
                                                                        cursor: 'text',
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#111827' }}>
                                                                        {s.title || `Click to add sub-issue ${i + 1} title`}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                            <Button size="small" onClick={() => this.removeEditSubIssue(i)}>Remove</Button>
                                                        </Box>
                                                        <Box mt={1} />
                                                        <Box>
                                                            <Typography variant="caption" style={{ color: '#64748b' }}>Description</Typography>
                                                            {(this.state.editingEditSubIssueDescriptions || {})[String(i)] ? (
                                                                <div style={{ border: isDark ? '1px solid #444' : '1px solid #e5e7eb', padding: 5, minHeight: 100, borderRadius: 6, background: isDark ? '#2d2d2d' : '#fff' }}>
                                                                    <Editor
                                                                        editorState={(this.state.editSubIssueEditorStates || {})[String(i)] || EditorState.createEmpty()}
                                                                        onEditorStateChange={(st) => this.handleEditSubIssueEditorChange(i, st)}
                                                                        handleKeyCommand={this.handleKeyCommand}
                                                                        toolbar={{ options: ['inline', 'list', 'emoji', 'remove', 'history'], inline: { inDropdown: true }, list: { inDropdown: true }, emoji: { popupClassName: 'editor-popup-fix' } }}
                                                                        placeholder="Add description..."
                                                                        popupClassName="editor-popup-fix"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <Box
                                                                    onClick={() => this.setState({ editingEditSubIssueDescriptions: { ...(this.state.editingEditSubIssueDescriptions || {}), [String(i)]: true } })}
                                                                    style={{
                                                                        border: isDark ? '1px dashed #555' : '1px dashed #cbd5e1',
                                                                        borderRadius: 6,
                                                                        padding: 10,
                                                                        background: isDark ? '#2d2d2d' : '#ffffff',
                                                                        minHeight: 56,
                                                                        textAlign: 'left',
                                                                        cursor: 'text'
                                                                    }}
                                                                >
                                                                    {(() => {
                                                                        const st = (this.state.editSubIssueEditorStates || {})[String(i)] || EditorState.createEmpty();
                                                                        const raw = convertToRaw(st.getCurrentContent());
                                                                        const html = draftToHtml(raw);
                                                                        const hasContent = (raw.blocks || []).some(b => b.text && b.text.trim().length > 0);
                                                                        if (!hasContent) return (
                                                                            <Typography variant="body2" style={{ color: isDark ? '#e2e8f0' : '#111827' }}>Click to add description</Typography>
                                                                        );
                                                                        return (
                                                                            <div style={{ color: isDark ? '#e2e8f0' : '#111827' }}>{parse(html)}</div>
                                                                        );
                                                                    })()}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                        <Box mt={1} display="flex" flexWrap="wrap" gridGap={8} alignItems="center">
                                                            <Tooltip title={`Status: ${sStatus}`}>
                                                                <Chip label={sStatus} size="small" onClick={(e) => this.openSubDetailMenu('status', i, e)} style={{ ...sStatusStyles, cursor: 'pointer' }} />
                                                            </Tooltip>
                                                            <Tooltip title={`Priority: ${sPriority}`}>
                                                                <Chip label={sPriority} size="small" onClick={(e) => this.openSubDetailMenu('priority', i, e)} style={{ ...sPrioStyles, cursor: 'pointer' }} />
                                                            </Tooltip>
                                                            <Tooltip title={`Assignee`}>
                                                                <Chip label={sAssigneeName} size="small" onClick={(e) => this.openSubDetailMenu('assignee', i, e)} style={{ cursor: 'pointer' }} />
                                                            </Tooltip>
                                                            <Tooltip title={`Milestone`}>
                                                                <Chip label={sMilestoneName} size="small" onClick={(e) => this.openSubDetailMenu('milestone', i, e)} style={{ cursor: 'pointer' }} />
                                                            </Tooltip>
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                </Box>
                            );
                        })()}
                    </DialogContent>
                    <DialogActions style={{ background: isDark ? '#1e1e1e' : '#f8fafc', padding: '10px 16px' }}>
                        <Button className="btn-cancel" onClick={this.closeIssueDetail}>Cancel</Button>
                        <Button className="btn-success" onClick={this.saveIssueDetail} variant="contained" style={{ backgroundColor: '#036dda', color: '#fff' }}>Save</Button>
                    </DialogActions>
                </Dialog>
                {/* Sub-issue Menus */}
                <Menu
                    anchorEl={this.state.subIssueMenus.statusAnchor}
                    open={Boolean(this.state.subIssueMenus.statusAnchor)}
                    onClose={this.closeSubIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Backlog', 'Todo', 'In Progress', 'Done', 'Canceled', 'Duplicate'].map((opt) => (
                        <MenuItem key={`sub-status-${opt}`} onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'status', opt); } this.closeSubIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.subIssueMenus.priorityAnchor}
                    open={Boolean(this.state.subIssueMenus.priorityAnchor)}
                    onClose={this.closeSubIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Low', 'Medium', 'High'].map((opt) => (
                        <MenuItem key={`sub-prio-${opt}`} onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'priority', opt); } this.closeSubIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.subIssueMenus.assigneeAnchor}
                    open={Boolean(this.state.subIssueMenus.assigneeAnchor)}
                    onClose={this.closeSubIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {(this.state.allUsers || []).map((u) => (
                        <MenuItem key={`sub-assignee-${u.id}`} onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'assigneeId', u.id); } this.closeSubIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)}</span>
                        </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'assigneeId', ''); } this.closeSubIssueMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'Unassigned'}</span>
                    </MenuItem>
                </Menu>
                <Menu
                    anchorEl={this.state.subIssueMenus.milestoneAnchor}
                    open={Boolean(this.state.subIssueMenus.milestoneAnchor)}
                    onClose={this.closeSubIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    <MenuItem onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'milestoneIndex', ''); } this.closeSubIssueMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'No milestone'}</span>
                    </MenuItem>
                    {((Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [])).map((m, i) => (
                        <MenuItem key={`det-sub-ms-${i}`} onClick={() => { if (this.state.subIssueMenus.index != null) { this.updateSubIssueField(this.state.subIssueMenus.index, 'milestoneIndex', String(i)); } this.closeSubIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{m?.name || m?.title || `Milestone ${i + 1}`}</span>
                        </MenuItem>
                    ))}
                </Menu>
                {/* Issue Menus for chips */}
                <Menu
                    anchorEl={this.state.issueMenus.priorityAnchor}
                    open={Boolean(this.state.issueMenus.priorityAnchor)}
                    onClose={this.closeIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 200, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {['Low', 'Medium', 'High'].map((opt) => (
                        <MenuItem key={`prio-${opt}`} onClick={() => { this.handleIssueDraftChange('priority', opt); this.closeIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{opt}</span>
                        </MenuItem>
                    ))}
                </Menu>
                <Menu
                    anchorEl={this.state.issueMenus.assigneeAnchor}
                    open={Boolean(this.state.issueMenus.assigneeAnchor)}
                    onClose={this.closeIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    {(this.state.allUsers || []).map((u) => (
                        <MenuItem key={`assignee-${u.id}`} onClick={() => { this.handleIssueDraftChange('assigneeId', u.id); this.closeIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : (u.name || u.email || `User ${u.id}`)}</span>
                        </MenuItem>
                    ))}
                    <Divider />
                    <MenuItem onClick={() => { this.handleIssueDraftChange('assigneeId', ''); this.closeIssueMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'Unassigned'}</span>
                    </MenuItem>
                </Menu>
                <Menu
                    anchorEl={this.state.issueMenus.milestoneAnchor}
                    open={Boolean(this.state.issueMenus.milestoneAnchor)}
                    onClose={this.closeIssueMenus}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    disablePortal={false}
                    PaperProps={{ style: { minWidth: 240, backgroundColor: isDark ? '#1e1e1e' : '#ffffff', color: isDark ? '#e2e8f0' : '#1a202c' } }}
                >
                    <MenuItem onClick={() => { this.handleIssueDraftChange('milestoneIndex', ''); this.closeIssueMenus(); }}>
                        <span style={{ whiteSpace: 'nowrap' }}>{'No milestone'}</span>
                    </MenuItem>
                    {((Array.isArray((this.state.project || {}).milestones) ? this.state.project.milestones : [])).map((m, i) => (
                        <MenuItem key={`ms-menu-${i}`} onClick={() => { this.handleIssueDraftChange('milestoneIndex', String(i)); this.closeIssueMenus(); }}>
                            <span style={{ whiteSpace: 'nowrap' }}>{m?.name || m?.title || `Milestone ${i + 1}`}</span>
                        </MenuItem>
                    ))}
                </Menu>
            </div >
        );
    }

    setCommentDraftFile(id, file) {
        // Remove or set file and preview for overview comment
        const nextFiles = { ...(this.state.commentFiles || {}) };
        const nextPreviews = { ...(this.state.commentFilePreviews || {}) };
        if (!file) {
            delete nextFiles[id];
            delete nextPreviews[id];
        } else {
            nextFiles[id] = file;
            nextPreviews[id] = file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
        }
        this.setState({ commentFiles: nextFiles, commentFilePreviews: nextPreviews });
    }

    setReplyFile(parentId, file) {
        // Remove or set file and preview for overview/issue reply
        const nextFiles = { ...(this.state.replyFiles || {}) };
        const nextPreviews = { ...(this.state.replyFilePreviews || {}) };
        if (!file) {
            delete nextFiles[parentId];
            delete nextPreviews[parentId];
        } else {
            nextFiles[parentId] = file;
            nextPreviews[parentId] = file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
        }
        this.setState({ replyFiles: nextFiles, replyFilePreviews: nextPreviews });
    }

    setIssueRootFile(file) {
        // Remove or set file and preview for issue root comment
        if (!file) {
            this.setState({ issueRootFile: null, issueRootFilePreview: null });
        } else {
            let previewUrl = null;
            if (file.type && file.type.startsWith('image/')) previewUrl = URL.createObjectURL(file);
            this.setState({ issueRootFile: file, issueRootFilePreview: previewUrl });
        }
    }

    setIssueReplyFile(parentId, file) {
        const nextFiles = { ...(this.state.issueReplyFiles || {}) };
        const nextPreviews = { ...(this.state.issueReplyFilePreviews || {}) };
        if (!file) {
            delete nextFiles[parentId];
            delete nextPreviews[parentId];
        } else {
            nextFiles[parentId] = file;
            nextPreviews[parentId] = file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : null;
        }
        this.setState({ issueReplyFiles: nextFiles, issueReplyFilePreviews: nextPreviews });
    }
}

export default ProjectDetail;



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}
